import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import { SettingsContext as SettingsContext$1, useIsMobile, Tooltip, Icon, bem, Tabs, Modal, Button, useIsTablet, Money, Dropdown, ButtonGroup, Divider } from "@distribusion/owl-frontend-ui";
import camelCase from "camelcase";
import { trim, sumBy, uniqBy, find, reverse, clamp, uniq, sortBy } from "lodash-es";
import { createContext, useContext, useCallback, useMemo, useRef, useState, useEffect } from "react";
import { useTranslation, Trans } from "react-i18next";
import currency from "currency.js";
import * as fns from "date-fns";
import * as fnsLocales from "date-fns/locale";
import * as fnsTz from "date-fns-tz";
import { toNestedObject as toNestedObject$1 } from "@distribusion/alien_utils";
import { stringify } from "qs";
import { useQuery } from "react-query";
import { Link } from "react-router-dom";
import { useQuery as useQuery$1 } from "@tanstack/react-query";
const EMPTY_API_URL = {
  url: "",
  oldUrl: ""
};
const DEFAULT_SETTINGS = {
  locale: "en",
  newBackendEndpoints: [],
  maxPassengers: Infinity,
  currency: "EUR",
  topCurrencies: [],
  seatAncillaryAsSelection: false,
  retailerPartnerNumber: 222222,
  discounts: { marketingCarrierCodes: [] },
  userInterface: { date: { textInputEnabled: false }, time: { textInputEnabled: false } },
  showPrice: true,
  showFareFeatures: false,
  carrierLogo: { enabled: true, source: "marketing_carrier" },
  logo: {},
  api: {
    distribusion: EMPTY_API_URL,
    railAgent: EMPTY_API_URL,
    portal: EMPTY_API_URL,
    suggestionUrl: "",
    loyaltyUrl: "",
    usersUrl: ""
  }
};
const SettingsContext = createContext(DEFAULT_SETTINGS);
const useSettings = () => useContext(SettingsContext);
const timezoneCurrencyMap = {
  "Europe/Andorra": "EUR",
  "Asia/Dubai": "AED",
  "Asia/Kabul": "AFN",
  "Europe/Tirane": "ALL",
  "Asia/Yerevan": "AMD",
  "Antarctica/Casey": "USD",
  "Antarctica/Davis": "USD",
  "Antarctica/Mawson": "USD",
  "Antarctica/Palmer": "USD",
  "Antarctica/Rothera": "USD",
  "Antarctica/Troll": "USD",
  "Antarctica/Vostok": "USD",
  "America/Argentina/Buenos_Aires": "ARS",
  "America/Argentina/Cordoba": "ARS",
  "America/Argentina/Salta": "ARS",
  "America/Argentina/Jujuy": "ARS",
  "America/Argentina/Tucuman": "ARS",
  "America/Argentina/Catamarca": "ARS",
  "America/Argentina/La_Rioja": "ARS",
  "America/Argentina/San_Juan": "ARS",
  "America/Argentina/Mendoza": "ARS",
  "America/Argentina/San_Luis": "ARS",
  "America/Argentina/Rio_Gallegos": "ARS",
  "America/Argentina/Ushuaia": "ARS",
  "Pacific/Pago_Pago": "USD",
  "Europe/Vienna": "EUR",
  "Australia/Lord_Howe": "AUD",
  "Antarctica/Macquarie": "AUD",
  "Australia/Hobart": "AUD",
  "Australia/Melbourne": "AUD",
  "Australia/Sydney": "AUD",
  "Australia/Broken_Hill": "AUD",
  "Australia/Brisbane": "AUD",
  "Australia/Lindeman": "AUD",
  "Australia/Adelaide": "AUD",
  "Australia/Darwin": "AUD",
  "Australia/Perth": "AUD",
  "Australia/Eucla": "AUD",
  "Asia/Baku": "AZN",
  "America/Barbados": "BBD",
  "Asia/Dhaka": "BDT",
  "Europe/Brussels": "EUR",
  "Europe/Sofia": "BGN",
  "Atlantic/Bermuda": "BMD",
  "America/La_Paz": "BOB",
  "America/Noronha": "BRL",
  "America/Belem": "BRL",
  "America/Fortaleza": "BRL",
  "America/Recife": "BRL",
  "America/Araguaina": "BRL",
  "America/Maceio": "BRL",
  "America/Bahia": "BRL",
  "America/Sao_Paulo": "BRL",
  "America/Campo_Grande": "BRL",
  "America/Cuiaba": "BRL",
  "America/Santarem": "BRL",
  "America/Porto_Velho": "BRL",
  "America/Boa_Vista": "BRL",
  "America/Manaus": "BRL",
  "America/Eirunepe": "BRL",
  "America/Rio_Branco": "BRL",
  "Asia/Thimphu": "BTN",
  "Europe/Minsk": "BYN",
  "America/Belize": "BZD",
  "America/St_Johns": "CAD",
  "America/Halifax": "CAD",
  "America/Glace_Bay": "CAD",
  "America/Moncton": "CAD",
  "America/Goose_Bay": "CAD",
  "America/Toronto": "CAD",
  "America/Iqaluit": "CAD",
  "America/Winnipeg": "CAD",
  "America/Resolute": "CAD",
  "America/Rankin_Inlet": "CAD",
  "America/Regina": "CAD",
  "America/Swift_Current": "CAD",
  "America/Edmonton": "CAD",
  "America/Cambridge_Bay": "CAD",
  "America/Inuvik": "CAD",
  "America/Dawson_Creek": "CAD",
  "America/Fort_Nelson": "CAD",
  "America/Whitehorse": "CAD",
  "America/Dawson": "CAD",
  "America/Vancouver": "CAD",
  "Europe/Zurich": "CHF",
  "Africa/Abidjan": "XOF",
  "Pacific/Rarotonga": "NZD",
  "America/Santiago": "CLP",
  "America/Punta_Arenas": "CLP",
  "Pacific/Easter": "CLP",
  "Asia/Shanghai": "CNY",
  "Asia/Urumqi": "CNY",
  "America/Bogota": "COP",
  "America/Costa_Rica": "CRC",
  "America/Havana": "CUP",
  "Atlantic/Cape_Verde": "CVE",
  "Asia/Nicosia": "EUR",
  "Asia/Famagusta": "EUR",
  "Europe/Prague": "CZK",
  "Europe/Berlin": "EUR",
  "America/Santo_Domingo": "DOP",
  "Africa/Algiers": "DZD",
  "America/Guayaquil": "USD",
  "Pacific/Galapagos": "USD",
  "Europe/Tallinn": "EUR",
  "Africa/Cairo": "EGP",
  "Africa/El_Aaiun": "MAD",
  "Europe/Madrid": "EUR",
  "Africa/Ceuta": "EUR",
  "Atlantic/Canary": "EUR",
  "Europe/Helsinki": "EUR",
  "Pacific/Fiji": "FJD",
  "Atlantic/Stanley": "FKP",
  "Pacific/Kosrae": "USD",
  "Atlantic/Faroe": "DKK",
  "Europe/Paris": "EUR",
  "Europe/London": "GBP",
  "Asia/Tbilisi": "GEL",
  "America/Cayenne": "EUR",
  "Europe/Gibraltar": "GIP",
  "America/Nuuk": "DKK",
  "America/Danmarkshavn": "DKK",
  "America/Scoresbysund": "DKK",
  "America/Thule": "DKK",
  "Europe/Athens": "EUR",
  "Atlantic/South_Georgia": "FKP",
  "America/Guatemala": "GTQ",
  "Pacific/Guam": "USD",
  "Africa/Bissau": "XOF",
  "America/Guyana": "GYD",
  "Asia/Hong_Kong": "HKD",
  "America/Tegucigalpa": "HNL",
  "America/Port-au-Prince": "HTG",
  "Europe/Budapest": "HUF",
  "Asia/Jakarta": "IDR",
  "Asia/Pontianak": "IDR",
  "Asia/Makassar": "IDR",
  "Asia/Jayapura": "IDR",
  "Europe/Dublin": "EUR",
  "Asia/Jerusalem": "ILS",
  "Asia/Kolkata": "INR",
  "Indian/Chagos": "USD",
  "Asia/Baghdad": "IQD",
  "Asia/Tehran": "IRR",
  "Europe/Rome": "EUR",
  "America/Jamaica": "JMD",
  "Asia/Amman": "JOD",
  "Asia/Tokyo": "JPY",
  "Africa/Nairobi": "KES",
  "Asia/Bishkek": "KGS",
  "Pacific/Tarawa": "AUD",
  "Pacific/Kanton": "AUD",
  "Pacific/Kiritimati": "AUD",
  "Asia/Pyongyang": "KPW",
  "Asia/Seoul": "KRW",
  "Asia/Almaty": "KZT",
  "Asia/Qyzylorda": "KZT",
  "Asia/Qostanay": "KZT",
  "Asia/Aqtobe": "KZT",
  "Asia/Aqtau": "KZT",
  "Asia/Atyrau": "KZT",
  "Asia/Oral": "KZT",
  "Asia/Beirut": "LBP",
  "Asia/Colombo": "LKR",
  "Africa/Monrovia": "LRD",
  "Europe/Vilnius": "EUR",
  "Europe/Riga": "EUR",
  "Africa/Tripoli": "LYD",
  "Africa/Casablanca": "MAD",
  "Europe/Chisinau": "MDL",
  "Pacific/Kwajalein": "USD",
  "Asia/Yangon": "MMK",
  "Asia/Ulaanbaatar": "MNT",
  "Asia/Hovd": "MNT",
  "Asia/Choibalsan": "MNT",
  "Asia/Macau": "MOP",
  "America/Martinique": "EUR",
  "Europe/Malta": "EUR",
  "Indian/Mauritius": "MUR",
  "Indian/Maldives": "MVR",
  "America/Mexico_City": "MXN",
  "America/Cancun": "MXN",
  "America/Merida": "MXN",
  "America/Monterrey": "MXN",
  "America/Matamoros": "MXN",
  "America/Chihuahua": "MXN",
  "America/Ciudad_Juarez": "MXN",
  "America/Ojinaga": "MXN",
  "America/Mazatlan": "MXN",
  "America/Bahia_Banderas": "MXN",
  "America/Hermosillo": "MXN",
  "America/Tijuana": "MXN",
  "Asia/Kuching": "MYR",
  "Africa/Maputo": "MZN",
  "Africa/Windhoek": "NAD",
  "Pacific/Noumea": "XPF",
  "Pacific/Norfolk": "AUD",
  "Africa/Lagos": "NGN",
  "America/Managua": "NIO",
  "Asia/Kathmandu": "NPR",
  "Pacific/Nauru": "AUD",
  "Pacific/Niue": "NZD",
  "Pacific/Auckland": "NZD",
  "Pacific/Chatham": "NZD",
  "America/Panama": "PAB",
  "America/Lima": "PEN",
  "Pacific/Tahiti": "XPF",
  "Pacific/Marquesas": "XPF",
  "Pacific/Gambier": "XPF",
  "Pacific/Port_Moresby": "PGK",
  "Pacific/Bougainville": "PGK",
  "Asia/Manila": "PHP",
  "Asia/Karachi": "PKR",
  "Europe/Warsaw": "PLN",
  "America/Miquelon": "EUR",
  "Pacific/Pitcairn": "NZD",
  "America/Puerto_Rico": "USD",
  "Asia/Gaza": "ILS",
  "Asia/Hebron": "ILS",
  "Europe/Lisbon": "EUR",
  "Atlantic/Madeira": "EUR",
  "Atlantic/Azores": "EUR",
  "Pacific/Palau": "USD",
  "America/Asuncion": "PYG",
  "Asia/Qatar": "QAR",
  "Europe/Bucharest": "RON",
  "Europe/Belgrade": "RSD",
  "Europe/Kaliningrad": "RUB",
  "Europe/Moscow": "RUB",
  "Europe/Simferopol": "RUB",
  "Europe/Kirov": "RUB",
  "Europe/Volgograd": "RUB",
  "Europe/Astrakhan": "RUB",
  "Europe/Saratov": "RUB",
  "Europe/Ulyanovsk": "RUB",
  "Europe/Samara": "RUB",
  "Asia/Yekaterinburg": "RUB",
  "Asia/Omsk": "RUB",
  "Asia/Novosibirsk": "RUB",
  "Asia/Barnaul": "RUB",
  "Asia/Tomsk": "RUB",
  "Asia/Novokuznetsk": "RUB",
  "Asia/Krasnoyarsk": "RUB",
  "Asia/Irkutsk": "RUB",
  "Asia/Chita": "RUB",
  "Asia/Yakutsk": "RUB",
  "Asia/Khandyga": "RUB",
  "Asia/Vladivostok": "RUB",
  "Asia/Ust-Nera": "RUB",
  "Asia/Magadan": "RUB",
  "Asia/Sakhalin": "RUB",
  "Asia/Srednekolymsk": "RUB",
  "Asia/Kamchatka": "RUB",
  "Asia/Anadyr": "RUB",
  "Asia/Riyadh": "SAR",
  "Pacific/Guadalcanal": "SBD",
  "Africa/Khartoum": "SDG",
  "Asia/Singapore": "SGD",
  "America/Paramaribo": "SRD",
  "Africa/Juba": "SSP",
  "Africa/Sao_Tome": "STN",
  "America/El_Salvador": "USD",
  "Asia/Damascus": "SYP",
  "America/Grand_Turk": "USD",
  "Africa/Ndjamena": "XAF",
  "Asia/Bangkok": "THB",
  "Asia/Dushanbe": "TJS",
  "Pacific/Fakaofo": "NZD",
  "Asia/Dili": "USD",
  "Asia/Ashgabat": "TMT",
  "Africa/Tunis": "TND",
  "Pacific/Tongatapu": "TOP",
  "Europe/Istanbul": "TRY",
  "Asia/Taipei": "TWD",
  "Europe/Kyiv": "UAH",
  "America/New_York": "USD",
  "America/Detroit": "USD",
  "America/Kentucky/Louisville": "USD",
  "America/Kentucky/Monticello": "USD",
  "America/Indiana/Indianapolis": "USD",
  "America/Indiana/Vincennes": "USD",
  "America/Indiana/Winamac": "USD",
  "America/Indiana/Marengo": "USD",
  "America/Indiana/Petersburg": "USD",
  "America/Indiana/Vevay": "USD",
  "America/Chicago": "USD",
  "America/Indiana/Tell_City": "USD",
  "America/Indiana/Knox": "USD",
  "America/Menominee": "USD",
  "America/North_Dakota/Center": "USD",
  "America/North_Dakota/New_Salem": "USD",
  "America/North_Dakota/Beulah": "USD",
  "America/Denver": "USD",
  "America/Boise": "USD",
  "America/Phoenix": "USD",
  "America/Los_Angeles": "USD",
  "America/Anchorage": "USD",
  "America/Juneau": "USD",
  "America/Sitka": "USD",
  "America/Metlakatla": "USD",
  "America/Yakutat": "USD",
  "America/Nome": "USD",
  "America/Adak": "USD",
  "Pacific/Honolulu": "USD",
  "America/Montevideo": "UYU",
  "Asia/Samarkand": "UZS",
  "Asia/Tashkent": "UZS",
  "America/Caracas": "VES",
  "Asia/Ho_Chi_Minh": "VND",
  "Pacific/Efate": "VUV",
  "Pacific/Apia": "WST",
  "Africa/Johannesburg": "ZAR",
  "America/Antigua": "XCD",
  "America/Anguilla": "XCD",
  "Africa/Luanda": "AOA",
  "Antarctica/McMurdo": "USD",
  "Antarctica/DumontDUrville": "USD",
  "Antarctica/Syowa": "USD",
  "America/Aruba": "AWG",
  "Europe/Mariehamn": "EUR",
  "Europe/Sarajevo": "BAM",
  "Africa/Ouagadougou": "XOF",
  "Asia/Bahrain": "BHD",
  "Africa/Bujumbura": "BIF",
  "Africa/Porto-Novo": "XOF",
  "America/St_Barthelemy": "EUR",
  "Asia/Brunei": "BND",
  "America/Kralendijk": "USD",
  "America/Nassau": "BSD",
  "Africa/Gaborone": "BWP",
  "America/Blanc-Sablon": "CAD",
  "America/Atikokan": "CAD",
  "America/Creston": "CAD",
  "Indian/Cocos": "AUD",
  "Africa/Kinshasa": "CDF",
  "Africa/Lubumbashi": "CDF",
  "Africa/Bangui": "XAF",
  "Africa/Brazzaville": "XAF",
  "Africa/Douala": "XAF",
  "America/Curacao": "ANG",
  "Indian/Christmas": "AUD",
  "Europe/Busingen": "EUR",
  "Africa/Djibouti": "DJF",
  "Europe/Copenhagen": "DKK",
  "America/Dominica": "XCD",
  "Africa/Asmara": "ERN",
  "Africa/Addis_Ababa": "ETB",
  "Pacific/Chuuk": "USD",
  "Pacific/Pohnpei": "USD",
  "Africa/Libreville": "XAF",
  "America/Grenada": "XCD",
  "Europe/Guernsey": "GBP",
  "Africa/Accra": "GHS",
  "Africa/Banjul": "GMD",
  "Africa/Conakry": "GNF",
  "America/Guadeloupe": "EUR",
  "Africa/Malabo": "XAF",
  "Europe/Zagreb": "EUR",
  "Europe/Isle_of_Man": "GBP",
  "Atlantic/Reykjavik": "ISK",
  "Europe/Jersey": "GBP",
  "Asia/Phnom_Penh": "KHR",
  "Indian/Comoro": "KMF",
  "America/St_Kitts": "XCD",
  "Asia/Kuwait": "KWD",
  "America/Cayman": "KYD",
  "Asia/Vientiane": "LAK",
  "America/St_Lucia": "XCD",
  "Europe/Vaduz": "CHF",
  "Africa/Maseru": "LSL",
  "Europe/Luxembourg": "EUR",
  "Europe/Monaco": "EUR",
  "Europe/Podgorica": "EUR",
  "America/Marigot": "EUR",
  "Indian/Antananarivo": "MGA",
  "Pacific/Majuro": "USD",
  "Europe/Skopje": "MKD",
  "Africa/Bamako": "XOF",
  "Pacific/Saipan": "USD",
  "Africa/Nouakchott": "MRU",
  "America/Montserrat": "XCD",
  "Africa/Blantyre": "MWK",
  "Asia/Kuala_Lumpur": "MYR",
  "Africa/Niamey": "XOF",
  "Europe/Amsterdam": "EUR",
  "Europe/Oslo": "NOK",
  "Asia/Muscat": "OMR",
  "Indian/Reunion": "EUR",
  "Africa/Kigali": "RWF",
  "Indian/Mahe": "SCR",
  "Europe/Stockholm": "SEK",
  "Atlantic/St_Helena": "SHP",
  "Europe/Ljubljana": "EUR",
  "Arctic/Longyearbyen": "NOK",
  "Europe/Bratislava": "EUR",
  "Africa/Freetown": "SLE",
  "Europe/San_Marino": "EUR",
  "Africa/Dakar": "XOF",
  "Africa/Mogadishu": "SOS",
  "America/Lower_Princes": "ANG",
  "Africa/Mbabane": "SZL",
  "Indian/Kerguelen": "EUR",
  "Africa/Lome": "XOF",
  "America/Port_of_Spain": "TTD",
  "Pacific/Funafuti": "AUD",
  "Africa/Dar_es_Salaam": "TZS",
  "Africa/Kampala": "UGX",
  "Pacific/Midway": "USD",
  "Pacific/Wake": "USD",
  "Europe/Vatican": "EUR",
  "America/St_Vincent": "XCD",
  "America/Tortola": "USD",
  "America/St_Thomas": "USD",
  "Pacific/Wallis": "XPF",
  "Asia/Aden": "YER",
  "Indian/Mayotte": "EUR",
  "Africa/Lusaka": "ZMW",
  "Africa/Harare": "ZWL"
};
const EXCLUDE_CURRENCIES = ["MXN"];
const MAP = {
  ALL: { symbol: "L", name: "ALL", multiplier: 1 },
  AED: { symbol: "د.إ", name: "AED", multiplier: 1 },
  ARS: { symbol: "AR$", name: "ARS", multiplier: 1 },
  AUD: { symbol: "AU$", name: "AUD", multiplier: 1 },
  AZN: { symbol: "₼", name: "AZN", multiplier: 1 },
  BAM: { symbol: "KM", name: "BAM", multiplier: 1 },
  BGN: { symbol: "ЛВ.", name: "BGN", multiplier: 1 },
  BRL: { symbol: "R$", name: "BRL", multiplier: 1 },
  CAD: { symbol: "C$", name: "CAD", multiplier: 1 },
  CHF: { symbol: "CHF", name: "CHF", multiplier: 1 },
  CNY: { symbol: "¥", name: "CNY", multiplier: 1 },
  COP: { symbol: "CO$", name: "COP", multiplier: 1 },
  CZK: { symbol: "Kč", name: "CZK", multiplier: 1 },
  DKK: { symbol: "kr.", name: "DKK", multiplier: 1 },
  EGP: { symbol: "E£", name: "EGP", multiplier: 1 },
  EUR: { symbol: "€", name: "EUR", multiplier: 1 },
  GBP: { symbol: "£", name: "GBP", multiplier: 1 },
  GEL: { symbol: "₾", name: "GEL", multiplier: 1 },
  HKD: { symbol: "HK$", name: "HKD", multiplier: 1 },
  HRK: { symbol: "kn", name: "HRK", multiplier: 1 },
  HUF: { symbol: "Ft", name: "HUF", multiplier: 100 },
  IDR: { symbol: "Rp", name: "IDR", multiplier: 1, precision: 2 },
  INR: { symbol: "₹", name: "INR", multiplier: 1 },
  JPY: { symbol: "¥", name: "JPY", multiplier: 1, precision: 0 },
  KES: { symbol: "Kshs ", name: "KES", multiplier: 0.01, precision: 0 },
  KRW: { symbol: "₩", name: "KRW", multiplier: 1, precision: 0 },
  KZT: { symbol: "₸", name: "KZT", multiplier: 1 },
  LAK: { symbol: "₭", name: "LAK", multiplier: 1 },
  LKR: { symbol: "Rs", name: "LKR", multiplier: 1 },
  MAD: { symbol: "MAD", name: "MAD", multiplier: 1 },
  MKD: { symbol: "ден", name: "MKD", multiplier: 1 },
  MMK: { symbol: "K", name: "MMK", multiplier: 1 },
  MXN: { symbol: "MX$", name: "MXN", multiplier: 1 },
  MYR: { symbol: "RM", name: "MYR", multiplier: 1 },
  NGN: { symbol: "₦", name: "NGN", multiplier: 1 },
  NOK: { symbol: "kr", name: "NOK", multiplier: 1 },
  NZD: { symbol: "NZ$", name: "NZD", multiplier: 1 },
  NPR: { symbol: "Rs", name: "NPR", multiplier: 1 },
  PHP: { symbol: "₱", name: "PHP", multiplier: 1 },
  PKR: { symbol: "Rs", name: "PKR", multiplier: 1 },
  PLN: { symbol: "zł", name: "PLN", multiplier: 1 },
  RON: { symbol: "L", name: "RON", multiplier: 1 },
  RSD: { symbol: "дин.", name: "RSD", multiplier: 1 },
  RUB: { symbol: "₽", name: "RUB", multiplier: 1 },
  SAR: { symbol: "﷼", name: "SAR", multiplier: 1 },
  SEK: { symbol: "kr", name: "SEK", multiplier: 1 },
  SGD: { symbol: "S$", name: "SGD", multiplier: 1 },
  THB: { symbol: "฿", name: "THB", multiplier: 1 },
  TRY: { symbol: "₺", name: "TRY", multiplier: 1 },
  TWD: { symbol: "元", name: "TWD", multiplier: 1 },
  UAH: { symbol: "₴", name: "UAH", multiplier: 1 },
  USD: { symbol: "US$", name: "USD", multiplier: 1 },
  VND: { symbol: "₫", name: "VND", multiplier: 1, precision: 0 },
  CLP: { symbol: "$", name: "CLP", multiplier: 1 }
};
const getSymbol = (currency2) => {
  const code = currency2.toUpperCase();
  return MAP[code]?.symbol ?? code;
};
const getName = (currency2) => {
  const code = currency2.toUpperCase();
  return MAP[code]?.name;
};
const getMultiplier = (currency2) => {
  if (currency2) return MAP[currency2.toUpperCase()]?.multiplier ?? 1;
  return 1;
};
const getPrecision = (currency2) => {
  if (currency2) return MAP[currency2.toUpperCase()]?.precision ?? 2;
  return 2;
};
const getBestCurrency = (supported, defaultValue) => {
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const countryCurrency = timezoneCurrencyMap[timezone];
  return supported.includes(countryCurrency) ? countryCurrency : defaultValue;
};
const sumPrice$1 = (first, second) => ({
  fractional: first.fractional + second.fractional,
  currency: first.currency
});
const getPrecisionMultiplier = (currency2) => 10 ** getPrecision(currency2);
const convertDecimalToInteger = (price) => getPrecisionMultiplier(price.currency) * price.fractional;
const useCurrencyUtils = () => {
  const { topCurrencies, locale } = useSettings();
  const createCurrency = useCallback(
    (price, code, opt) => {
      const currencyCode = code?.toUpperCase();
      const multiplier = getMultiplier(currencyCode);
      const precision = getPrecision(currencyCode);
      const currentLocale = opt?.locale || locale || "en-US";
      const currencySign = code ? getSymbol(code) : "";
      const options = {
        fromCents: true,
        precision,
        symbol: currencySign,
        ...opt
      };
      const formatter = new Intl.NumberFormat(currentLocale, {
        style: "currency",
        currency: currencyCode || "USD",
        currencyDisplay: "symbol",
        minimumFractionDigits: precision,
        maximumFractionDigits: precision,
        useGrouping: true
      });
      const format = (curr) => {
        if (code) {
          return formatter.format(curr?.value ?? 0);
        }
        return curr && curr.value ? curr.value.toString() : "";
      };
      if (!EXCLUDE_CURRENCIES.includes(currencyCode)) {
        options.format = format;
      }
      return currency(price, options).multiply(multiplier);
    },
    [locale]
  );
  const formatPrice = useCallback((fractional) => createCurrency(fractional).value, [createCurrency]);
  const sort = useCallback(
    (supported) => {
      const filteredTop = topCurrencies.filter((item) => supported.includes(item));
      const restCurrencies = supported.filter((item) => !filteredTop.includes(item)).sort((a, b) => a > b ? 1 : -1);
      return [...filteredTop, ...restCurrencies];
    },
    [topCurrencies]
  );
  const verifyPositionInPopularList = useCallback(
    (supported, code, index) => {
      const filteredTop = topCurrencies.filter((item) => supported.includes(item));
      return filteredTop.at(index) === code;
    },
    [topCurrencies]
  );
  return {
    getSymbol,
    getName,
    sort,
    verifyPositionInPopularList,
    createCurrency,
    formatPrice,
    getBestCurrency,
    getMultiplier,
    getPrecision,
    sumPrice: sumPrice$1,
    convertDecimalToInteger,
    getPrecisionMultiplier
  };
};
const localesMap = {
  ar: fnsLocales.ar,
  bg: fnsLocales.bg,
  cs: fnsLocales.cs,
  da: fnsLocales.da,
  de: fnsLocales.de,
  en: fnsLocales.enGB,
  es: fnsLocales.es,
  fr: fnsLocales.fr,
  hr: fnsLocales.hr,
  it: fnsLocales.it,
  ja: fnsLocales.ja,
  nl: fnsLocales.nl,
  no: fnsLocales.nn,
  pl: fnsLocales.pl,
  pt: fnsLocales.pt,
  sq: fnsLocales.sq,
  sv: fnsLocales.sv,
  tr: fnsLocales.tr,
  vi: fnsLocales.vi,
  zh: fnsLocales.zhCN,
  "en-IE": fnsLocales.enIE,
  "en-US": fnsLocales.enUS,
  "en-CA": fnsLocales.enCA,
  "es-CO": fnsLocales.es,
  "es-EC": fnsLocales.es,
  "es-MX": fnsLocales.es,
  "hi-IN": fnsLocales.hi,
  "pt-BR": fnsLocales.ptBR,
  "sk-SK": fnsLocales.sk,
  "th-TH": fnsLocales.th,
  ur: fnsLocales.enGB,
  bs: fnsLocales.bs,
  el: fnsLocales.el,
  hu: fnsLocales.hu,
  mk: fnsLocales.mk,
  ro: fnsLocales.ro,
  ru: fnsLocales.ru,
  sr: fnsLocales.sr,
  uk: fnsLocales.uk,
  yue: fnsLocales.enGB,
  id: fnsLocales.id,
  lv: fnsLocales.lv,
  ga: fnsLocales.enGB,
  rm: fnsLocales.enGB,
  he: fnsLocales.he,
  sw: fnsLocales.enGB
};
const trimCountryCode = (locale) => locale.split("-")[0].toLowerCase();
const parse = (string, tz) => {
  if (tz !== "UTC") return fns.parseISO(string);
  const parsedDate = fns.parseISO(`${string.split("+")[0]}+00:00`);
  return fnsTz.toZonedTime(parsedDate, tz);
};
const useDateUtils = () => {
  const { locale } = useSettings();
  const getLocale = useCallback(() => {
    const trimmedLocale = trimCountryCode(locale);
    return localesMap[locale] ?? localesMap[trimmedLocale] ?? fnsLocales.enGB;
  }, [locale]);
  const formatInLocal = useCallback(
    (date, template) => fns.format(date, template, { locale: getLocale() }),
    [getLocale]
  );
  const formatInUtc = useCallback(
    (date, template) => fnsTz.formatInTimeZone(date, "UTC", template, {
      locale: getLocale()
    }),
    [getLocale]
  );
  const format = useCallback(
    (date, template, displayInUtc = false) => displayInUtc ? formatInUtc(date, template) : formatInLocal(date, template),
    [formatInLocal, formatInUtc]
  );
  const formatDateISO = (date) => format(date, "yyyy-MM-dd'T'HH:mm");
  return {
    parse,
    formatInLocal,
    formatInUtc,
    format,
    formatDateISO,
    getLocale
  };
};
const UISettingsContextProvider = ({ children }) => {
  const {
    userInterface: { date, time }
  } = useSettings();
  const dateUtils = useDateUtils();
  const currencyUtils = useCurrencyUtils();
  const settings = useMemo(
    () => ({
      dateLocale: dateUtils.getLocale(),
      currency: {
        getSymbol: (currency2) => currencyUtils.getSymbol(currency2),
        create: (price, code) => currencyUtils.createCurrency(price, code)
      },
      time,
      date
    }),
    [currencyUtils, date, dateUtils, time]
  );
  return /* @__PURE__ */ jsx(SettingsContext$1.Provider, { value: settings, children });
};
const withUISettingsProvider = (Component) => {
  return function WithSettingsWrapper(props) {
    return /* @__PURE__ */ jsx(UISettingsContextProvider, { children: /* @__PURE__ */ jsx(Component, { ...props }) });
  };
};
const build = (parts, params = {}, arrayFormat) => {
  const path = parts.map((p) => trim(p, "/")).join("/");
  const query = stringify(params, { arrayFormat });
  if (query.length > 0) return `${path}?${query}`;
  return path;
};
const API_PATHNAME = "api";
const API_OLD_PATHNAME = "new_search";
const PORTAL_PATHNAME = "portal";
const SUGGESTION_API_ENDPOINTS = [/locations$/];
const NEW_API_ENDPOINTS = [
  /settings/,
  /countries/,
  /fare_classes/,
  /passenger_types/,
  /installment_rates/,
  /marketing_carriers\/([^/]+)$/,
  /connections\/cheapest_prices/,
  /connections\/vacancy/,
  /connections\/price_calendar/,
  /connections$/,
  /landing/,
  /popular_connections/,
  /conditions/,
  /stations/,
  /carrier/,
  /feedback/,
  /media/,
  /amendments\/\d+\/status$/,
  /amendments\/\d+\/details$/,
  /realtime\/trips(\/.*)?$/,
  /price_insights/,
  /portal_settings/,
  /seat_availabilities$/,
  /layouts\//,
  /landing\/cities/,
  /orders/,
  /resend_confirmation_email/,
  /bookings\/user\/tickets/,
  /subscriptions/,
  /payments/
];
const PORTAL_ENDPOINTS = [/retailer\/\d+\/cards$/, /\/retailer\/[^/]+\/billing_address/, /payment_terminals/];
const ENDPOINTS_WITH_COOKIES = [
  /payment_terminals/,
  /\/api\/.*/,
  /\/portal\/.*/,
  /\/new_search\/reservations/,
  /\/new_search\/bookings/,
  /\/new_search\/amendments/
];
const HOSTS_WITH_COOKIES = [/localhost/, /\.distribusion\.com$/, /\.railagent/];
const HOSTS_PORTAL = [/^https:\/\/portal\.distribusion\.com(\/.*)?$/];
const HOSTS_RAILAGENT = [/^https:\/\/portal\.railagent\.com(\/.*)?$/];
const LOYALTY_ENDPOINTS = [/\/v1\/loyalty\//];
const USERS_ENDPOINTS = [/travelers/];
class ApiError extends Error {
  code;
  data;
  status;
  path;
  constructor(params) {
    super(params.code);
    Object.assign(this, params);
  }
}
const toNestedObject = (response, params) => {
  if (response?.jsonapi?.version == null) return response;
  return toNestedObject$1(response, params);
};
const makeApiCollection = (collection) => ({
  url: build([collection.url, API_PATHNAME]),
  oldUrl: build([collection.oldUrl, API_OLD_PATHNAME]),
  portalUrl: build([collection.url, PORTAL_PATHNAME])
});
const hostWithCookies = HOSTS_WITH_COOKIES.some((r) => r.test(window.location.hostname));
const shouldSendCookies = (url) => {
  const { origin, pathname } = new URL(url);
  const uri = `${origin}${pathname}`;
  if (!hostWithCookies) return false;
  return ENDPOINTS_WITH_COOKIES.some((regexp) => regexp.test(uri));
};
const credentialsIncludeStrategy = (url) => {
  if (shouldSendCookies(url)) return "include";
  else return "omit";
};
const processResponse = async (response, config, requestParams) => {
  const responseBody = await (async () => {
    try {
      return await response.json();
    } catch {
      return {};
    }
  })();
  if (response.ok) {
    const params = { ...apiConfigDefaults.responsePostprocessing, ...config.responsePostprocessing };
    const processedResponse = config.parseJsonApi === false ? responseBody : toNestedObject(responseBody, params);
    return config.transformResponse ? config.transformResponse(processedResponse, responseBody, requestParams) : processedResponse;
  } else {
    throw new ApiError({
      code: responseBody.code ?? "internalError",
      data: responseBody.data ?? {},
      status: response.status,
      path: response.url.replace(location.hostname, "")
    });
  }
};
const apiConfigDefaults = {
  arrayFormat: "brackets",
  responsePostprocessing: {
    convertKeys: "LowerCamel"
  }
};
const getWhitelabelUrls = ({ distribusion, railAgent, portal }) => {
  const iframeDomain = new URLSearchParams(window.location.search).get("parentDomain");
  const domain = iframeDomain ?? window.location.origin;
  if (HOSTS_PORTAL.some((r) => r.test(domain))) return portal;
  if (HOSTS_RAILAGENT.some((r) => r.test(domain))) return railAgent;
  return distribusion;
};
function useBuildUrl() {
  const { api, newBackendEndpoints } = useSettings();
  const { url, oldUrl, portalUrl } = useMemo(() => makeApiCollection(getWhitelabelUrls(api)), [api]);
  const getApiUrl = useCallback(
    (path) => {
      const { suggestionUrl, loyaltyUrl, usersUrl } = api;
      if (LOYALTY_ENDPOINTS.some((regex) => regex.test(path))) {
        return loyaltyUrl;
      }
      if (PORTAL_ENDPOINTS.some((r) => r.test(path))) return portalUrl;
      if (NEW_API_ENDPOINTS.some((r) => r.test(path))) return url;
      if (SUGGESTION_API_ENDPOINTS.some((regex) => regex.test(path))) return suggestionUrl;
      if (USERS_ENDPOINTS.some((regex) => regex.test(path))) return usersUrl;
      return oldUrl;
    },
    [api, portalUrl, url, oldUrl]
  );
  const getEndpointParts = useCallback(
    (path) => {
      if (typeof path === "string") return [getApiUrl(path), path];
      return newBackendEndpoints.includes(path.type) || !path.old ? [url, path.new] : [oldUrl, path.old];
    },
    [getApiUrl, newBackendEndpoints, oldUrl, url]
  );
  return useCallback(
    (path, params, config) => build(getEndpointParts(path), params, config.arrayFormat),
    [getEndpointParts]
  );
}
function useApi() {
  const buildUrl = useBuildUrl();
  const makeApi = useCallback(
    (method, path, config) => {
      return async ({ params, body }) => {
        const url = buildUrl(path, params, config);
        const requestOptions = {
          method,
          body: body == null ? null : JSON.stringify(body),
          headers: body == null ? void 0 : { "Content-Type": "application/json" },
          credentials: credentialsIncludeStrategy(url)
        };
        const response = await fetch(url, requestOptions);
        return await processResponse(response, config, params);
      };
    },
    [buildUrl]
  );
  const get = useCallback(
    (path, config = apiConfigDefaults) => {
      const callApi = makeApi("GET", path, config);
      return async (params) => await callApi({ params, body: null });
    },
    [makeApi]
  );
  const post = useCallback(
    (path, config = apiConfigDefaults) => makeApi("POST", path, config),
    [makeApi]
  );
  const put = useCallback(
    (path, config = apiConfigDefaults) => makeApi("PUT", path, config),
    [makeApi]
  );
  return { get, post, put };
}
const useMarketingCarrierLogo = (code) => {
  const buildUrl = useBuildUrl();
  return code && buildUrl(
    {
      type: "marketingCarriers/logo",
      old: `/carriers/${code}/logo`,
      new: `/marketing_carriers/${code}/logo`
    },
    {},
    {}
  );
};
const isValuePresent = (value) => value != null;
const objectCompact = (item) => {
  const entries = Object.entries(item).filter(([_key, value]) => isValuePresent(value));
  return Object.fromEntries(entries);
};
const getPaxCards = (cards) => cards?.map(({ name, code }) => ({ name, code }));
const filterPassengers = (passengers) => passengers.filter(({ type, pax }) => type && pax);
const normalizePassengers = (passengers) => filterPassengers(passengers).reduce((acc, { type, cards, pax }) => {
  const selected = acc.find((p) => p.type === type && !p.cards?.length);
  if (cards?.length || !selected) return [...acc, { type, pax, cards }];
  selected.pax += 1;
  return acc;
}, []);
const currencyIcons = {
  EUR: "euro",
  USD: "dollar",
  GBP: "pound"
};
const supportLabels = ["WC", "ES", "WHEELCHAIR", "RESTAURANT", "STROLLER", "LUGGAGE"];
const getCurrencyIcon = (currency2) => currencyIcons[currency2] ?? /* istanbul ignore next: fallback to be covered with unit tests */
"star-simple";
const getSeatsCount = (seats) => {
  if (!seats) return 0;
  return Object.values(seats).reduce((acc, currentValue) => acc + currentValue.length, 0);
};
const getUniqueFares = (layout) => {
  const array = [...new Set(layout?.cars.flatMap((item) => item.seats.map((el) => el.fareClass)))];
  return array.filter((item) => item !== null);
};
const getUniqueLevel = (layout) => [
  ...new Set(layout?.cars.flatMap((item) => item.seats.map((el) => el.coordinates.z)))
];
const toUrlParams = (selected) => {
  const entries = Object.entries(selected).map(([key, value]) => [
    key,
    value.map((item) => ({
      price: item.price ?? 0,
      code: item.code,
      label: item.label,
      fareClass: item.fareClass,
      segmentIndex: item.segmentIndex
    }))
  ]);
  return Object.fromEntries(entries);
};
const filterLayoutByFareClass = (layout, fareClassCode) => layout?.map((item) => ({
  ...item,
  cars: item.cars.map((car) => ({
    ...car,
    seats: car.seats.filter(
      (el) => el.fareClass === fareClassCode || supportLabels.includes(el.label)
    )
  }))
}));
const sumPrice = (seats) => sumBy(seats, (seat) => Number(seat.price));
const sumOutboundPrice = (selected, connection, currency2) => Object.values(selected).flatMap((item) => item.map((el) => ({ fareClass: el.fareClass, price: el.price }))).reduce(
  (acc, curr) => {
    const current = connection?.fares.find((el) => el.fareClass.code === curr.fareClass);
    return {
      fractional: acc.fractional + (current?.price.fractional ?? /* istanbul ignore next: fallback to be covered with unit tests */
      0) + Number(curr.price),
      currency: currency2
    };
  },
  { fractional: 0, currency: currency2 }
);
const MAX_PRICE_CATEGORY = 3;
const getPriceCategories = (seats) => {
  const prices = seats.filter((seat) => seat.price != null && seat.price > 0).map((seat) => seat.price);
  return [...new Set(prices)].sort((a, b) => a - b).reduce((mem, price, index) => ({ ...mem, [price]: Math.min(index + 1, MAX_PRICE_CATEGORY) }), {});
};
const getSeatsLimitations = (car) => car.seats.flatMap((seat) => seat.limitations ?? /* istanbul ignore next: fallback to be covered with unit tests */
[]);
const getDiscountCategories = (cars) => {
  const limitations = cars.flatMap((car) => [...getSeatsLimitations(car), ...car.limitations ?? []]);
  return uniqBy(limitations, "name");
};
const flatten = (seats) => Object.values(seats ?? {}).flat();
const isLimitedBy = (seat, discount) => !!find(seat.limitations ?? [], { name: discount });
const isLimitedSeatsTaken = (seats, discountCard) => {
  let limitedSeatFound = false;
  for (const seat of seats) {
    if (isLimitedBy(seat, discountCard)) {
      if (seat.vacant) return false;
      limitedSeatFound = true;
    }
  }
  return limitedSeatFound;
};
const normalizeSeat = (seat) => {
  const swappedMap = {
    facing_forward: "facingBackward",
    facing_backward: "facingForward",
    facing_right: "facingLeft",
    facing_left: "facingRight"
  };
  return {
    ...seat,
    orientation: swappedMap[seat.orientation ?? "facing_backward"]
  };
};
const transformSegmentIntoTrainSeatsScheme = (tripDirection) => ({ segment, cars }) => ({
  id: segment.id,
  index: segment.index,
  cars: cars.map((car) => ({
    label: car.label ?? String(car.index + 1),
    index: car.index,
    layout: `${tripDirection}.${segment.index}.${car.index}`
  }))
});
const transformIntoTrainSeats = (seats) => {
  const scheme = {
    outbound: seats.outbound.map(transformSegmentIntoTrainSeatsScheme("outbound")),
    inbound: seats.inbound.map(transformSegmentIntoTrainSeatsScheme("inbound"))
  };
  return {
    scheme,
    layoutQuery: (layoutKey) => {
      const [tripDirection, segmentIndex, carIndex] = layoutKey.split(".");
      const segment = seats[tripDirection]?.find(
        ({ segment: segment2 }) => segment2.index === Number(segmentIndex)
      );
      const car = segment?.cars.find(({ index }) => index === Number(carIndex));
      const layout = car && {
        code: layoutKey,
        seats: car.seats.map((seat) => normalizeSeat(seat))
      };
      return {
        queryKey: ["seats", "layout", "singleStep", layout],
        queryFn: () => layout,
        placeholderData: layout
      };
    }
  };
};
const getGridPlacement = (position, size) => ({
  gridRow: `${position.y + 1}${size?.width ? `/${position.y + size.width + 1}` : ""}`,
  gridColumn: `${position.x + 1}${size?.length ? `/${position.x + size.length + 1}` : ""}`
});
const useSeatSelectionUtils = () => {
  const date = useDateUtils();
  const { currency: currency2, locale, retailerPartnerNumber } = useSettings();
  const buildSeatAvailabilitiesParams = (connection, props) => {
    let passengers = null;
    if (props?.passengers?.length) {
      passengers = props.passengers;
    }
    let normalizedPassengers = null;
    if (passengers !== null) {
      normalizedPassengers = normalizePassengers(passengers).map((pax) => ({ ...pax, cards: getPaxCards(pax.cards) }));
    }
    return objectCompact({
      retailerPartnerNumber,
      marketingCarrierCode: connection.marketingCarrier.code,
      departureStation: connection.departureStation.code,
      arrivalStation: connection.arrivalStation.code,
      departureTime: date.formatDateISO(date.parse(connection.departureTime, "UTC")),
      arrivalTime: date.formatDateISO(date.parse(connection.arrivalTime, "UTC")),
      fareClass: props?.fareClass,
      offerId: connection.offerId ?? null,
      currency: currency2,
      passengers: normalizedPassengers
    });
  };
  const buildSeatsParams = (connection, props) => {
    const baseParams = buildSeatAvailabilitiesParams(connection, props);
    return objectCompact({
      ...baseParams,
      extraFields: props?.limitations ? (
        /* istanbul ignore next: fallback to be covered with unit tests */
        "cars.limitations,cars.seats.limitations"
      ) : null,
      locale
    });
  };
  return {
    transformIntoTrainSeats,
    getSeatsCount,
    getUniqueFares,
    getUniqueLevel,
    toUrlParams,
    buildSeatsParams,
    buildSeatAvailabilitiesParams,
    filterLayoutByFareClass,
    sumPrice,
    sumOutboundPrice,
    getPriceCategories,
    getCurrencyIcon,
    flatten,
    getDiscountCategories,
    isLimitedSeatsTaken,
    getGridPlacement
  };
};
function useReactiveState(initialStateFactory, dependencies) {
  const prevDependencies = useRef(dependencies);
  const [internalState, setInternalState] = useState(initialStateFactory);
  if (dependencies.some((dependency, index) => !Object.is(dependency, prevDependencies.current[index]))) {
    setInternalState(initialStateFactory);
    prevDependencies.current = dependencies;
  }
  return [internalState, setInternalState];
}
const buildLinkedList = (array, getIndex) => {
  if (array.length === 0) {
    return { position: 0, item: null };
  }
  const sorted = array.sort((a, b) => getIndex(a) - getIndex(b));
  const start = { position: 0, item: sorted[0] };
  let current = start;
  for (let i = start.position + 1; i < sorted.length; i++) {
    const next = { position: i, item: sorted[i] };
    current.next = next;
    next.prev = current;
    current = next;
  }
  return start;
};
const findNode = (first, item) => {
  let node = first;
  while (node && node.item !== item) {
    node = node.next;
  }
  return node || { position: 0, item: null };
};
const useLinkedListWithIndex = (array, getIndex, beginFrom) => {
  const firstNode = useMemo(() => buildLinkedList(array, getIndex), [array, getIndex]);
  const [currentNode, setCurrentNode] = useReactiveState(
    () => beginFrom ? findNode(firstNode, beginFrom) : firstNode,
    [firstNode, beginFrom]
  );
  const move = useCallback(
    (direction) => {
      setCurrentNode((node) => (direction === -1 ? node.prev : node.next) || node);
    },
    [setCurrentNode]
  );
  return useMemo(
    () => ({
      current: currentNode.item ? currentNode : firstNode,
      move,
      reset: () => setCurrentNode(firstNode),
      length: array.length
    }),
    [currentNode, firstNode, move, array.length, setCurrentNode]
  );
};
class AssertionError extends Error {
}
function assert(condition, message) {
  if (!condition) {
    throw new AssertionError(message);
  }
}
function assertNotNull(value, message) {
  return assert(value != null, message);
}
const fareFeatureIconName = {
  TOIL: "wc",
  WIFI: "wifi",
  PSOC: "outlet",
  DCLE: "broom",
  BIKE: "bicycle",
  ACON: "air",
  PREF: "money-half",
  ALRO: "comfortable-seat",
  MSYS: "tv",
  AAFO: "bicycle",
  UCHA: "usb",
  NAME: "pen-crossed",
  NREF: "money-crossed",
  AMEN: "pen",
  REFU: "money-full",
  AAFR: "wheelchair",
  MAGA: "magazines",
  AAFP: "folded-bicycle",
  ALSE: "adjustable-seat",
  ASEA: "adjustable-seat",
  APLI: "adjustable-personal-lighting",
  ATDB: "lounge",
  BABF: "baby-changing-facilities",
  BCTA: "baby-changing-facilities",
  BLUF: "bulky-luggage-for-fee",
  BLUG: "bulky-luggage",
  BLUN: "bulky-luggage-included",
  CACA: "teddy-bear",
  CAUN: "teddy-bear",
  CBYE: "teddy-bear",
  CSEA: "child-seat",
  CUCA: "teddy-bear",
  DGAT: "door-to-door",
  DRFF: "drinks-for-fee",
  DRIN: "drinks",
  DRNN: "drinks",
  DTDO: "door-to-door",
  DTDT: "door-to-door",
  ELUF: "extra-luggage-for-fee",
  ELUG: "extra-luggage",
  FBIF: "bike-for-fee",
  FBIC: "bicycle",
  FBIN: "bicycle",
  FTAB: "table-seat",
  FVAL: "flexible-validity",
  FRSN: "front-row-seat",
  CSER: "restaurant",
  FSNA: "snacks",
  SNAN: "snacks",
  GDOG: "giude-dog",
  LACC: "lounge",
  LOUN: "lounge",
  LOUF: "lounge-fee",
  MREQ: "mask-required",
  PALL: "pet-allowance",
  PALF: "pet-for-fee",
  QCAR: "quiet",
  QCOM: "quiet",
  REST: "restaurant",
  SSBA: "snowboard-bag-allowance",
  SSNO: "snowboard-bag-allowance",
  STVA: "table-seat",
  TABS: "table-seat",
  SKIT: "sleep-kit",
  VMOB: "vending-machine",
  WIFF: "wifi-for-fee",
  WSEA: "wider-seats",
  RARM: "reclining-armchairs",
  SKIF: "snowboard-bag-for-fee",
  SEAT: "seat-selection",
  HSAN: "hand-sanitizer",
  SBEL: "safety-belts",
  NOSA: "shop-check",
  SDIS: "social-distancing",
  PSER: "real-time",
  INFA: "buggy",
  FDEP: "frequent-departures",
  CODE: "missed-departure-flexibility",
  TBIN: "train-binding",
  NTBI: "flexible-train",
  NCTI: "public-transport-for-fee",
  CTIN: "ticket-included",
  NSRE: "seat-for-fee",
  SRES: "seat-selection-included",
  default: "star"
};
const getFareFeatureIcon = (code) => fareFeatureIconName[code] ?? fareFeatureIconName.default;
const getFareFeatures = (connection, fareSelection) => getFareClasses(connection, fareSelection).flatMap((item) => item.fareFeatures);
const hasFareClass = (connection, fareClassCode) => connection.fares.some(({ fareClass: { code } }) => code === fareClassCode);
const getFareClasses = (connection, { fareClassCode }) => {
  const carrierFareClasses = connection.segments.flatMap((item) => item.marketingCarrier.fareClasses);
  return carrierFareClasses.filter(
    ({ code }) => hasFareClass(connection, code) && (!fareClassCode || fareClassCode === code)
  );
};
const getUniqueFareClasses = (connections, filters) => {
  const fareClasses = connections.flatMap((connection) => getFareClasses(connection, filters));
  return uniqBy(fareClasses, "code");
};
const getUniqueFareFeatures = (connections, filters) => {
  const allFareFeatures = connections.flatMap((connection) => getFareFeatures(connection, filters));
  return uniqBy(allFareFeatures, "code");
};
const getFareByCode = (code, connection) => {
  if (!connection) return;
  const find2 = (code2) => connection.fares.find((item) => item.fareClass.code === code2);
  return find2(code) ?? find2(connection.cheapestFareClassCode);
};
const useDiscountCardsApi = () => {
  const { get } = useApi();
  return {
    load: get({
      type: "discountCards",
      old: "/cards",
      new: "/discount_cards"
    })
  };
};
const useDiscounts = (options, types) => {
  const discountCardsAPI = useDiscountCardsApi();
  const {
    retailerPartnerNumber,
    discounts: { marketingCarrierCodes },
    locale
  } = useSettings();
  return useQuery({
    queryKey: [discountCardsAPI, locale, retailerPartnerNumber, marketingCarrierCodes, types],
    queryFn: () => discountCardsAPI.load({
      locale,
      retailerPartnerNumber,
      types: ["discount_card", "loyalty"],
      marketingCarrierCodes
    }),
    staleTime: 1e3 * 60 * 10,
    cacheTime: 1e3 * 60,
    ...options
  });
};
const Amenity = ({ fareFeature, tooltipPosition = "top" }) => {
  const isMobile = useIsMobile();
  return /* @__PURE__ */ jsx(
    Tooltip,
    {
      action: isMobile ? "click" : "hover",
      content: /* @__PURE__ */ jsx("div", { className: "journey-card__footer-amenities-description", children: fareFeature.name }),
      position: tooltipPosition,
      children: /* @__PURE__ */ jsx("span", { className: "journey-card__footer-amenities-icon", children: /* @__PURE__ */ jsx(Icon, { name: getFareFeatureIcon(fareFeature.code), size: isMobile ? "medium" : "large" }) })
    }
  );
};
const LogoLink = ({ children }) => {
  const {
    logo: { redirectionUrl, handleClick },
    retailerPartnerNumber,
    marketingCarrierCode
  } = useSettings();
  if (handleClick) return /* @__PURE__ */ jsx("a", { onClick: handleClick, children });
  if (redirectionUrl) return /* @__PURE__ */ jsx("a", { href: redirectionUrl, children });
  return /* @__PURE__ */ jsx(
    Link,
    {
      "data-tag": "retail-partner-link",
      to: { pathname: "/", search: stringify({ retailerPartnerNumber, marketingCarrierCode }) },
      children
    }
  );
};
const poweredByDistribusionImage = "data:image/svg+xml,%3csvg%20width='135'%20height='13'%20viewBox='0%200%20135%2013'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M0.880682%2010V2.72727H3.33807C3.90862%202.72727%204.375%202.83026%204.73722%203.03622C5.1018%203.23982%205.37169%203.51562%205.54688%203.86364C5.72206%204.21165%205.80966%204.59991%205.80966%205.02841C5.80966%205.45691%205.72206%205.84635%205.54688%206.19673C5.37405%206.54711%205.10653%206.82647%204.74432%207.0348C4.3821%207.24077%203.91809%207.34375%203.35227%207.34375H1.59091V6.5625H3.32386C3.71449%206.5625%204.02817%206.49503%204.26491%206.36009C4.50166%206.22514%204.6733%206.04285%204.77983%205.81321C4.88873%205.5812%204.94318%205.3196%204.94318%205.02841C4.94318%204.73722%204.88873%204.4768%204.77983%204.24716C4.6733%204.01752%204.50047%203.83759%204.26136%203.70739C4.02225%203.57481%203.70502%203.50852%203.30966%203.50852H1.76136V10H0.880682ZM9.27202%2010.1136C8.77959%2010.1136%208.34754%209.99645%207.97585%209.76207C7.60653%209.5277%207.31771%209.19981%207.10938%208.77841C6.90341%208.35701%206.80043%207.86458%206.80043%207.30114C6.80043%206.73295%206.90341%206.23698%207.10938%205.81321C7.31771%205.38944%207.60653%205.06037%207.97585%204.82599C8.34754%204.59162%208.77959%204.47443%209.27202%204.47443C9.76444%204.47443%2010.1953%204.59162%2010.5646%204.82599C10.9363%205.06037%2011.2251%205.38944%2011.4311%205.81321C11.6394%206.23698%2011.7436%206.73295%2011.7436%207.30114C11.7436%207.86458%2011.6394%208.35701%2011.4311%208.77841C11.2251%209.19981%2010.9363%209.5277%2010.5646%209.76207C10.1953%209.99645%209.76444%2010.1136%209.27202%2010.1136ZM9.27202%209.3608C9.64607%209.3608%209.95384%209.26491%2010.1953%209.07315C10.4368%208.88139%2010.6155%208.62926%2010.7315%208.31676C10.8475%208.00426%2010.9055%207.66572%2010.9055%207.30114C10.9055%206.93655%2010.8475%206.59683%2010.7315%206.28196C10.6155%205.96709%2010.4368%205.71259%2010.1953%205.51847C9.95384%205.32434%209.64607%205.22727%209.27202%205.22727C8.89796%205.22727%208.5902%205.32434%208.34872%205.51847C8.10724%205.71259%207.9285%205.96709%207.8125%206.28196C7.6965%206.59683%207.63849%206.93655%207.63849%207.30114C7.63849%207.66572%207.6965%208.00426%207.8125%208.31676C7.9285%208.62926%208.10724%208.88139%208.34872%209.07315C8.5902%209.26491%208.89796%209.3608%209.27202%209.3608ZM14.0732%2010L12.4112%204.54545H13.2919L14.4709%208.72159H14.5277L15.6925%204.54545H16.5874L17.7379%208.70739H17.7947L18.9737%204.54545H19.8544L18.1925%2010H17.3686L16.1754%205.80966H16.0902L14.897%2010H14.0732ZM23.0637%2010.1136C22.5382%2010.1136%2022.0848%209.99763%2021.7037%209.76562C21.3249%209.53125%2021.0325%209.20455%2020.8265%208.78551C20.6229%208.36411%2020.5211%207.87405%2020.5211%207.31534C20.5211%206.75663%2020.6229%206.2642%2020.8265%205.83807C21.0325%205.40956%2021.319%205.07576%2021.6859%204.83665C22.0552%204.59517%2022.4861%204.47443%2022.9785%204.47443C23.2626%204.47443%2023.5431%204.52178%2023.8201%204.61648C24.0971%204.71117%2024.3493%204.86506%2024.5765%205.07812C24.8038%205.28883%2024.9849%205.56818%2025.1199%205.91619C25.2548%206.2642%2025.3223%206.69271%2025.3223%207.2017V7.55682H21.1177V6.83239H24.47C24.47%206.52462%2024.4084%206.25%2024.2853%206.00852C24.1646%205.76705%2023.9918%205.57647%2023.7669%205.43679C23.5443%205.29711%2023.2815%205.22727%2022.9785%205.22727C22.6447%205.22727%2022.3559%205.31013%2022.112%205.47585C21.8706%205.6392%2021.6847%205.85227%2021.5545%206.11506C21.4243%206.37784%2021.3592%206.65956%2021.3592%206.96023V7.44318C21.3592%207.85511%2021.4302%208.20431%2021.5723%208.49077C21.7167%208.77486%2021.9167%208.99148%2022.1724%209.14062C22.4281%209.28741%2022.7252%209.3608%2023.0637%209.3608C23.2839%209.3608%2023.4828%209.33002%2023.6603%209.26847C23.8403%209.20455%2023.9953%209.10985%2024.1255%208.98438C24.2557%208.85653%2024.3564%208.69792%2024.4274%208.50852L25.237%208.7358C25.1518%209.01042%2025.0086%209.25189%2024.8074%209.46023C24.6061%209.66619%2024.3575%209.82718%2024.0616%209.94318C23.7657%2010.0568%2023.4331%2010.1136%2023.0637%2010.1136ZM26.5971%2010V4.54545H27.4068V5.36932H27.4636C27.563%205.09943%2027.743%204.88045%2028.0034%204.71236C28.2638%204.54427%2028.5574%204.46023%2028.8841%204.46023C28.9456%204.46023%2029.0225%204.46141%2029.1149%204.46378C29.2072%204.46615%2029.277%204.4697%2029.3244%204.47443V5.3267C29.296%205.3196%2029.2309%205.30895%2029.1291%205.29474C29.0297%205.27817%2028.9243%205.26989%2028.813%205.26989C28.5479%205.26989%2028.3111%205.32552%2028.1028%205.43679C27.8968%205.54569%2027.7335%205.69721%2027.6127%205.89134C27.4944%206.0831%2027.4352%206.30208%2027.4352%206.5483V10H26.5971ZM32.4387%2010.1136C31.9132%2010.1136%2031.4598%209.99763%2031.0787%209.76562C30.6999%209.53125%2030.4075%209.20455%2030.2015%208.78551C29.9979%208.36411%2029.8961%207.87405%2029.8961%207.31534C29.8961%206.75663%2029.9979%206.2642%2030.2015%205.83807C30.4075%205.40956%2030.694%205.07576%2031.0609%204.83665C31.4302%204.59517%2031.8611%204.47443%2032.3535%204.47443C32.6376%204.47443%2032.9181%204.52178%2033.1951%204.61648C33.4721%204.71117%2033.7243%204.86506%2033.9515%205.07812C34.1788%205.28883%2034.3599%205.56818%2034.4949%205.91619C34.6298%206.2642%2034.6973%206.69271%2034.6973%207.2017V7.55682H30.4927V6.83239H33.845C33.845%206.52462%2033.7834%206.25%2033.6603%206.00852C33.5396%205.76705%2033.3668%205.57647%2033.1419%205.43679C32.9193%205.29711%2032.6565%205.22727%2032.3535%205.22727C32.0197%205.22727%2031.7309%205.31013%2031.487%205.47585C31.2456%205.6392%2031.0597%205.85227%2030.9295%206.11506C30.7993%206.37784%2030.7342%206.65956%2030.7342%206.96023V7.44318C30.7342%207.85511%2030.8052%208.20431%2030.9473%208.49077C31.0917%208.77486%2031.2917%208.99148%2031.5474%209.14062C31.8031%209.28741%2032.1002%209.3608%2032.4387%209.3608C32.6589%209.3608%2032.8578%209.33002%2033.0353%209.26847C33.2153%209.20455%2033.3703%209.10985%2033.5005%208.98438C33.6307%208.85653%2033.7314%208.69792%2033.8024%208.50852L34.612%208.7358C34.5268%209.01042%2034.3836%209.25189%2034.1824%209.46023C33.9811%209.66619%2033.7325%209.82718%2033.4366%209.94318C33.1407%2010.0568%2032.8081%2010.1136%2032.4387%2010.1136ZM38.0318%2010.1136C37.5772%2010.1136%2037.176%209.99882%2036.8279%209.76918C36.4799%209.53717%2036.2077%209.21046%2036.0112%208.78906C35.8147%208.36529%2035.7164%207.86458%2035.7164%207.28693C35.7164%206.71402%2035.8147%206.21686%2036.0112%205.79545C36.2077%205.37405%2036.4811%205.04853%2036.8315%204.81889C37.1819%204.58925%2037.5867%204.47443%2038.046%204.47443C38.4011%204.47443%2038.6816%204.53362%2038.8876%204.65199C39.0959%204.76799%2039.2546%204.90057%2039.3635%205.04972C39.4747%205.1965%2039.5611%205.31723%2039.6227%205.41193H39.6937V2.72727H40.5318V10H39.7221V9.16193H39.6227C39.5611%209.26136%2039.4735%209.38684%2039.3599%209.53835C39.2463%209.6875%2039.0841%209.82126%2038.8734%209.93963C38.6627%2010.0556%2038.3822%2010.1136%2038.0318%2010.1136ZM38.1454%209.3608C38.4816%209.3608%2038.7657%209.2732%2038.9977%209.09801C39.2297%208.92045%2039.4061%208.67543%2039.5268%208.36293C39.6475%208.04806%2039.7079%207.68466%2039.7079%207.27273C39.7079%206.86553%2039.6487%206.50923%2039.5304%206.20384C39.412%205.89607%2039.2368%205.65696%2039.0048%205.48651C38.7728%205.31368%2038.4863%205.22727%2038.1454%205.22727C37.7903%205.22727%2037.4944%205.31842%2037.2576%205.50071C37.0233%205.68063%2036.8469%205.92566%2036.7285%206.2358C36.6125%206.54356%2036.5545%206.8892%2036.5545%207.27273C36.5545%207.66098%2036.6137%208.01373%2036.7321%208.33097C36.8528%208.64583%2037.0304%208.89678%2037.2647%209.08381C37.5015%209.26847%2037.795%209.3608%2038.1454%209.3608ZM45.1092%2010V2.72727H45.9473V5.41193H46.0183C46.0798%205.31723%2046.1651%205.1965%2046.274%205.04972C46.3852%204.90057%2046.5439%204.76799%2046.7498%204.65199C46.9582%204.53362%2047.2399%204.47443%2047.595%204.47443C48.0543%204.47443%2048.4591%204.58925%2048.8095%204.81889C49.1599%205.04853%2049.4333%205.37405%2049.6298%205.79545C49.8263%206.21686%2049.9245%206.71402%2049.9245%207.28693C49.9245%207.86458%2049.8263%208.36529%2049.6298%208.78906C49.4333%209.21046%2049.161%209.53717%2048.813%209.76918C48.465%209.99882%2048.0637%2010.1136%2047.6092%2010.1136C47.2588%2010.1136%2046.9783%2010.0556%2046.7676%209.93963C46.5569%209.82126%2046.3947%209.6875%2046.2811%209.53835C46.1674%209.38684%2046.0798%209.26136%2046.0183%209.16193H45.9189V10H45.1092ZM45.9331%207.27273C45.9331%207.68466%2045.9934%208.04806%2046.1142%208.36293C46.2349%208.67543%2046.4113%208.92045%2046.6433%209.09801C46.8753%209.2732%2047.1594%209.3608%2047.4956%209.3608C47.8459%209.3608%2048.1383%209.26847%2048.3727%209.08381C48.6094%208.89678%2048.787%208.64583%2048.9054%208.33097C49.0261%208.01373%2049.0865%207.66098%2049.0865%207.27273C49.0865%206.8892%2049.0273%206.54356%2048.9089%206.2358C48.7929%205.92566%2048.6165%205.68063%2048.3798%205.50071C48.1454%205.31842%2047.8507%205.22727%2047.4956%205.22727C47.1547%205.22727%2046.8682%205.31368%2046.6362%205.48651C46.4042%205.65696%2046.229%205.89607%2046.1106%206.20384C45.9922%206.50923%2045.9331%206.86553%2045.9331%207.27273ZM51.551%2012.0455C51.4089%2012.0455%2051.2823%2012.0336%2051.171%2012.0099C51.0597%2011.9886%2050.9828%2011.9673%2050.9402%2011.946L51.1532%2011.2074C51.3568%2011.2595%2051.5368%2011.2784%2051.693%2011.2642C51.8493%2011.25%2051.9877%2011.1802%2052.1085%2011.0547C52.2316%2010.9316%2052.344%2010.7315%2052.4458%2010.4545L52.6021%2010.0284L50.585%204.54545H51.4941L52.9998%208.89205H53.0566L54.5623%204.54545H55.4714L53.1561%2010.7955C53.0519%2011.0772%2052.9229%2011.3104%2052.769%2011.495C52.6151%2011.6821%2052.4364%2011.8205%2052.2328%2011.9105C52.0315%2012.0005%2051.8043%2012.0455%2051.551%2012.0455Z'%20fill='%23848388'/%3e%3cg%20clip-path='url(%23clip0_13200_9599)'%3e%3cpath%20d='M73.144%204.43436C72.5523%203.38067%2071.9338%202.29996%2071.3152%201.24628C70.9655%200.624869%2070.4545%200.354692%2069.7553%200.38171C69.2617%200.390086%2068.4815%200.363068%2067.4154%200.38171C68.1685%201.67856%2068.9215%202.97541%2069.6746%204.29927C69.9973%204.89366%2069.9973%205.48805%2069.6746%206.08244C68.9484%207.37929%2067.4423%209.97298%2067.4423%2010C68.3029%2010%2069.1367%2010%2069.9973%2010C70.5352%2010%2070.9386%209.75684%2071.2076%209.29754C71.8531%208.18982%2072.4986%207.08209%2073.144%205.94735C73.413%205.43401%2073.413%204.92068%2073.144%204.43436Z'%20fill='%232B4466'/%3e%3cpath%20d='M67.8457%204.59629C67.3347%203.70471%2066.8237%202.81312%2066.3127%201.94856C66.0975%201.59733%2065.8017%201.4082%2065.3983%201.4082C65.3445%201.4082%2064.6721%201.4082%2064.6721%201.4082C64.3762%201.4082%2064.1611%201.59733%2063.9997%201.94856C63.6232%202.84014%2063.2198%203.70471%2062.8432%204.59629C62.8432%204.62331%2062.8163%204.65032%2062.8163%204.67734C62.7894%204.73138%2062.7625%204.78541%2062.7625%204.83945C62.7625%204.86647%2062.7625%204.86646%2062.7625%204.89348C62.7088%205.19068%2062.7357%205.48787%2062.8701%205.75805C63.2198%206.5956%2063.5694%207.40613%2063.919%208.21666C64.1073%208.62192%2064.3493%208.86508%2064.6721%208.8921C64.699%208.8921%2065.1562%208.8921%2065.21%208.8921C65.7479%208.91912%2066.1513%208.67596%2066.4203%208.21666C66.9044%207.37911%2067.3885%206.54156%2067.8457%205.70401C68.0609%205.3798%2068.0609%204.97454%2067.8457%204.59629Z'%20fill='%232B4466'/%3e%3cpath%20d='M77.7431%209.75732C77.2321%209.75732%2076.8018%209.70328%2076.4522%209.59521C76.1025%209.48714%2075.8336%209.32504%2075.6184%209.08188C75.4033%208.83872%2075.2688%208.54152%2075.1612%208.19029C75.0805%207.81205%2075.0267%207.37976%2075.0267%206.83941V6.40713C75.0267%205.92081%2075.0536%205.51554%2075.1343%205.16431C75.215%204.81308%2075.3495%204.51589%2075.5646%204.27273C75.7529%204.02957%2076.0487%203.84045%2076.3715%203.73238C76.7211%203.62431%2077.1514%203.54325%2077.6893%203.54325C78.0659%203.54325%2078.3886%203.59729%2078.6844%203.67834C78.9803%203.7594%2079.1955%203.86747%2079.3299%204.00255V1.78711L80.5402%201.625V8.78468C80.5402%209.13591%2080.4595%209.40609%2080.2981%209.54118C80.1368%209.70328%2079.814%209.78434%2079.3568%209.78434L77.7431%209.75732ZM79.3568%208.75766V6.02888C79.3568%205.73169%2079.3299%205.48853%2079.2761%205.27239C79.2223%205.08326%2079.1417%204.92116%2079.0341%204.81308C78.9265%204.70501%2078.7651%204.62396%2078.55%204.59694C78.3617%204.56993%2078.1197%204.54291%2077.7969%204.54291C77.4742%204.54291%2077.2052%204.56993%2077.017%204.62396C76.8287%204.678%2076.6673%204.75905%2076.5597%204.89414C76.4522%205.02923%2076.3715%205.21835%2076.3446%205.46151C76.3177%205.70467%2076.2908%206.00186%2076.2908%206.40713V6.83941C76.2908%207.24467%2076.3177%207.56889%2076.3446%207.81205C76.3715%208.0552%2076.4522%208.24433%2076.5597%208.40643C76.6673%208.54152%2076.8287%208.64959%2077.017%208.67661C77.2052%208.73065%2077.4742%208.75766%2077.8238%208.75766H79.3568Z'%20fill='%232B4466'/%3e%3cpath%20d='M81.9119%203.73242H83.1221V9.75736H81.9119V3.73242Z'%20fill='%232B4466'/%3e%3cpath%20d='M87.6673%206.19038C88.017%206.2174%2088.2859%206.29845%2088.5011%206.40652C88.7162%206.51459%2088.8776%206.64968%2089.0121%206.81178C89.1197%206.97389%2089.2003%207.136%2089.2541%207.32512C89.3079%207.51424%2089.3079%207.67635%2089.3079%207.86547V8.02758C89.3079%208.56793%2089.1197%209.00022%2088.7162%209.32443C88.3128%209.62162%2087.7211%209.78373%2086.8874%209.78373C86.5377%209.78373%2086.1343%209.78373%2085.6771%209.78373C85.2199%209.78373%2084.7627%209.78373%2084.2786%209.75671L84.4937%208.73004C84.924%208.73004%2085.3275%208.75706%2085.7578%208.75706C86.1881%208.75706%2086.5915%208.75706%2086.9412%208.75706C87.3984%208.75706%2087.6942%208.70302%2087.8556%208.59495C88.017%208.48688%2088.0976%208.29776%2088.0976%208.00056C88.0976%207.91951%2088.0976%207.81144%2088.0708%207.73038C88.0439%207.64933%2088.017%207.56828%2087.9632%207.51424C87.9094%207.46021%2087.8287%207.40617%2087.7211%207.35214C87.6135%207.2981%2087.4791%207.27108%2087.2908%207.27108L85.8923%207.136C85.5964%207.10898%2085.3544%207.05494%2085.1661%206.94687C84.9778%206.8388%2084.7896%206.73073%2084.682%206.59564C84.5475%206.46055%2084.4668%206.29845%2084.413%206.10932C84.3592%205.9202%2084.3324%205.75809%2084.3324%205.56897V5.37985C84.3324%204.83949%2084.5206%204.43423%2084.8703%204.13703C85.2468%203.83984%2085.8385%203.67773%2086.6453%203.67773C87.0219%203.67773%2087.3984%203.67773%2087.8018%203.67773C88.2052%203.67773%2088.6624%203.67773%2089.1466%203.70475L88.9314%204.73142C88.6087%204.73142%2088.3128%204.70441%2088.0708%204.70441C87.8287%204.70441%2087.6135%204.70441%2087.4253%204.70441C87.237%204.70441%2087.0756%204.70441%2086.9143%204.70441C86.7529%204.70441%2086.6184%204.70441%2086.5108%204.70441C86.1074%204.70441%2085.8385%204.75844%2085.6771%204.83949C85.5157%204.94757%2085.435%205.10967%2085.435%205.35283C85.435%205.4609%2085.435%205.54195%2085.4619%205.62301C85.4888%205.70406%2085.5157%205.7581%2085.5695%205.81213C85.6233%205.86617%2085.704%205.9202%2085.8116%205.94722C85.9192%205.97424%2086.0805%206.00125%2086.2688%206.02827L87.6673%206.19038Z'%20fill='%232B4466'/%3e%3cpath%20d='M98.5868%203.89453L99.7971%203.73242V9.59526L98.5868%209.75736V3.89453Z'%20fill='%232B4466'/%3e%3cpath%20d='M104.073%203.54323C104.584%203.54323%20105.014%203.59727%20105.337%203.73235C105.687%203.84042%20105.956%204.02955%20106.144%204.27271C106.359%204.51587%20106.494%204.81306%20106.574%205.16429C106.655%205.51552%20106.709%205.9478%20106.709%206.4071V7.05553C106.709%207.54184%20106.655%207.94711%20106.574%208.32536C106.494%208.7036%20106.332%209.0008%20106.117%209.21694C105.902%209.4601%20105.606%209.64922%20105.23%209.75729C104.853%209.86536%20104.396%209.9194%20103.831%209.9194C103.347%209.9194%20102.944%209.86537%20102.594%209.78431C102.244%209.70326%20101.975%209.54115%20101.733%209.32501C101.518%209.10887%20101.357%208.81168%20101.249%208.43343C101.142%208.05518%20101.088%207.59588%20101.088%207.05553V0.571286L102.298%200.40918V4.00253C102.486%203.84042%20102.701%203.73235%20102.97%203.6513C103.293%203.57025%20103.643%203.54323%20104.073%203.54323ZM103.939%204.54288C103.616%204.54288%20103.347%204.5699%20103.132%204.62394C102.917%204.67797%20102.755%204.75902%20102.648%204.8671C102.54%205.00218%20102.459%205.16429%20102.406%205.38043C102.352%205.59657%20102.352%205.86675%20102.352%206.19096V7.05553C102.352%207.46079%20102.379%207.785%20102.406%208.02816C102.433%208.27132%20102.513%208.46045%20102.648%208.59553C102.755%208.73062%20102.917%208.81168%20103.132%208.86571C103.32%208.91975%20103.589%208.91975%20103.912%208.91975C104.208%208.91975%20104.477%208.89273%20104.665%208.86571C104.853%208.83869%20105.014%208.73062%20105.149%208.62255C105.256%208.48746%20105.337%208.29834%20105.391%208.05518C105.445%207.81202%20105.472%207.46079%20105.472%207.05553V6.46114C105.472%206.02886%20105.445%205.70464%20105.391%205.46148C105.337%205.21833%20105.256%205.00218%20105.149%204.8671C105.041%204.73201%20104.88%204.62394%20104.692%204.59692C104.503%204.5699%20104.261%204.54288%20103.939%204.54288Z'%20fill='%232B4466'/%3e%3cpath%20d='M110.555%209.94649C109.667%209.94649%20109.022%209.8114%20108.592%209.5142C108.161%209.21701%20107.919%208.70367%20107.919%208.00121V3.73242L109.129%203.89453V7.73104C109.129%207.92016%20109.129%208.10928%20109.156%208.24437C109.183%208.37946%20109.237%208.51455%20109.318%208.62262C109.398%208.73069%20109.56%208.81174%20109.748%208.83876C109.936%208.8928%20110.205%208.91982%20110.528%208.91982C110.851%208.91982%20111.12%208.8928%20111.308%208.83876C111.496%208.78473%20111.631%208.70367%20111.738%208.62262C111.819%208.51455%20111.9%208.40648%20111.9%208.24437C111.927%208.10928%20111.927%207.92016%20111.927%207.73104V3.89453L113.137%203.73242V7.9742C113.137%208.67666%20112.922%209.18999%20112.464%209.48719C112.088%209.78438%20111.416%209.94649%20110.555%209.94649Z'%20fill='%232B4466'/%3e%3cpath%20d='M120.533%203.89453L121.743%203.73242V9.59526L120.533%209.75736V3.89453Z'%20fill='%232B4466'/%3e%3cpath%20d='M125.777%203.54297C126.288%203.54297%20126.719%203.597%20127.068%203.67806C127.418%203.75911%20127.714%203.92122%20127.929%204.13736C128.144%204.3535%20128.305%204.65069%20128.413%205.02894C128.521%205.40719%20128.574%205.86649%20128.574%206.43386V7.08228C128.574%207.64965%20128.521%208.10895%20128.413%208.4872C128.305%208.86545%20128.144%209.16264%20127.929%209.37879C127.714%209.59493%20127.418%209.75703%20127.068%209.83809C126.719%209.91914%20126.288%209.97317%20125.777%209.97317C125.266%209.97317%20124.836%209.91914%20124.486%209.83809C124.137%209.75703%20123.841%209.59493%20123.626%209.37879C123.411%209.16264%20123.249%208.86545%20123.142%208.4872C123.034%208.10895%20122.98%207.64965%20122.98%207.08228V6.43386C122.98%205.86649%20123.034%205.40719%20123.142%205.02894C123.249%204.65069%20123.411%204.3535%20123.626%204.13736C123.841%203.92122%20124.137%203.75911%20124.486%203.67806C124.836%203.56999%20125.266%203.54297%20125.777%203.54297ZM127.31%206.40684C127.31%206.00158%20127.283%205.67736%20127.257%205.43421C127.203%205.19105%20127.149%205.00192%20127.014%204.86683C126.907%204.73175%20126.746%204.65069%20126.557%204.59666C126.369%204.54262%20126.1%204.54262%20125.777%204.54262C125.455%204.54262%20125.186%204.56964%20124.997%204.59666C124.809%204.65069%20124.648%204.73175%20124.54%204.86683C124.433%205.00192%20124.352%205.19105%20124.298%205.43421C124.244%205.67736%20124.244%206.00158%20124.244%206.40684V7.05527C124.244%207.46053%20124.271%207.78474%20124.298%208.0279C124.352%208.27106%20124.406%208.46018%20124.54%208.59527C124.648%208.73036%20124.809%208.81141%20124.997%208.86545C125.186%208.91949%20125.455%208.91949%20125.777%208.91949C126.1%208.91949%20126.369%208.89247%20126.557%208.86545C126.746%208.81141%20126.907%208.73036%20127.014%208.59527C127.122%208.46018%20127.203%208.27106%20127.257%208.0279C127.31%207.78474%20127.31%207.46053%20127.31%207.05527V6.40684Z'%20fill='%232B4466'/%3e%3cpath%20d='M129.785%209.75671V5.48791C129.785%204.78546%20130%204.29914%20130.43%203.97493C130.861%203.67773%20131.533%203.51562%20132.447%203.51562C133.362%203.51562%20134.034%203.67773%20134.465%203.97493C134.895%204.27212%20135.11%204.78546%20135.11%205.48791V9.40548L133.9%209.72969V5.73107C133.9%205.54195%20133.9%205.35283%20133.873%205.21774C133.846%205.08265%20133.792%204.94756%20133.711%204.83949C133.631%204.73142%20133.469%204.65037%20133.281%204.62335C133.093%204.56931%20132.824%204.5423%20132.474%204.5423C132.125%204.5423%20131.856%204.56931%20131.667%204.62335C131.479%204.67738%20131.318%204.75844%20131.237%204.83949C131.156%204.94756%20131.076%205.05563%20131.076%205.21774C131.049%205.35283%20131.049%205.54195%20131.049%205.73107V9.72969H129.785V9.75671Z'%20fill='%232B4466'/%3e%3cpath%20d='M119.269%207.32447C119.215%207.13535%20119.134%206.97324%20119.027%206.81113C118.919%206.64903%20118.758%206.51394%20118.516%206.40587C118.301%206.2978%20118.005%206.21674%20117.682%206.18973L116.337%206.05464C116.149%206.02762%20116.015%206.0006%20115.88%205.97359C115.772%205.94657%20115.692%205.89253%20115.638%205.8385C115.584%205.78446%20115.53%205.73043%20115.53%205.64937C115.504%205.56832%20115.504%205.48727%20115.504%205.3792C115.504%205.13604%20115.584%204.94691%20115.746%204.86586C115.907%204.75779%20116.176%204.73077%20116.579%204.73077C116.714%204.73077%20116.848%204.73077%20116.983%204.73077C117.144%204.73077%20117.305%204.73077%20117.494%204.73077C117.682%204.73077%20117.897%204.73077%20118.139%204.73077C118.381%204.73077%20118.677%204.73077%20119%204.75779L119.215%203.73112C118.704%203.7041%20118.247%203.7041%20117.87%203.7041C117.467%203.7041%20117.09%203.7041%20116.714%203.7041C115.88%203.7041%20115.288%203.86621%20114.939%204.1634C114.562%204.4606%20114.401%204.86586%20114.401%205.40621V5.59534C114.401%205.78446%20114.428%205.97359%20114.482%206.13569C114.535%206.32482%20114.643%206.48692%20114.75%206.62201C114.885%206.7571%20115.046%206.89219%20115.235%206.97324C115.423%207.08131%20115.692%207.13535%20115.961%207.16236L117.359%207.29745C117.548%207.32447%20117.682%207.35149%20117.79%207.3785C117.897%207.43254%20117.978%207.48657%20118.032%207.54061C118.085%207.59465%20118.139%207.6757%20118.139%207.75675C118.166%207.83781%20118.166%207.91886%20118.166%208.02693C118.166%208.32412%20118.085%208.51325%20117.924%208.62132C117.763%208.72939%20117.44%208.78342%20117.01%208.78342C116.66%208.78342%20116.283%208.78342%20115.826%208.78342C115.45%208.78342%20114.777%208.78342%20114.347%208.75641V9.75606C114.804%209.75606%20115.261%209.78308%20115.746%209.78308C116.203%209.78308%20116.606%209.78308%20116.956%209.78308C117.763%209.78308%20118.381%209.62097%20118.785%209.32378C119.188%209.02658%20119.376%208.5943%20119.376%208.02693V7.86482C119.35%207.6757%20119.323%207.51359%20119.269%207.32447Z'%20fill='%232B4466'/%3e%3cpath%20d='M92.4008%208.75765C92.2664%208.75765%2092.1588%208.73063%2092.0781%208.73063C91.9436%208.70362%2091.836%208.64958%2091.7553%208.56853C91.6747%208.48747%2091.6209%208.35239%2091.594%208.19028C91.5671%208.02817%2091.5402%207.81203%2091.5402%207.56887V4.73202H93.2884L93.5035%203.70535H91.5671V0.976562L90.3568%201.1927V7.56887C90.3568%208.00116%2090.3837%208.32537%2090.4644%208.62256C90.5182%208.89274%2090.6527%209.1359%2090.814%209.298C90.9754%209.46011%2091.2175%209.5952%2091.5133%209.64923C91.7016%209.70327%2091.9436%209.73029%2092.2126%209.73029L92.4008%208.75765Z'%20fill='%232B4466'/%3e%3cpath%20d='M96.7041%204.70441C96.8117%204.70441%2096.9193%204.70441%2097.0537%204.70441C97.1613%204.70441%2097.242%204.70441%2097.3227%204.70441L97.5379%203.67773C97.511%203.67773%2097.4841%203.67773%2097.4303%203.67773C97.242%203.67773%2096.9462%203.67773%2096.5696%203.67773C96.22%203.67773%2095.9242%203.70475%2095.6283%203.78581C95.3594%203.86686%2095.1173%203.97493%2094.9022%204.11002C94.7139%204.27212%2094.5525%204.46125%2094.4449%204.70441C94.3374%204.94757%2094.2836%205.24476%2094.2836%205.59599V9.72969L95.4938%209.56759V5.89318C95.4938%205.70406%2095.4938%205.54195%2095.5207%205.37985C95.5476%205.24476%2095.6014%205.10967%2095.6552%205.0016C95.7359%204.89353%2095.8435%204.81248%2096.0048%204.78546C96.22%204.73142%2096.4352%204.70441%2096.7041%204.70441Z'%20fill='%232B4466'/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_13200_9599'%3e%3crect%20width='74'%20height='12'%20fill='white'%20transform='translate(61)'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e";
const PoweredByDistribusion = () => {
  const { t } = useTranslation();
  return /* @__PURE__ */ jsx(
    "img",
    {
      className: "powered-by-distribusion-image",
      src: poweredByDistribusionImage,
      alt: t("accessibility.images.distribusionLogo")
    }
  );
};
const Logo = ({ showDistribusionBranding, url, clickable = true }) => {
  const { t } = useTranslation();
  const logoContent = /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("img", { src: url, className: "logo-image", alt: t("accessibility.images.homePageLink"), "data-tag": "logo" }),
    showDistribusionBranding && /* @__PURE__ */ jsx(PoweredByDistribusion, {})
  ] });
  return /* @__PURE__ */ jsx("div", { className: "partner-logo", children: clickable ? /* @__PURE__ */ jsx(LogoLink, { children: logoContent }) : logoContent });
};
const DeckLevelSelector = ({ level, levels, onChange }) => {
  const { t } = useTranslation();
  const tabs = useMemo(() => {
    const minLabel = Math.min(...levels);
    return levels.map((value) => ({ value, label: value === minLabel ? t("seats.lower_deck") : t("seats.upper_deck") }));
  }, [levels, t]);
  return /* @__PURE__ */ jsx("div", { "data-tag": "deck-level-selector", className: bem("seat-selection", "tabs-level"), children: /* @__PURE__ */ jsx(Tabs, { options: tabs, value: level, variant: "outlined", onClick: onChange }) });
};
function toggleArrayItem(value, array, key) {
  {
    return array.some((item) => item[key] === value[key]) ? array.filter((item) => item[key] !== value[key]) : [...array, value];
  }
}
const useItemsSelection = (initialSelection) => {
  const [items, setItems] = useReactiveState(
    () => initialSelection ?? { outbound: {}, inbound: {} },
    [initialSelection]
  );
  const toggle = useCallback(
    (seat, direction, segment) => {
      setItems((items2) => {
        const selectedSeats = items2[direction][segment] ?? [];
        return {
          ...items2,
          [direction]: {
            ...items2[direction],
            [segment]: toggleArrayItem({ ...seat, segmentIndex: segment }, selectedSeats, "code")
          }
        };
      });
    },
    [setItems]
  );
  return useMemo(
    () => ({
      items,
      toggle,
      set: setItems,
      clear: () => setItems({ outbound: {}, inbound: {} })
    }),
    [items, setItems, toggle]
  );
};
const DISCOUNT_ALTERNATIVE = {
  ANTT_Senior_100: "ANTT_Senior_50"
};
const AlternativeDiscountModal = (props) => {
  const { opened, selectedDiscount, setSelectedDiscount, onCloseTrip, onClose, discounts } = props;
  const { t } = useTranslation();
  const alternativeDiscount = useMemo(() => {
    const name = selectedDiscount && DISCOUNT_ALTERNATIVE[selectedDiscount];
    return name && discounts ? find(discounts, { name }) : null;
  }, [discounts, selectedDiscount]);
  const onModalClose = () => {
    onClose();
    onCloseTrip();
  };
  const onAlternativeDiscountSelected = () => {
    setSelectedDiscount(alternativeDiscount?.name ?? null);
    onClose();
  };
  return /* @__PURE__ */ jsx(
    Modal,
    {
      opened,
      onClose: onModalClose,
      maxWidth: "md",
      title: t("seats.limitedModal.title"),
      className: bem("limited-seats-taken", "modal"),
      footer: /* @__PURE__ */ jsxs("div", { className: "p-4 row gap-3 center", children: [
        /* @__PURE__ */ jsx("div", { className: "cell shrink no-grow basis-auto", children: /* @__PURE__ */ jsx(Button, { onClick: onAlternativeDiscountSelected, children: t(`seats.limitedModal.alternative.${alternativeDiscount ? "specific" : "all"}`, {
          discount: alternativeDiscount?.marketingName
        }) }) }),
        /* @__PURE__ */ jsx("div", { className: "cell shrink no-grow basis-auto", children: /* @__PURE__ */ jsx(Button, { onClick: onModalClose, variant: "outline", children: t("seats.limitedModal.cancel") }) })
      ] }),
      children: /* @__PURE__ */ jsx("div", { className: "p-4 text-center", children: t("seats.limitedModal.description") })
    }
  );
};
const DeckContext = createContext({
  orientation: "right",
  isTrainHead: false,
  size: { length: 15, width: 5, height: 1 }
});
const DeckFrame = (props) => {
  const {
    children,
    orientation,
    isTrainHead = false,
    lights,
    dense,
    size = { length: 15, width: 5, height: 1 },
    bus
  } = props;
  const setDeckSize = useCallback(
    (element) => {
      if (element) {
        element.style.setProperty("--rows", size.width.toString());
        element.style.setProperty("--columns", size.length.toString());
      }
    },
    [size.length, size.width]
  );
  return /* @__PURE__ */ jsxs(
    "div",
    {
      "data-tag": "seat-selection-deck",
      className: bem("seat-selection", "deck-wrapper", { [orientation]: true, head: isTrainHead, dense, bus }),
      ref: setDeckSize,
      children: [
        lights && /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx("div", { className: bem("seat-selection", "lights", { left: true }) }),
          /* @__PURE__ */ jsx("div", { className: bem("seat-selection", "lights", { right: true }) })
        ] }),
        /* @__PURE__ */ jsx("div", { className: bem("seat-selection", "deck"), children: /* @__PURE__ */ jsx(DeckContext.Provider, { value: { orientation, isTrainHead, size }, children }) })
      ]
    }
  );
};
function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
var classnames = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var hasRequiredClassnames;
function requireClassnames() {
  if (hasRequiredClassnames) return classnames.exports;
  hasRequiredClassnames = 1;
  (function(module) {
    (function() {
      var hasOwn = {}.hasOwnProperty;
      function classNames() {
        var classes = "";
        for (var i = 0; i < arguments.length; i++) {
          var arg = arguments[i];
          if (arg) {
            classes = appendClass(classes, parseValue(arg));
          }
        }
        return classes;
      }
      function parseValue(arg) {
        if (typeof arg === "string" || typeof arg === "number") {
          return arg;
        }
        if (typeof arg !== "object") {
          return "";
        }
        if (Array.isArray(arg)) {
          return classNames.apply(null, arg);
        }
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) {
          return arg.toString();
        }
        var classes = "";
        for (var key in arg) {
          if (hasOwn.call(arg, key) && arg[key]) {
            classes = appendClass(classes, key);
          }
        }
        return classes;
      }
      function appendClass(value, newClass) {
        if (!newClass) {
          return value;
        }
        if (value) {
          return value + " " + newClass;
        }
        return value + newClass;
      }
      if (module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
      } else {
        window.classNames = classNames;
      }
    })();
  })(classnames);
  return classnames.exports;
}
var classnamesExports = requireClassnames();
const cn = /* @__PURE__ */ getDefaultExportFromCjs(classnamesExports);
const bigTable = "data:image/svg+xml,%3csvg%20width='60'%20height='120'%20viewBox='0%200%2060%20120'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20clip-path='url(%23clip0_4_615)'%3e%3cpath%20d='M52%200L52%20105C52%20109.418%2048.4183%20113%2044%20113H16C11.5817%20113%208%20109.418%208%20105L8%200L52%200Z'%20fill='%23DEDDE3'/%3e%3cpath%20d='M44%200V3C44%205.20914%2042.2091%207%2040%207L20%207C17.7909%207%2016%205.20914%2016%203V0L44%200Z'%20fill='%23BBBAC5'/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_4_615'%3e%3crect%20x='60'%20width='120'%20height='60'%20rx='4'%20transform='rotate(90%2060%200)'%20fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e";
const lWall = "data:image/svg+xml,%3csvg%20width='60'%20height='180'%20viewBox='0%200%2060%20180'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20clip-path='url(%23clip0_8_4)'%3e%3crect%20x='2'%20y='180'%20width='2'%20height='180'%20transform='rotate(-180%202%20180)'%20fill='%23BBBAC5'/%3e%3crect%20x='40'%20y='180'%20width='40'%20height='2'%20transform='rotate(-180%2040%20180)'%20fill='%23BBBAC5'/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_8_4'%3e%3crect%20width='60'%20height='180'%20fill='white'%20transform='matrix(-1%200%200%20-1%2060%20180)'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e";
const smallTable = "data:image/svg+xml,%3csvg%20width='60'%20height='60'%20viewBox='0%200%2060%2060'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M52%200L52%2043C52%2047.4183%2048.4183%2051%2044%2051L16%2051C11.5817%2051%208%2047.4183%208%2043L8%200L52%200Z'%20fill='%23DEDDE3'/%3e%3cpath%20d='M44%200V3C44%205.20914%2042.2091%207%2040%207L20%207C17.7909%207%2016%205.20914%2016%203V0L44%200Z'%20fill='%23848388'/%3e%3c/svg%3e";
const smallWall = "data:image/svg+xml,%3csvg%20width='15'%20height='60'%20viewBox='0%200%2015%2060'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20clip-path='url(%23clip0_3_3)'%3e%3crect%20x='6'%20y='60'%20width='2'%20height='60'%20transform='rotate(180%206%2060)'%20fill='%23BBBAC5'/%3e%3crect%20x='2'%20y='60'%20width='2'%20height='61'%20transform='rotate(180%202%2060)'%20fill='%23BBBAC5'/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_3_3'%3e%3crect%20width='15'%20height='60'%20fill='white'%20transform='matrix(-1%200%200%20-1%2015%2060)'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e";
const stairs = "data:image/svg+xml,%3csvg%20width='60'%20height='120'%20viewBox='0%200%2060%20120'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20clip-path='url(%23clip0_16_27)'%3e%3cpath%20d='M20%20112C15.5817%20112%2012%20108.418%2012%20104L12%2094H60V104C60%20108.418%2056.4183%20112%2052%20112H20Z'%20fill='%23B4B4B4'%20fill-opacity='0.3'/%3e%3cpath%20d='M0%2044C0%2048.4183%203.58172%2052%208%2052H10V8H8C3.58172%208%200%2011.5817%200%2016V44Z'%20fill='%23B4B4B4'/%3e%3cpath%20d='M12%208L12%2052L23%208H12Z'%20fill='%23B4B4B4'%20fill-opacity='0.9'/%3e%3crect%20x='12'%20y='92'%20width='18'%20height='48'%20transform='rotate(-90%2012%2092)'%20fill='%23B4B4B4'%20fill-opacity='0.4'/%3e%3crect%20x='12'%20y='72'%20width='18'%20height='48'%20transform='rotate(-90%2012%2072)'%20fill='%23B4B4B4'%20fill-opacity='0.5'/%3e%3cpath%20d='M25%208L14%2050L39%208H25Z'%20fill='%23B4B4B4'%20fill-opacity='0.8'/%3e%3cpath%20d='M60%2052H16L60%2023V52Z'%20fill='%23B4B4B4'%20fill-opacity='0.6'/%3e%3cpath%20d='M41%208L16%2050L60%2021V8H41Z'%20fill='%23B4B4B4'%20fill-opacity='0.7'/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_16_27'%3e%3crect%20width='120'%20height='60'%20fill='white'%20transform='matrix(0%20-1%201%200%200%20120)'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e";
const steeringWheel = "data:image/svg+xml,%3csvg%20width='60'%20height='60'%20viewBox='0%200%2060%2060'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M21.689%2032.2149L21.9193%2029.9998L21.689%2027.7858L11.5087%2026.4053V29.9998V33.5951L21.689%2032.2149Z'%20fill='%23909096'/%3e%3cpath%20d='M11.5087%2033.5951L21.689%2032.2149L21.9193%2029.9998L21.689%2027.7858L19.2978%2027.4612C18.9214%2028.8973%2018.219%2031.3029%2017.7062%2031.4235C17.0154%2031.5861%2012.9195%2032.0537%2011.5087%2031.0988V33.5951Z'%20fill='%2375757B'/%3e%3cpath%20d='M33.9688%2019.5606C33.9688%2019.5606%2033.7098%2013.1763%2036.0395%2012.3137C36.0395%2012.3137%2031.4666%2010.1568%2026.8944%2012.1413C26.8944%2012.1413%2030.3516%2013.2629%2029.917%2019.5606H33.9688Z'%20fill='%23909096'/%3e%3cpath%20d='M29.917%2019.5606H31.0819C31.081%2019.5314%2031.0801%2019.5036%2031.0786%2019.4747C30.733%2013.0039%2032.2433%2013.4351%2032.2433%2013.4351C32.6807%2013.3699%2033.7837%2013.5483%2034.7649%2013.7403C35.0657%2013.0544%2035.4761%2012.5218%2036.0395%2012.3137C36.0395%2012.3137%2031.4666%2010.1568%2026.8944%2012.1413C26.8942%2012.1413%2030.3517%2013.2627%2029.917%2019.5606Z'%20fill='url(%23paint0_linear_22_22)'/%3e%3cpath%20d='M33.9688%2040.1179C33.9688%2040.1179%2033.7098%2046.5024%2036.0395%2047.365C36.0395%2047.365%2031.4666%2049.5217%2026.8944%2047.5376C26.8944%2047.5376%2030.3516%2046.416%2029.917%2040.1179H33.9688Z'%20fill='%23909096'/%3e%3cpath%20d='M29.917%2040.1179H31.0819C31.081%2040.1471%2031.0801%2040.1749%2031.0786%2040.2034C30.7333%2046.6744%2032.2433%2046.2432%2032.2433%2046.2432C32.6807%2046.3086%2033.7837%2046.1304%2034.7649%2045.9382C35.0657%2046.6239%2035.4761%2047.1558%2036.0395%2047.3647C36.0395%2047.3647%2031.4666%2049.5215%2026.8944%2047.5374C26.8942%2047.5376%2030.3517%2046.416%2029.917%2040.1179Z'%20fill='url(%23paint1_linear_22_22)'/%3e%3cpath%20d='M52%2029.9998C52%2017.8497%2042.1503%208%2030.0002%208C17.8501%208%208%2017.8497%208%2029.9998C8%2042.1499%2017.8501%2052%2030.0002%2052C42.1503%2052%2052%2042.1501%2052%2029.9998ZM12.4863%2029.9998C12.4863%2020.3274%2020.3279%2012.4866%2030%2012.4866C39.6721%2012.4866%2047.5137%2020.3274%2047.5137%2029.9998C47.5137%2039.6721%2039.6726%2047.5142%2030%2047.5142C20.3274%2047.5142%2012.4863%2039.6728%2012.4863%2029.9998Z'%20fill='%23575D75'/%3e%3cpath%20d='M52%2029.9998C52%2017.8497%2042.1503%208%2030.0002%208C17.8501%208%208%2017.8497%208%2029.9998C8%2042.1499%2017.8501%2052%2030.0002%2052C42.1503%2052%2052%2042.1501%2052%2029.9998ZM12.4863%2029.9998C12.4863%2020.3274%2020.3279%2012.4866%2030%2012.4866C39.6721%2012.4866%2047.5137%2020.3274%2047.5137%2029.9998C47.5137%2039.6721%2039.6726%2047.5142%2030%2047.5142C20.3274%2047.5142%2012.4863%2039.6728%2012.4863%2029.9998Z'%20fill='%2375757B'/%3e%3cpath%20d='M49.4117%2029.9998C49.4117%2019.2793%2040.7203%2010.5879%2030.0002%2010.5879C19.2801%2010.5879%2010.5886%2019.2793%2010.5886%2029.9998C10.5886%2040.7202%2019.2793%2049.412%2030.0002%2049.412C40.7211%2049.412%2049.4117%2040.7213%2049.4117%2029.9998ZM12.4863%2029.9998C12.4863%2020.3274%2020.3279%2012.4866%2030%2012.4866C39.6721%2012.4866%2047.5137%2020.3274%2047.5137%2029.9998C47.5137%2039.6721%2039.6726%2047.5143%2030%2047.5143C20.3274%2047.5143%2012.4863%2039.6728%2012.4863%2029.9998V29.9998Z'%20fill='%23616164'/%3e%3cpath%20d='M34.4574%2018.9569H29.5112L20.9986%2027.2394V32.761L29.5112%2041.0437H34.4574C35.1396%2038.9974%2037%2034.4986%2037%2029.9999C37%2025.5014%2035.1396%2021.003%2034.4574%2018.9569Z'%20fill='url(%23paint2_linear_22_22)'/%3e%3cpath%20opacity='0.2'%20d='M34.4574%2018.9569H33.6496C35.0136%2023.0491%2035.0136%2036.9511%2033.6496%2041.0437H34.4574C35.8219%2036.9511%2035.8219%2023.0491%2034.4574%2018.9569Z'%20fill='%239F9FA5'/%3e%3cpath%20d='M30.3622%2041.0437C25.5873%2030.7584%2028.141%2022.8923%2030.2245%2018.9569H29.5112L20.9986%2027.2394V32.761L29.5112%2041.0437H30.3622Z'%20fill='url(%23paint3_linear_22_22)'/%3e%3cdefs%3e%3clinearGradient%20id='paint0_linear_22_22'%20x1='34.0004'%20y1='18.4999'%20x2='27.5004'%20y2='11.9999'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%23909096'/%3e%3cstop%20offset='1'%20stop-color='%2375757B'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint1_linear_22_22'%20x1='35.0004'%20y1='41'%20x2='25.5004'%20y2='47'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%23909096'/%3e%3cstop%20offset='1'%20stop-color='%2375757B'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint2_linear_22_22'%20x1='37'%20y1='30.0003'%20x2='20.9986'%20y2='30.0003'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%239F9FA5'/%3e%3cstop%20offset='1'%20stop-color='%23606064'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint3_linear_22_22'%20x1='29.5009'%20y1='29.9999'%20x2='20.9986'%20y2='30.0003'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%23767678'/%3e%3cstop%20offset='1'%20stop-color='%23404042'/%3e%3c/linearGradient%3e%3c/defs%3e%3c/svg%3e";
const tWall = "data:image/svg+xml,%3csvg%20width='120'%20height='180'%20viewBox='0%200%20120%20180'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3crect%20x='59'%20width='2'%20height='180'%20fill='%23BBBAC5'/%3e%3crect%20x='21'%20width='39'%20height='2'%20fill='%23BBBAC5'/%3e%3crect%20x='60'%20width='39'%20height='2'%20fill='%23BBBAC5'/%3e%3c/svg%3e";
const iconsMap = {
  small_wall: smallWall,
  big_table: bigTable,
  small_table: smallTable,
  l_wall_big: lWall,
  t_wall_big: tWall,
  ES: stairs,
  steeringWheel
};
const accessibilityMap$1 = {
  small_wall: "accessibility.images.seatIcons.small_wall",
  big_table: "accessibility.images.seatIcons.big_table",
  small_table: "accessibility.images.seatIcons.small_table",
  l_wall_big: "accessibility.images.seatIcons.l_wall_big",
  t_wall_big: "accessibility.images.seatIcons.t_wall_big",
  ES: "accessibility.images.seatIcons.ES",
  steeringWheel: "accessibility.images.seatIcons.steeringWheel"
};
const customDefaultSizes = {
  ES: { length: 1, width: 2, height: 1 }
};
const IconSeat = ({
  position,
  code,
  orientation = "facingForward",
  size = customDefaultSizes[code] || { length: 1, width: 1, height: 1 },
  flipped
}) => {
  const seatSelection = useSeatSelectionUtils();
  const { t } = useTranslation();
  const gridPlacement = seatSelection.getGridPlacement(position, size);
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: cn(bem("seat-selection-icon-seat"), bem("deck-item", { [orientation]: true })),
      style: { ...gridPlacement, scale: flipped ? "-1 1" : void 0 },
      children: /* @__PURE__ */ jsx("img", { src: iconsMap[code], alt: t(accessibilityMap$1[code]), className: bem("seat-selection-icon-seat", "image") })
    }
  );
};
const femaleSymbol = "data:image/svg+xml,%3csvg%20width='10'%20height='15'%20viewBox='0%200%2010%2015'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M9.5%205.48272C9.49999%204.61523%209.2473%203.76637%208.7726%203.0391C8.29788%202.31184%207.62154%201.7374%206.8256%201.38547C6.02965%201.03354%205.14829%200.919227%204.28842%201.0564C3.42855%201.19358%202.62711%201.57634%201.98129%202.15828C1.33547%202.74022%200.873021%203.49632%200.650032%204.3349C0.427044%205.17347%200.453094%206.05848%200.725023%206.8826C0.996952%207.70671%201.50308%208.43452%202.18202%208.97777C2.86095%209.52101%203.68354%209.85634%204.55%209.94309V11.3103H2.75C2.63065%2011.3103%202.51619%2011.3576%202.4318%2011.4416C2.34741%2011.5257%202.3%2011.6397%202.3%2011.7586C2.3%2011.8775%202.34741%2011.9915%202.4318%2012.0756C2.51619%2012.1597%202.63065%2012.2069%202.75%2012.2069H4.55V13.5517C4.55%2013.6706%204.59741%2013.7846%204.6818%2013.8687C4.76619%2013.9528%204.88065%2014%205%2014C5.11935%2014%205.23381%2013.9528%205.3182%2013.8687C5.40259%2013.7846%205.45%2013.6706%205.45%2013.5517V12.2069H7.25C7.36935%2012.2069%207.48381%2012.1597%207.5682%2012.0756C7.65259%2011.9915%207.7%2011.8775%207.7%2011.7586C7.7%2011.6397%207.65259%2011.5257%207.5682%2011.4416C7.48381%2011.3576%207.36935%2011.3103%207.25%2011.3103H5.45V9.94309C6.55945%209.83062%207.58763%209.31234%208.33571%208.48846C9.08379%207.66458%209.49863%206.59364%209.5%205.48272ZM1.4%205.48272C1.4%204.77344%201.61114%204.08008%202.00671%203.49033C2.40228%202.90057%202.96453%202.44092%203.62234%202.16949C4.28015%201.89805%205.00399%201.82703%205.70232%201.96541C6.40066%202.10379%207.04212%202.44534%207.54558%202.94688C8.04905%203.44842%208.39192%204.08743%208.53083%204.78309C8.66973%205.47874%208.59844%206.19981%208.32597%206.85511C8.05349%207.51041%207.59207%208.0705%207.00005%208.46456C6.40804%208.85862%205.71201%209.06894%205%209.06894C4.04554%209.06791%203.13047%208.68974%202.45557%208.01742C1.78066%207.3451%201.40104%206.43353%201.4%205.48272Z'%20fill='white'%20stroke='white'%20stroke-width='0.6'/%3e%3c/svg%3e";
const DISCOUNT_SIGN$1 = "%";
const isInView = (element) => window.innerHeight > element.getBoundingClientRect().top;
const PassengerSeat = (props) => {
  const {
    position,
    price,
    priceCategory,
    label,
    onSelect,
    disabled,
    selected,
    isDriverSeat,
    discountCategory,
    orientation,
    isFirstSeat,
    size,
    femaleOnly
  } = props;
  const { currency: currency2 } = useSettings();
  const { t } = useTranslation();
  const isMobile = useIsMobile();
  const isTablet = useIsTablet();
  const isSmallScreen = isMobile || isTablet;
  const isVacant = !disabled && !selected;
  const [opened, setOpened] = useState(isSmallScreen ? false : void 0);
  const ref = useRef(null);
  const seatSelection = useSeatSelectionUtils();
  const scroll = useCallback(() => {
    if (ref.current && !isInView(ref.current)) ref.current.scrollIntoView({ behavior: "smooth" });
  }, []);
  useEffect(() => {
    if (!isMobile || !isFirstSeat) return;
    const timeout = setTimeout(scroll, 250);
    return () => clearTimeout(timeout);
  }, [isFirstSeat, isMobile, scroll]);
  const paid = price != null && priceCategory != null;
  const discounted = useMemo(() => !!discountCategory?.length, [discountCategory]);
  const iconsCount = useMemo(() => {
    if (!paid) return 0;
    if (disabled || selected) return 1;
    return priceCategory;
  }, [paid, disabled, selected, priceCategory]);
  const showTooltip = !!price && !(disabled && isSmallScreen);
  const tooltipContent = useMemo(() => {
    if (!showTooltip) return null;
    return /* @__PURE__ */ jsxs("div", { className: bem("seat-selection", "seat-tooltip"), children: [
      /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(Trans, { i18nKey: "seats.seat", values: { label }, components: { 0: /* @__PURE__ */ jsx("b", {}) } }) }),
      /* @__PURE__ */ jsxs("span", { children: [
        "+",
        /* @__PURE__ */ jsx(Money, { fractional: price, currency: currency2 })
      ] }),
      isSmallScreen && /* @__PURE__ */ jsx(
        Button,
        {
          color: "secondary",
          onClick: () => {
            onSelect?.();
            setOpened(!opened);
          },
          children: t(`seats.${selected ? "deselect" : "select"}`)
        }
      )
    ] });
  }, [showTooltip, label, price, currency2, isSmallScreen, t, selected, onSelect, opened]);
  const handleClick = () => {
    if (!isSmallScreen || !paid) {
      onSelect?.();
    }
  };
  const gridPlacement = seatSelection.getGridPlacement(position, size);
  return /* @__PURE__ */ jsx(
    Tooltip,
    {
      action: isSmallScreen ? "click" : "hover",
      position: "top",
      className: bem("seat-selection", "seat-tooltip"),
      popperClassName: bem("seat-selection", "seat-tooltip-wrapper"),
      content: tooltipContent,
      style: { ...gridPlacement },
      opened,
      onOpenChanged: setOpened,
      dataTag: showTooltip ? label : void 0,
      children: /* @__PURE__ */ jsx(
        "div",
        {
          ref,
          "data-tag": showTooltip ? void 0 : label,
          style: { ...gridPlacement },
          className: cn(
            bem("seat-selection", "seat-wrapper"),
            bem("deck-item", { [orientation ?? "facingForward"]: true })
          ),
          children: /* @__PURE__ */ jsxs(
            "div",
            {
              className: bem("seat-selection", "seat", { selected, disabled, paid, discounted, "female-only": femaleOnly }),
              onClick: handleClick,
              children: [
                /* @__PURE__ */ jsx("div", { className: bem("seat-selection", "seat-surface"), children: /* @__PURE__ */ jsxs("div", { className: bem("seat-selection", "seat-surface-icon"), children: [
                  selected && /* @__PURE__ */ jsx(Icon, { name: "checkout", size: "large" }),
                  disabled && !isDriverSeat && /* @__PURE__ */ jsx(Icon, { name: "cross", size: "large" })
                ] }) }),
                /* @__PURE__ */ jsx("div", { className: bem("seat-selection", "seat-armrest", { left: true }) }),
                /* @__PURE__ */ jsx("div", { className: bem("seat-selection", "seat-armrest", { right: true }) }),
                /* @__PURE__ */ jsxs("div", { className: bem("seat-selection", "seat-armrest", { back: true }), children: [
                  femaleOnly && /* @__PURE__ */ jsx("div", { className: bem("seat-selection", "seat-female-icon"), children: /* @__PURE__ */ jsx("img", { src: femaleSymbol, alt: "female", className: isMobile ? "mobile-rotated" : "" }) }),
                  isVacant && new Array(iconsCount).fill(seatSelection.getCurrencyIcon(currency2)).map((icon, index) => /* @__PURE__ */ jsx(Icon, { className: bem("seat-selection", "seat-sign"), name: icon, size: "small" }, index)),
                  discountCategory?.[0] && /* @__PURE__ */ jsx("span", { className: bem("seat-selection", "seat-discount", { disabled }), children: /* @__PURE__ */ jsx("span", { className: bem("seat-selection", "seat-discount-sign"), children: DISCOUNT_SIGN$1 }) }),
                  !isVacant && /* @__PURE__ */ jsx("span", { className: bem("seat-selection", "seat-armrest-label"), children: label })
                ] }),
                isVacant && /* @__PURE__ */ jsx("div", { className: bem("seat-selection", "seat-label", { selected }), children: label })
              ]
            }
          )
        }
      )
    }
  );
};
const bar = "data:image/svg+xml,%3csvg%20width='28'%20height='28'%20viewBox='0%200%2028%2028'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M13.4541%209.33667C15.993%209.33667%2018.5319%209.32745%2021.0708%209.33957C23.3285%209.35028%2025.0605%2010.9072%2025.3434%2013.1517C25.6245%2015.3827%2023.9977%2017.553%2021.7884%2017.8205C21.2626%2017.8842%2021.0328%2018.0574%2020.8632%2018.5828C20.5262%2019.6107%2019.8827%2020.5062%2019.0224%2021.1444C18.1621%2021.7827%2017.1277%2022.132%2016.0632%2022.1437C13.9179%2022.1747%2011.7715%2022.1723%209.62609%2022.1482C6.70148%2022.1153%204.4396%2019.8263%204.39289%2016.8422C4.36024%2014.7583%204.38089%2012.6736%204.38797%2010.5892C4.39073%209.74823%204.80209%209.34027%205.64086%209.33867C8.24523%209.33333%2010.8496%209.33266%2013.4541%209.33667ZM21.2035%2011.5372L21.2035%2015.7019C22.3592%2015.7568%2023.2744%2014.8073%2023.2635%2013.5902C23.2527%2012.4014%2022.3276%2011.4691%2021.2032%2011.5372H21.2035Z'%20fill='%23848388'/%3e%3cpath%20d='M13.4335%203.15161C13.4385%203.21365%2013.4273%203.27586%2013.4009%203.33373C13.0747%203.77497%2013.2514%204.16821%2013.4871%204.59233C13.8613%205.26545%2013.7275%205.94002%2013.3348%206.5797C13.2344%206.75629%2013.0574%206.89188%2012.8421%206.95727C12.6267%207.02267%2012.3901%207.01265%2012.1833%206.92937C11.7316%206.75745%2011.5001%206.33245%2011.7197%205.93521C11.9306%205.55341%2011.8858%205.23397%2011.6613%204.87447C11.2168%204.16311%2011.325%203.44664%2011.7449%202.75459C11.8366%202.59514%2011.9906%202.46859%2012.1798%202.39712C12.3691%202.32564%2012.5815%202.31381%2012.7798%202.36368C13.1786%202.46363%2013.4371%202.76202%2013.4335%203.15161Z'%20fill='%23848388'/%3e%3cpath%20d='M9.93353%203.15161C9.93848%203.21365%209.92733%203.27586%209.90088%203.33373C9.57467%203.77497%209.75139%204.16821%209.98708%204.59233C10.3613%205.26545%2010.2275%205.94002%209.83481%206.5797C9.73436%206.75629%209.55741%206.89188%209.34205%206.95727C9.12669%207.02267%208.89013%207.01265%208.68326%206.92937C8.23159%206.75745%208.00013%206.33245%208.21966%205.93521C8.43065%205.55341%208.38581%205.23397%208.16129%204.87447C7.71681%204.16311%207.82501%203.44664%208.24487%202.75459C8.33661%202.59514%208.49059%202.46859%208.67983%202.39712C8.86907%202.32564%209.08148%202.31381%209.27984%202.36368C9.67864%202.46363%209.93709%202.76202%209.93353%203.15161Z'%20fill='%23848388'/%3e%3cpath%20d='M15.1507%206.1848C15.1459%206.12243%2015.157%206.05993%2015.183%206.00159C15.4971%205.56159%2015.3403%205.16923%2015.0995%204.74263C14.721%204.072%2014.855%203.39561%2015.2489%202.75593C15.3485%202.57902%2015.5248%202.44289%2015.7398%202.37686C15.9547%202.31083%2016.1912%202.32019%2016.3982%202.40291C16.85%202.57316%2017.0883%203.00099%2016.8641%203.39488C16.6369%203.79386%2016.7178%204.12335%2016.9395%204.48905C17.3668%205.19371%2017.248%205.89727%2016.8408%206.57679C16.7491%206.73621%2016.5955%206.86291%2016.4067%206.9349C16.2178%207.00688%2016.0057%207.01959%2015.8071%206.97082C15.6108%206.92276%2015.4392%206.81897%2015.32%206.67628C15.2009%206.53359%2015.1412%206.36039%2015.1507%206.1848Z'%20fill='%23848388'/%3e%3cpath%20d='M4.31059%2024.7115C3.86624%2024.1561%204.26169%2023.3333%204.97299%2023.3333L20.1097%2023.3333C20.821%2023.3333%2021.2164%2024.1561%2020.7721%2024.7115C20.2892%2025.3152%2019.558%2025.6666%2018.7849%2025.6666L6.29781%2025.6666C5.52471%2025.6666%204.79354%2025.3152%204.31059%2024.7115Z'%20fill='%23848388'/%3e%3c/svg%3e";
const bike = "data:image/svg+xml,%3csvg%20width='28'%20height='28'%20viewBox='0%200%2028%2028'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M19.1587%205.13336C19.0482%205.13336%2018.9587%205.2229%2018.9587%205.33336V6.00836H18.9583V8.63336H10.2083V6.50836H11.667C11.9431%206.50836%2012.167%206.2845%2012.167%206.00836C12.167%205.73222%2011.9431%205.50836%2011.667%205.50836H7.00033C6.72418%205.50836%206.50033%205.73222%206.50033%206.00836C6.50033%206.2845%206.72418%206.50836%207.00033%206.50836H8.45826V9.3018L6.57565%2013.067C6.33401%2013.0284%206.08618%2013.0084%205.83366%2013.0084C3.25633%2013.0084%201.16699%2015.0977%201.16699%2017.675C1.16699%2020.2524%203.25633%2022.3417%205.83366%2022.3417C8.3468%2022.3417%2010.396%2020.3551%2010.4965%2017.8667L13.115%2018.3904C13.8868%2018.5447%2014.6773%2018.2321%2015.1347%2017.5917L19.6307%2011.2973L21.6057%2016.0372C21.7916%2016.4833%2022.3039%2016.6942%2022.7499%2016.5084C23.196%2016.3225%2023.4069%2015.8102%2023.2211%2015.3641L20.7083%209.33336V6.88336H22.0293C22.4973%206.88336%2022.9251%207.14777%2023.1344%207.56634L23.4362%208.17008C23.4856%208.26887%2023.6058%208.30892%2023.7046%208.25952L24.912%207.65578C25.0108%207.60638%2025.0509%207.48625%2025.0015%207.38745L24.6996%206.78372C24.1939%205.77227%2023.1601%205.13336%2022.0293%205.13336H19.1587ZM8.23064%2013.6702C9.12523%2014.2068%209.82515%2015.0346%2010.1993%2016.0226L12.2864%2016.44L9.38471%2011.362L8.23064%2013.6702ZM14.0819%2016.0549L10.841%2010.3834H18.133L14.0819%2016.0549ZM5.83366%2018.8417C6.47799%2018.8417%207.00033%2018.3194%207.00033%2017.675C7.00033%2017.0307%206.47799%2016.5084%205.83366%2016.5084C5.18933%2016.5084%204.66699%2017.0307%204.66699%2017.675C4.66699%2018.3194%205.18933%2018.8417%205.83366%2018.8417ZM20.6523%2016.6027L19.8036%2014.6226C19.0954%2015.4409%2018.667%2016.5079%2018.667%2017.675C18.667%2020.2524%2020.7563%2022.3417%2023.3337%2022.3417C25.911%2022.3417%2028.0003%2020.2524%2028.0003%2017.675C28.0003%2015.1724%2026.0304%2013.13%2023.5566%2013.0136L24.4054%2014.9942C24.8496%2016.0306%2024.3695%2017.2309%2023.3331%2017.675C22.2967%2018.1192%2021.0964%2017.6391%2020.6523%2016.6027Z'%20fill='%23848388'/%3e%3c/svg%3e";
const childrenPlayArea = "data:image/svg+xml,%3csvg%20width='28'%20height='28'%20viewBox='0%200%2028%2028'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M8.333%207.37807C8.22412%207.78641%208.16579%208.21322%208.16579%208.65266C8.16579%2011.6063%2010.777%2013.9999%2013.9987%2013.9999C17.2204%2013.9999%2019.8316%2011.6063%2019.8316%208.65266C19.8316%208.20447%2019.7713%207.76988%2019.6576%207.35377C19.7985%207.28571%2019.9463%207.16613%2020.1077%206.98335C21.1284%205.82154%2021.0147%204.05208%2019.853%203.03027C18.6913%202.00943%2016.9219%202.12318%2015.9002%203.28499C15.8215%203.37444%2015.7573%203.45902%2015.7058%203.53875C15.1653%203.38708%2014.5927%203.30541%2013.9987%203.30541C13.3998%203.30541%2012.8224%203.38805%2012.279%203.54166C12.2138%203.42208%2012.1147%203.29277%2011.9747%203.15374C10.881%202.05999%209.10781%202.05999%208.01414%203.15374C6.92047%204.2475%206.92047%206.02084%208.01414%207.1146C8.12788%207.22835%208.23287%207.31488%208.333%207.37807ZM13.9987%209.13878C14.8036%209.13878%2015.4569%209.57433%2015.4569%2010.111C15.4569%2010.6477%2014.8036%2011.0832%2013.9987%2011.0832C13.1938%2011.0832%2012.5405%2010.6477%2012.5405%2010.111C12.5405%209.57433%2013.1938%209.13878%2013.9987%209.13878ZM8.52646%2021.0836C8.52646%2021.0836%2010.0537%2023.1204%2010.0537%2025.6666H8.53521C6.6123%2025.6666%204.80118%2024.7605%203.64724%2023.2225L2.89382%2022.2182C2.09471%2021.1526%202.1336%2019.6068%203.11353%2018.7065C4.24122%2017.6701%205.98429%2017.8529%206.88061%2019.0477L8.52646%2021.0845V21.0836ZM25.1045%2022.2162L24.3501%2023.2225C23.1962%2024.7615%2021.3851%2025.6666%2019.4622%2025.6666H17.9233C17.9233%2022.1015%2019.4116%2020.9056%2019.4116%2020.9056L21.1177%2019.0467C22.0141%2017.8519%2023.7581%2017.6701%2024.8858%2018.7065C25.8657%2019.6068%2025.9036%2021.1516%2025.1055%2022.2152L25.1045%2022.2162ZM15.978%2025.6666H11.999C11.999%2022.5614%2010.2783%2020.1774%2010.0391%2019.8615L8.43702%2017.8791C7.6768%2016.866%206.51703%2016.2185%205.25615%2016.1019C5.1113%2016.0883%204.96742%2016.0834%204.82354%2016.0844L2.84424%2013.2134C2.00042%2012.0885%202.22887%2010.4921%203.35365%209.64822C4.23733%208.98516%205.41169%208.98419%206.28371%209.55975C6.76103%2013.1541%2010.0401%2015.9444%2014.0006%2015.9444C17.9612%2015.9444%2021.2402%2013.1541%2021.7176%209.55975C22.5896%208.98419%2023.7639%208.98614%2024.6476%209.64822C25.7724%2010.4921%2026.0009%2012.0885%2025.157%2013.2134L23.1777%2016.0844C23.0339%2016.0844%2022.889%2016.0902%2022.7451%2016.1038C21.5202%2016.2156%2020.3906%2016.8301%2019.6304%2017.7926L18.0448%2019.5212C17.478%2020.0501%2015.9799%2021.8108%2015.9799%2025.6666H15.978Z'%20fill='%23848388'/%3e%3c/svg%3e";
const conferenceRoom = "data:image/svg+xml,%3csvg%20width='28'%20height='28'%20viewBox='0%200%2028%2028'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M4.08301%203.20831C4.08301%202.72506%203.69126%202.33331%203.20801%202.33331C2.72476%202.33331%202.33301%202.72506%202.33301%203.20831V7.87498C2.33301%208.35823%202.72476%208.74998%203.20801%208.74998C3.69126%208.74998%204.08301%208.35823%204.08301%207.87498V7.05753C4.34041%207.20643%204.63926%207.29165%204.95801%207.29165C5.92451%207.29165%206.70801%206.50814%206.70801%205.54165C6.70801%204.57515%205.92451%203.79165%204.95801%203.79165C4.63926%203.79165%204.34041%203.87687%204.08301%204.02577V3.20831Z'%20fill='%23848388'/%3e%3cpath%20d='M3.20801%2011.0833C3.69126%2011.0833%204.08301%2011.4751%204.08301%2011.9583V12.7758C4.34041%2012.6269%204.63926%2012.5416%204.95801%2012.5416C5.92451%2012.5416%206.70801%2013.3251%206.70801%2014.2916C6.70801%2015.2581%205.92451%2016.0416%204.95801%2016.0416C4.63926%2016.0416%204.34041%2015.9564%204.08301%2015.8075V16.625C4.08301%2017.1082%203.69126%2017.5%203.20801%2017.5C2.72476%2017.5%202.33301%2017.1082%202.33301%2016.625V11.9583C2.33301%2011.4751%202.72476%2011.0833%203.20801%2011.0833Z'%20fill='%23848388'/%3e%3cpath%20d='M4.08301%2020.125C4.08301%2019.6417%203.69126%2019.25%203.20801%2019.25C2.72476%2019.25%202.33301%2019.6417%202.33301%2020.125V24.7916C2.33301%2025.2749%202.72476%2025.6666%203.20801%2025.6666C3.69126%2025.6666%204.08301%2025.2749%204.08301%2024.7916V23.9742C4.34041%2024.1231%204.63926%2024.2083%204.95801%2024.2083C5.92451%2024.2083%206.70801%2023.4248%206.70801%2022.4583C6.70801%2021.4918%205.92451%2020.7083%204.95801%2020.7083C4.63926%2020.7083%204.34041%2020.7935%204.08301%2020.9424V20.125Z'%20fill='%23848388'/%3e%3cpath%20d='M8.16634%205.83331C8.16634%203.90032%209.73335%202.33331%2011.6663%202.33331H16.333C18.266%202.33331%2019.833%203.90032%2019.833%205.83331V22.1666C19.833%2024.0996%2018.266%2025.6666%2016.333%2025.6666H11.6663C9.73335%2025.6666%208.16634%2024.0996%208.16634%2022.1666V5.83331Z'%20fill='%23848388'/%3e%3cpath%20d='M24.7913%202.33331C24.3081%202.33331%2023.9163%202.72506%2023.9163%203.20831V4.02577C23.6589%203.87687%2023.3601%203.79165%2023.0413%203.79165C22.0748%203.79165%2021.2913%204.57515%2021.2913%205.54165C21.2913%206.50814%2022.0748%207.29165%2023.0413%207.29165C23.3601%207.29165%2023.6589%207.20643%2023.9163%207.05753V7.87498C23.9163%208.35823%2024.3081%208.74998%2024.7913%208.74998C25.2746%208.74998%2025.6663%208.35823%2025.6663%207.87498V3.20831C25.6663%202.72506%2025.2746%202.33331%2024.7913%202.33331Z'%20fill='%23848388'/%3e%3cpath%20d='M23.9163%2011.9583C23.9163%2011.4751%2024.3081%2011.0833%2024.7913%2011.0833C25.2746%2011.0833%2025.6663%2011.4751%2025.6663%2011.9583V16.625C25.6663%2017.1082%2025.2746%2017.5%2024.7913%2017.5C24.3081%2017.5%2023.9163%2017.1082%2023.9163%2016.625V15.8075C23.6589%2015.9564%2023.3601%2016.0416%2023.0413%2016.0416C22.0748%2016.0416%2021.2913%2015.2581%2021.2913%2014.2916C21.2913%2013.3251%2022.0748%2012.5416%2023.0413%2012.5416C23.3601%2012.5416%2023.6589%2012.6269%2023.9163%2012.7758V11.9583Z'%20fill='%23848388'/%3e%3cpath%20d='M24.7913%2019.25C24.3081%2019.25%2023.9163%2019.6417%2023.9163%2020.125V20.9424C23.6589%2020.7935%2023.3601%2020.7083%2023.0413%2020.7083C22.0748%2020.7083%2021.2913%2021.4918%2021.2913%2022.4583C21.2913%2023.4248%2022.0748%2024.2083%2023.0413%2024.2083C23.3601%2024.2083%2023.6589%2024.1231%2023.9163%2023.9742V24.7916C23.9163%2025.2749%2024.3081%2025.6666%2024.7913%2025.6666C25.2746%2025.6666%2025.6663%2025.2749%2025.6663%2024.7916V20.125C25.6663%2019.6417%2025.2746%2019.25%2024.7913%2019.25Z'%20fill='%23848388'/%3e%3c/svg%3e";
const family = "data:image/svg+xml,%3csvg%20width='28'%20height='28'%20viewBox='0%200%2028%2028'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M12.056%2023.2428C12.0556%2023.6822%2012.1686%2024.1147%2012.3846%2024.5H4.20009C3.70527%2024.4989%203.23104%2024.3061%202.88115%2023.9637C2.53126%2023.6214%202.33418%2023.1574%202.33301%2022.6733V19.9339C2.33651%2018.7239%202.82933%2017.5645%203.70379%2016.7089C4.57826%2015.8533%205.76329%2015.3711%206.99997%2015.3677H15.0725C15.2434%2015.927%2015.522%2016.4491%2015.8933%2016.9061C14.8204%2017.0865%2013.8471%2017.6318%2013.145%2018.4458C12.4429%2019.2599%2012.0573%2020.2903%2012.056%2021.3555V23.2428ZM11.1998%2013.998C10.2566%2013.998%209.33468%2013.7244%208.55048%2013.2117C7.76628%2012.699%207.15507%2011.9703%206.79414%2011.1178C6.43322%2010.2653%206.33878%209.32716%206.52278%208.42212C6.70678%207.51707%207.16095%206.68573%207.82785%206.03323C8.49476%205.38072%209.34445%204.93636%2010.2695%204.75634C11.1945%204.57631%2012.1533%204.66871%2013.0247%205.02184C13.896%205.37497%2014.6408%205.97298%2015.1648%206.74024C15.6888%207.5075%2015.9684%208.40956%2015.9684%209.33234C15.9684%2010.5697%2015.466%2011.7565%2014.5717%2012.6315C13.6774%2013.5064%2012.4645%2013.998%2011.1998%2013.998ZM25.6663%2023.2428C25.6652%2023.5759%2025.5294%2023.895%2025.2887%2024.1305C25.048%2024.3661%2024.7218%2024.4989%2024.3813%2024.5H14.7409C14.4005%2024.4989%2014.0743%2024.3661%2013.8336%2024.1305C13.5928%2023.895%2013.4571%2023.5759%2013.4559%2023.2428V21.3555C13.4586%2020.5227%2013.798%2019.7248%2014.3998%2019.1359C15.0017%2018.547%2015.8172%2018.215%2016.6684%2018.2124H22.4524C23.3035%2018.215%2024.1191%2018.547%2024.7209%2019.1359C25.3228%2019.7248%2025.6621%2020.5227%2025.6649%2021.3555L25.6663%2023.2428ZM22.8444%2014.0557C22.8444%2014.691%2022.6518%2015.3121%2022.291%2015.8403C21.9303%2016.3686%2021.4175%2016.7803%2020.8176%2017.0235C20.2176%2017.2666%2019.5575%2017.3302%2018.9206%2017.2063C18.2837%2017.0823%2017.6987%2016.7764%2017.2395%2016.3271C16.7804%2015.8779%2016.4677%2015.3055%2016.341%2014.6824C16.2143%2014.0592%2016.2793%2013.4133%2016.5278%2012.8264C16.7763%2012.2394%2017.1971%2011.7377%2017.7371%2011.3847C18.277%2011.0317%2018.9118%2010.8433%2019.5611%2010.8433C20.4319%2010.8433%2021.267%2011.1818%2021.8827%2011.7842C22.4984%2012.3866%2022.8444%2013.2037%2022.8444%2014.0557Z'%20fill='%23848388'/%3e%3c/svg%3e";
const firstClass = "data:image/svg+xml,%3csvg%20width='8'%20height='17'%20viewBox='0%200%208%2017'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M8%200V17H4.21007V3.41162H4.10503L0%205.85205V2.66455L4.43764%200H8Z'%20fill='%23F0EFF1'/%3e%3c/svg%3e";
const hanger = "data:image/svg+xml,%3csvg%20width='28'%20height='28'%20viewBox='0%200%2028%2028'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M12.833%207.4722C12.833%206.94222%2013.301%206.41665%2013.9997%206.41665C14.6983%206.41665%2015.1663%206.94222%2015.1663%207.4722C15.1663%207.84021%2014.9528%208.1926%2014.5811%208.38726C13.9337%208.72629%2012.833%209.52031%2012.833%2010.8611V12.3675C12.2851%2012.4822%2011.7595%2012.6819%2011.2442%2012.9718L4.24104%2016.9111C3.06241%2017.574%202.33301%2018.8212%202.33301%2020.1735C2.33301%2022.2408%204.00887%2023.9166%206.07616%2023.9166H21.9232C23.9905%2023.9166%2025.6663%2022.2408%2025.6663%2020.1735C25.6663%2018.8212%2024.9369%2017.574%2023.7583%2016.9111L16.7551%2012.9718C16.2399%2012.6819%2015.7143%2012.4822%2015.1663%2012.3675V10.868C15.1708%2010.8558%2015.1857%2010.8252%2015.2296%2010.7743C15.3161%2010.6742%2015.4655%2010.558%2015.6635%2010.4543C16.7351%209.89316%2017.4997%208.78365%2017.4997%207.4722C17.4997%205.54758%2015.8784%204.08331%2013.9997%204.08331C12.121%204.08331%2010.4997%205.54758%2010.4997%207.4722C10.4997%208.11653%2011.022%208.63887%2011.6663%208.63887C12.3107%208.63887%2012.833%208.11653%2012.833%207.4722ZM13.9997%2014.5833C13.4115%2014.5833%2012.9065%2014.7139%2012.3881%2015.0055L5.38498%2018.9447C4.94106%2019.1944%204.66634%2019.6642%204.66634%2020.1735C4.66634%2020.9521%205.29754%2021.5833%206.07616%2021.5833H21.9232C22.7018%2021.5833%2023.333%2020.9521%2023.333%2020.1735C23.333%2019.6642%2023.0583%2019.1944%2022.6144%2018.9447L15.6112%2015.0055C15.0928%2014.7139%2014.5878%2014.5833%2013.9997%2014.5833Z'%20fill='%23848388'/%3e%3c/svg%3e";
const infantCompartment = "data:image/svg+xml,%3csvg%20width='28'%20height='28'%20viewBox='0%200%2028%2028'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M11.4251%2010.6989L12.1882%2011.7047C12.3988%2011.9884%2012.7409%2012.1689%2013.0829%2012.2205L16.4776%2012.6074C16.5302%2012.6074%2016.5829%2012.6074%2016.6355%2012.6074C17.2934%2012.6074%2017.8723%2012.1174%2017.9513%2011.4726C18.0302%2010.7763%2017.5302%2010.1316%2016.7934%2010.0542L13.9777%209.74473C13.9777%209.74473%2012.3198%207.55263%2012.2672%207.44947C12.1882%207.34631%2011.9251%206.98526%2011.7935%206.85631C11.2935%206.36631%2010.6093%206.10842%209.92513%206.16C9.24094%206.21158%208.58306%206.52105%208.16201%207.06263C8.1357%207.08842%208.1357%207.11421%208.10938%207.14L4.45158%2012.1689C4.26737%2012.4268%204.16211%2012.7363%204.16211%2013.0716L4.16211%2015.0574L4.16211%2015.0832L4.16211%2024.7026C4.16211%2025.5537%204.87262%2026.25%205.74102%2026.25C6.60942%2026.25%207.31993%2025.5537%207.31993%2024.7026L7.31993%2015.5989L11.4251%2010.6989Z'%20fill='%23848388'/%3e%3cpath%20d='M14.0036%206.85632C15.4425%206.85632%2016.6088%205.71323%2016.6088%204.30316C16.6088%202.89309%2015.4425%201.75%2014.0036%201.75C12.5648%201.75%2011.3984%202.89309%2011.3984%204.30316C11.3984%205.71323%2012.5648%206.85632%2014.0036%206.85632Z'%20fill='%23848388'/%3e%3cpath%20d='M24.3218%2022.1667L12.1078%2022.1667C11.6181%2022.1667%2011.2148%2022.5618%2011.2148%2023.0417C11.2148%2023.5215%2011.6181%2023.9167%2012.1078%2023.9167L24.3218%2023.9167C24.8116%2023.9167%2025.2148%2023.5215%2025.2148%2023.0417C25.2148%2022.5618%2024.8116%2022.1667%2024.3218%2022.1667Z'%20fill='%23848388'/%3e%3cpath%20d='M22.6898%2020.4958C23.6781%2020.4958%2024.4793%2019.7106%2024.4793%2018.7421C24.4793%2017.7736%2023.6781%2016.9884%2022.6898%2016.9884C21.7015%2016.9884%2020.9004%2017.7736%2020.9004%2018.7421C20.9004%2019.7106%2021.7015%2020.4958%2022.6898%2020.4958Z'%20fill='%23848388'/%3e%3cpath%20d='M18.1056%2017.1816L15.8479%2017.1816L16.1824%2016.29C16.266%2016.0353%2016.2381%2015.7805%2016.0709%2015.5768C15.9036%2015.373%2015.6528%2015.2456%2015.374%2015.2456L12.531%2015.2456C12.0572%2015.2456%2011.667%2015.6022%2011.667%2016.0353C11.667%2016.4683%2012.0572%2016.8249%2012.531%2016.8249L14.1477%2016.8249L13.4787%2018.659C13.4508%2018.7099%2013.4508%2018.7354%2013.4508%2018.7864C13.3951%2019.1939%2013.5066%2019.6015%2013.8132%2019.9327C14.1198%2020.2638%2014.5379%2020.4166%2014.9838%2020.4166L18.9696%2020.4166C19.4434%2020.4166%2019.8337%2020.06%2019.8337%2019.627L19.8337%2015.373C19.8337%2014.9399%2019.4434%2014.5833%2018.9696%2014.5833C18.4958%2014.5833%2018.1056%2014.9399%2018.1056%2015.373L18.1056%2017.1816Z'%20fill='%23848388'/%3e%3c/svg%3e";
const luggage = "data:image/svg+xml,%3csvg%20width='32'%20height='32'%20viewBox='0%200%2032%2032'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M3.99967%206.66663C2.52692%206.66663%201.33301%207.86053%201.33301%209.33329V25.3333C1.33301%2026.8061%202.52692%2028%203.99967%2028H4.33301V28.9966C4.33301%2030.1011%205.22844%2030.9966%206.33301%2030.9966C7.43758%2030.9966%208.33301%2030.1011%208.33301%2028.9966V28H15.6663V28.9962C15.6663%2030.1007%2016.5618%2030.9962%2017.6663%2030.9962C18.7709%2030.9962%2019.6663%2030.1007%2019.6663%2028.9962V28H19.9997C21.4724%2028%2022.6663%2026.8061%2022.6663%2025.3333V9.33329C22.6663%207.86053%2021.4724%206.66663%2019.9997%206.66663H3.99967ZM8.66634%2010.3294C8.66634%209.7771%208.21863%209.32939%207.66634%209.32939C7.11406%209.32939%206.66634%209.7771%206.66634%2010.3294V24.3082C6.66634%2024.8605%207.11406%2025.3082%207.66634%2025.3082C8.21863%2025.3082%208.66634%2024.8605%208.66634%2024.3082V10.3294ZM17.333%2010.3281C17.333%209.7758%2016.8853%209.32808%2016.333%209.32808C15.7807%209.32808%2015.333%209.7758%2015.333%2010.3281V24.3018C15.333%2024.8541%2015.7807%2025.3018%2016.333%2025.3018C16.8853%2025.3018%2017.333%2024.8541%2017.333%2024.3018V10.3281Z'%20fill='%23848388'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M29.333%2026.6666C30.0694%2026.6666%2030.6663%2027.3458%2030.6663%2028.1836V29.1496C30.6663%2029.9874%2030.0694%2030.6666%2029.333%2030.6666C28.5966%2030.6666%2027.9997%2029.9874%2027.9997%2029.1496V28.1836C27.9997%2027.3458%2028.5966%2026.6666%2029.333%2026.6666Z'%20fill='%23848388'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M10.333%202.66663V6.66663H8.33301V2.66663H10.333Z'%20fill='%23848388'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M15.6663%202.66663V6.66663H13.6663V2.66663H15.6663Z'%20fill='%23848388'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M5.66634%202.66663C5.66634%202.11434%206.11406%201.66663%206.66634%201.66663H17.333C17.8853%201.66663%2018.333%202.11434%2018.333%202.66663C18.333%203.21891%2017.8853%203.66663%2017.333%203.66663H6.66634C6.11406%203.66663%205.66634%203.21891%205.66634%202.66663Z'%20fill='%23848388'/%3e%3cpath%20d='M23.333%2029.3333H30.6663C31.4027%2029.3333%2031.9997%2028.7363%2031.9997%2028V18.6666C31.9997%2017.9302%2031.4027%2017.3333%2030.6663%2017.3333H24.6663V28C24.6663%2028.7363%2024.0694%2029.3333%2023.333%2029.3333Z'%20fill='%23848388'/%3e%3c/svg%3e";
const luggageLocker = "data:image/svg+xml,%3csvg%20width='28'%20height='28'%20viewBox='0%200%2028%2028'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M16.1018%2014.191C17.0617%2014.3037%2017.9312%2013.6168%2018.0438%2012.6569C18.1564%2011.697%2017.4696%2010.8275%2016.5097%2010.7149C15.5498%2010.6023%2014.6803%2011.2891%2014.5677%2012.249C14.455%2013.2089%2015.1419%2014.0784%2016.1018%2014.191Z'%20fill='%23848388'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M8.45866%202.33331C8.45866%201.85006%208.85041%201.45831%209.33366%201.45831H18.667C19.1502%201.45831%2019.542%201.85006%2019.542%202.33331C19.542%202.81656%2019.1502%203.20831%2018.667%203.20831H17.2087V5.83331H21.0003C22.289%205.83331%2023.3337%206.87798%2023.3337%208.16665V22.1666C23.3337%2023.4553%2022.289%2024.5%2021.0003%2024.5H20.7087V25.3717C20.7087%2026.3382%2019.9252%2027.1217%2018.9587%2027.1217C17.9922%2027.1217%2017.2087%2026.3382%2017.2087%2025.3717V24.5H10.792V25.372C10.792%2026.3385%2010.0085%2027.122%209.04199%2027.122C8.07549%2027.122%207.29199%2026.3385%207.29199%2025.372V24.5H7.00033C5.71166%2024.5%204.66699%2023.4553%204.66699%2022.1666V8.16665C4.66699%206.87798%205.71166%205.83331%207.00033%205.83331H10.792V3.20831H9.33366C8.85041%203.20831%208.45866%202.81656%208.45866%202.33331ZM12.542%203.20831H15.4587V5.83331H12.542V3.20831ZM15.8979%2015.9291C17.8177%2016.1544%2019.5566%2014.7807%2019.7819%2012.8608C20.0071%2010.941%2018.6334%209.20208%2016.7136%208.97682C14.7938%208.75156%2013.0548%2010.1253%2012.8296%2012.0451C12.7248%2012.9384%2012.9662%2013.7926%2013.4477%2014.4733L8.91473%2019.7964C8.60142%2020.1643%208.64569%2020.7165%209.01361%2021.0298C9.38152%2021.3431%209.93377%2021.2989%2010.2471%2020.931L10.4362%2020.7089L10.9818%2021.1735C11.3497%2021.4868%2011.902%2021.4426%2012.2153%2021.0747C12.5286%2020.7067%2012.4843%2020.1545%2012.1164%2019.8412L11.5708%2019.3765L12.3272%2018.4883L13.4375%2019.4338C13.8054%2019.7471%2014.3577%2019.7029%2014.671%2019.3349C14.9843%2018.967%2014.94%2018.4148%2014.5721%2018.1015L13.4618%2017.156L14.7824%2015.6052C15.1244%2015.7704%2015.4994%2015.8824%2015.8979%2015.9291Z'%20fill='%23848388'/%3e%3c/svg%3e";
const noPhone = "data:image/svg+xml,%3csvg%20width='28'%20height='28'%20viewBox='0%200%2028%2028'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M7.00033%204.66665C7.00033%203.37798%208.04499%202.33331%209.33366%202.33331H18.667C19.9557%202.33331%2021.0003%203.37798%2021.0003%204.66665V18.4697L23.8979%2020.9146C24.2673%2021.2262%2024.3141%2021.7783%2024.0024%2022.1476C23.6908%2022.5169%2023.1388%2022.5637%2022.7694%2022.2521L4.10275%206.50209C3.73341%206.19045%203.68662%205.63841%203.99826%205.26907C4.30989%204.89973%204.86193%204.85294%205.23127%205.16458L7.00033%206.65722V4.66665ZM10.792%204.66665C10.792%204.1834%2011.1837%203.79165%2011.667%203.79165H16.3337C16.8169%203.79165%2017.2087%204.1834%2017.2087%204.66665C17.2087%205.1499%2016.8169%205.54165%2016.3337%205.54165H11.667C11.1837%205.54165%2010.792%205.1499%2010.792%204.66665Z'%20fill='%23848388'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M7.00033%2011.1891L21.0003%2023.0016V23.3333C21.0003%2024.622%2019.9557%2025.6666%2018.667%2025.6666H9.33366C8.04499%2025.6666%207.00033%2024.622%207.00033%2023.3333V11.1891ZM14.0003%2024.5C14.6447%2024.5%2015.167%2023.9776%2015.167%2023.3333C15.167%2022.689%2014.6447%2022.1666%2014.0003%2022.1666C13.356%2022.1666%2012.8337%2022.689%2012.8337%2023.3333C12.8337%2023.9776%2013.356%2024.5%2014.0003%2024.5Z'%20fill='%23848388'/%3e%3c/svg%3e";
const phone = "data:image/svg+xml,%3csvg%20width='28'%20height='28'%20viewBox='0%200%2028%2028'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M7%204.66665C7%203.37798%208.04467%202.33331%209.33333%202.33331H18.6667C19.9553%202.33331%2021%203.37798%2021%204.66665V23.3333C21%2024.622%2019.9553%2025.6666%2018.6667%2025.6666H9.33333C8.04467%2025.6666%207%2024.622%207%2023.3333V4.66665ZM10.7917%204.66665C10.7917%204.1834%2011.1834%203.79165%2011.6667%203.79165H16.3333C16.8166%203.79165%2017.2083%204.1834%2017.2083%204.66665C17.2083%205.1499%2016.8166%205.54165%2016.3333%205.54165H11.6667C11.1834%205.54165%2010.7917%205.1499%2010.7917%204.66665ZM14%2024.5C14.6443%2024.5%2015.1667%2023.9776%2015.1667%2023.3333C15.1667%2022.689%2014.6443%2022.1666%2014%2022.1666C13.3557%2022.1666%2012.8333%2022.689%2012.8333%2023.3333C12.8333%2023.9776%2013.3557%2024.5%2014%2024.5Z'%20fill='%23848388'/%3e%3c/svg%3e";
const powerOutlet = "data:image/svg+xml,%3csvg%20width='28'%20height='28'%20viewBox='0%200%2028%2028'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20clip-path='url(%23clip0_16001_77212)'%3e%3crect%20x='8.38574'%20y='7.97406'%20width='16.3333'%20height='10.5'%20rx='1'%20transform='rotate(30%208.38574%207.97406)'%20fill='%23848388'/%3e%3crect%20x='12.1572'%20y='6.10968'%20width='11.6667'%20height='4.66667'%20rx='1'%20transform='rotate(30%2012.1572%206.10968)'%20fill='%23848388'/%3e%3crect%20x='17.0938'%20y='2.22449'%20width='1.75'%20height='7'%20rx='0.875'%20transform='rotate(30%2017.0938%202.22449)'%20fill='%23848388'/%3e%3crect%20x='21.6406'%20y='4.84949'%20width='1.75'%20height='7'%20rx='0.875'%20transform='rotate(30%2021.6406%204.84949)'%20fill='%23848388'/%3e%3crect%20x='8.1875'%20y='19.984'%20width='4.66667'%20height='1.16667'%20transform='rotate(30%208.1875%2019.984)'%20fill='%23848388'/%3e%3cpath%20d='M9.62484%2022.161V22.161C8.7833%2023.6186%207.01132%2024.2541%205.43522%2023.6637L4.84375%2023.4421'%20stroke='%23848388'%20stroke-width='1.5'%20stroke-linecap='round'/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_16001_77212'%3e%3crect%20width='28'%20height='28'%20fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e";
const prioritySeat = "data:image/svg+xml,%3csvg%20width='28'%20height='28'%20viewBox='0%200%2028%2028'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M19.5458%2015.907C19.4584%2015.9676%2019.3554%2016%2019.25%2016C19.1446%2016%2019.0416%2015.9676%2018.9543%2015.907C17.5544%2014.9474%2011.6667%2010.6769%2011.6667%206.64781C11.6667%201.44892%2017.9861%200.725467%2019.25%203.90766C20.5139%200.725492%2026.8333%201.44892%2026.8333%206.64781C26.8333%2010.6777%2020.9456%2014.9474%2019.5458%2015.9054V15.907ZM20.2045%206.45455C20.2045%205.92736%2019.7772%205.5%2019.25%205.5C18.7228%205.5%2018.2955%205.92736%2018.2955%206.45455V8.04545H16.7045C16.1774%208.04545%2015.75%208.47282%2015.75%209C15.75%209.52718%2016.1774%209.95455%2016.7045%209.95455H18.2955V11.5455C18.2955%2012.0726%2018.7228%2012.5%2019.25%2012.5C19.7772%2012.5%2020.2045%2012.0726%2020.2045%2011.5455V9.95455H21.7955C22.3226%209.95455%2022.75%209.52718%2022.75%209C22.75%208.47282%2022.3226%208.04545%2021.7955%208.04545H20.2045V6.45455Z'%20fill='%23848388'/%3e%3cpath%20d='M1.75%206.88143C1.75%2012.5%204.66667%2017.1667%204.66667%2017.1667C4.66667%2017.1667%207.35%2016.1683%207.35%2013.3823C7.35%2011.8485%206.50143%2010.5962%205.73858%209.47039C5.11572%208.55117%204.55%207.7163%204.55%206.88143C4.55%205.7934%204.87027%205.34272%205.13559%204.96937C5.3232%204.70537%205.48333%204.48003%205.48333%204.09536C5.48333%203.16667%204.55%203.16667%204.55%203.16667H3.61667C3.61667%203.16667%201.75%203.16667%201.75%206.88143Z'%20fill='%23848388'/%3e%3cpath%20d='M5.25%2019.5C5.25%2019.5%207.81667%2017.1667%208.75%2017.1667H13.8815C14.9082%2017.1667%2015.75%2018.0257%2015.75%2019.0473V19.976C15.75%2020.9975%2014.91%2021.8333%2013.8833%2021.8333H8.28333C7.79042%2021.8333%207.36258%2021.7168%206.99982%2021.5452V24.4584H12.2499C12.7331%2024.4584%2013.1249%2024.8501%2013.1249%2025.3334C13.1249%2025.8166%2012.7331%2026.2084%2012.2499%2026.2084H6.24149C5.69381%2026.2084%205.24982%2025.7644%205.24982%2025.2167V20.0832C5.24982%2019.6%205.25%2019.5%205.25%2019.5Z'%20fill='%23848388'/%3e%3c/svg%3e";
const quiet = "data:image/svg+xml,%3csvg%20width='28'%20height='28'%20viewBox='0%200%2028%2028'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M21.6213%203.9827C21.999%203.6813%2022.5496%203.7432%2022.851%204.12095C25.1236%206.96934%2026.542%209.74777%2026.542%2014C26.542%2018.248%2025.127%2021.0872%2022.8452%2023.8862C22.5398%2024.2608%2021.9887%2024.3169%2021.6141%2024.0115C21.2396%2023.7062%2021.1834%2023.155%2021.4888%2022.7805C23.582%2020.2128%2024.792%2017.7518%2024.792%2014C24.792%2010.2524%2023.5854%207.84733%2021.483%205.21239C21.1816%204.83464%2021.2435%204.28409%2021.6213%203.9827ZM18.1512%206.75984C18.5416%206.47499%2019.089%206.56052%2019.3738%206.95089C20.8985%209.04029%2021.8753%2010.9565%2021.8753%2014C21.8753%2017.0481%2020.8565%2018.9837%2019.3778%2021.0436C19.096%2021.4362%2018.5493%2021.526%2018.1567%2021.2441C17.7642%2020.9623%2017.6744%2020.4156%2017.9562%2020.0231C19.3183%2018.1257%2020.1253%2016.5449%2020.1253%2014C20.1253%2011.4505%2019.3522%209.89005%2017.9602%207.98244C17.6753%207.59208%2017.7608%207.0447%2018.1512%206.75984Z'%20fill='%23848388'/%3e%3cpath%20d='M4.53654%208.17438H2.79199C2.36102%208.17438%201.94769%208.35854%201.64294%208.68635C1.3382%209.01415%201.16699%209.45875%201.16699%209.92234L1.16699%2018.0788C1.16699%2018.5423%201.3382%2018.9869%201.64294%2019.3147C1.94769%2019.6426%202.36102%2019.8267%202.79199%2019.8267H7.50923L13.7018%2025.2891L13.7465%2025.3262C14.025%2025.5478%2014.3622%2025.6676%2014.7087%2025.6678C15.1396%2025.6678%2015.553%2025.4822%2015.8577%2025.1544C16.1625%2024.8266%2016.3337%2024.382%2016.3337%2023.9184V18.9582L4.53654%208.17438Z'%20fill='%23848388'/%3e%3cpath%20d='M16.3337%2016.4834V4.08343C16.3338%203.76004%2016.2506%203.44293%2016.0932%203.16739C15.9358%202.89186%2015.7105%202.66868%2015.4422%202.5227C15.1739%202.37672%2014.8733%202.31365%2014.5737%202.34051C14.2741%202.36738%2013.9873%202.48312%2013.7452%202.67486L13.7005%202.71201L7.50788%208.17438H7.24396L16.3337%2016.4834Z'%20fill='%23848388'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M4.36497%204.30557C4.73879%203.96386%205.34487%203.96386%205.71868%204.30557L24.2194%2021.2172C24.5932%2021.5589%2024.2919%2021.8238%2023.9181%2022.1655C23.5443%2022.5072%2023.2395%2022.7964%2022.8657%2022.4546L4.36497%205.543C3.99116%205.2013%203.99116%204.64728%204.36497%204.30557Z'%20fill='%23848388'/%3e%3c/svg%3e";
const restaurant = "data:image/svg+xml,%3csvg%20width='32'%20height='32'%20viewBox='0%200%2032%2032'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M15.3761%2010.6705C18.2777%2010.6705%2021.1793%2010.6599%2024.0809%2010.6738C26.6612%2010.686%2028.6406%2012.4654%2028.9639%2015.0305C29.2852%2017.5802%2027.4259%2020.0605%2024.901%2020.3663C24.3001%2020.439%2024.0375%2020.637%2023.8436%2021.2374C23.4585%2022.4123%2022.7231%2023.4356%2021.7399%2024.165C20.7567%2024.8945%2019.5745%2025.2937%2018.3579%2025.3071C15.9061%2025.3425%2013.4532%2025.3398%2011.0012%2025.3122C7.65883%2025.2746%205.07383%2022.6586%205.02044%2019.2482C4.98313%2016.8666%205.00673%2014.484%205.01483%2012.1019C5.01797%2011.1408%205.48811%2010.6746%206.44669%2010.6727C9.42312%2010.6666%2012.3996%2010.6659%2015.3761%2010.6705ZM24.2325%2013.1853L24.2325%2017.945C25.5533%2018.0077%2026.5993%2016.9226%2026.5869%2015.5316C26.5745%2014.1731%2025.5173%2013.1075%2024.2322%2013.1853H24.2325Z'%20fill='%23848388'/%3e%3cpath%20d='M15.3526%203.60182C15.3583%203.67273%2015.3455%203.74383%2015.3153%203.80996C14.9425%204.31424%2015.1444%204.76365%2015.4138%205.24836C15.8414%206.01763%2015.6886%206.78858%2015.2398%207.51964C15.125%207.72146%2014.9228%207.87641%2014.6766%207.95115C14.4305%208.02589%2014.1601%208.01444%2013.9237%207.91926C13.4075%207.72278%2013.143%207.23707%2013.3939%206.78308C13.635%206.34674%2013.5838%205.98167%2013.3272%205.5708C12.8192%204.75782%2012.9429%203.93901%2013.4227%203.14808C13.5276%202.96586%2013.7035%202.82123%2013.9198%202.73955C14.1361%202.65786%2014.3788%202.64433%2014.6055%202.70134C15.0613%202.81556%2015.3567%203.15657%2015.3526%203.60182Z'%20fill='%23848388'/%3e%3cpath%20d='M11.3526%203.60182C11.3583%203.67273%2011.3455%203.74383%2011.3153%203.80996C10.9425%204.31424%2011.1444%204.76365%2011.4138%205.24836C11.8414%206.01763%2011.6886%206.78858%2011.2398%207.51964C11.125%207.72146%2010.9228%207.87641%2010.6766%207.95115C10.4305%208.02589%2010.1601%208.01444%209.92372%207.91926C9.40753%207.72278%209.143%207.23707%209.39389%206.78308C9.63502%206.34674%209.58378%205.98167%209.32718%205.5708C8.81921%204.75782%208.94287%203.93901%209.42271%203.14808C9.52755%202.96586%209.70353%202.82123%209.91981%202.73955C10.1361%202.65786%2010.3788%202.64433%2010.6055%202.70134C11.0613%202.81556%2011.3567%203.15657%2011.3526%203.60182Z'%20fill='%23848388'/%3e%3cpath%20d='M17.3151%207.06832C17.3096%206.99705%2017.3222%206.92561%2017.352%206.85894C17.711%206.35608%2017.5317%205.90767%2017.2566%205.42013C16.824%204.65369%2016.9771%203.88068%2017.4273%203.14962C17.5412%202.94744%2017.7426%202.79186%2017.9883%202.71639C18.234%202.64093%2018.5042%202.65162%2018.7408%202.74617C19.2572%202.94073%2019.5295%203.42969%2019.2732%203.87984C19.0137%204.33583%2019.106%204.71239%2019.3594%205.13033C19.8477%205.93565%2019.7121%206.73972%2019.2466%207.51631C19.1419%207.6985%2018.9663%207.84331%2018.7505%207.92558C18.5347%208.00785%2018.2922%208.02238%2018.0653%207.96664C17.841%207.91171%2017.6448%207.79309%2017.5086%207.63001C17.3724%207.46694%2017.3042%207.269%2017.3151%207.06832Z'%20fill='%23848388'/%3e%3cpath%20d='M4.92708%2028.2417C4.41926%2027.607%204.8712%2026.6666%205.68412%2026.6666L22.9832%2026.6666C23.7961%2026.6666%2024.2481%2027.607%2023.7402%2028.2417C23.1883%2028.9317%2022.3527%2029.3333%2021.4691%2029.3333L7.1982%2029.3333C6.31466%2029.3333%205.47902%2028.9317%204.92708%2028.2417Z'%20fill='%23848388'/%3e%3c/svg%3e";
const secondClass = "data:image/svg+xml,%3csvg%20width='13'%20height='17'%20viewBox='0%200%2013%2017'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M0.662162%2017V14.4451L6.57297%208.91763C7.07568%208.4263%207.4973%207.9841%207.83784%207.59104C8.18378%207.19798%208.44595%206.8131%208.62432%206.43642C8.8027%206.05427%208.89189%205.6421%208.89189%205.1999C8.89189%204.70857%208.78108%204.28549%208.55946%203.93064C8.33784%203.57033%208.03513%203.29464%207.65135%203.10356C7.26757%202.90703%206.83243%202.80877%206.34595%202.80877C5.83784%202.80877%205.39459%202.91249%205.01622%203.11994C4.63784%203.32739%204.34595%203.62492%204.14054%204.01252C3.93513%204.40013%203.83243%204.86143%203.83243%205.39643H0.5C0.5%204.29913%200.745946%203.3465%201.23784%202.53854C1.72973%201.73057%202.41892%201.10549%203.30541%200.663294C4.19189%200.221098%205.21351%200%206.37027%200C7.55946%200%208.59459%200.21291%209.47568%200.638729C10.3622%201.05909%2011.0514%201.64322%2011.5432%202.39114C12.0351%203.13905%2012.2811%203.99615%2012.2811%204.96243C12.2811%205.5957%2012.1568%206.22078%2011.9081%206.83767C11.6649%207.45456%2011.2297%208.13969%2010.6027%208.89306C9.97567%209.64098%209.09189%2010.539%207.95135%2011.5872L5.52703%2013.9865V14.1012H12.5V17H0.662162Z'%20fill='%23EFEFF1'/%3e%3c/svg%3e";
const stroller = "data:image/svg+xml,%3csvg%20width='28'%20height='28'%20viewBox='0%200%2028%2028'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M4.08366%2012.4833C4.08366%2011.839%204.60599%2011.3167%205.25033%2011.3167H23.917C24.5613%2011.3167%2025.0837%2011.839%2025.0837%2012.4833C25.0837%2015.705%2022.472%2018.3166%2019.2503%2018.3166H9.91699C6.69533%2018.3166%204.08366%2015.705%204.08366%2012.4833Z'%20fill='%23848388'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M2.04199%208.98332C2.04199%208.50007%202.43374%208.10832%202.91699%208.10832H4.95866C5.60299%208.10832%206.12533%208.63065%206.12533%209.27498V12.4833C6.12533%2012.9666%205.73358%2013.3583%205.25033%2013.3583C4.76708%2013.3583%204.37533%2012.9666%204.37533%2012.4833V9.85832H2.91699C2.43374%209.85832%202.04199%209.46657%202.04199%208.98332Z'%20fill='%23848388'/%3e%3cpath%20d='M11.0837%2023.5667C11.0837%2024.5331%2010.3002%2025.3167%209.33366%2025.3167C8.36716%2025.3167%207.58366%2024.5331%207.58366%2023.5667C7.58366%2022.6002%208.36716%2021.8167%209.33366%2021.8167C10.3002%2021.8167%2011.0837%2022.6002%2011.0837%2023.5667Z'%20fill='%23848388'/%3e%3cpath%20d='M20.417%2023.5667C20.417%2024.5331%2019.6335%2025.3167%2018.667%2025.3167C17.7005%2025.3167%2016.917%2024.5331%2016.917%2023.5667C16.917%2022.6002%2017.7005%2021.8167%2018.667%2021.8167C19.6335%2021.8167%2020.417%2022.6002%2020.417%2023.5667Z'%20fill='%23848388'/%3e%3cpath%20d='M17.5003%202.56665C17.0578%202.56665%2016.6242%202.60454%2016.2025%202.67727C15.9359%202.72324%2015.7503%202.96065%2015.7503%203.23116V8.39998C15.7503%208.88068%2016.2991%209.15507%2016.6837%208.86665L22.2048%204.72577C22.4914%204.51087%2022.5191%204.08851%2022.2336%203.87231C20.9379%202.89132%2019.3078%202.56665%2017.5003%202.56665Z'%20fill='%23848388'/%3e%3cpath%20d='M24.9879%208.9417C24.8204%207.89587%2024.4391%206.92145%2023.8903%206.0647C23.7187%205.79686%2023.3569%205.74395%2023.0994%205.93065L19.5398%208.51103C19.0821%208.84288%2019.3168%209.56665%2019.8822%209.56665H24.4321C24.7717%209.56665%2025.0416%209.27703%2024.9879%208.9417Z'%20fill='%23848388'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M9.78838%2017.2248C10.0693%2016.8316%2010.6157%2016.7405%2011.009%2017.0214L19.1756%2022.8547C19.5689%2023.1356%2019.66%2023.6821%2019.3791%2024.0753C19.0982%2024.4685%2018.5517%2024.5596%2018.1585%2024.2787L9.99181%2018.4454C9.59857%2018.1645%209.50749%2017.618%209.78838%2017.2248Z'%20fill='%23848388'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M18.2123%2017.2248C17.9314%2016.8316%2017.3849%2016.7405%2016.9917%2017.0214L8.82501%2022.8547C8.43177%2023.1356%208.34069%2023.6821%208.62157%2024.0753C8.90246%2024.4685%209.44894%2024.5596%209.84218%2024.2787L18.0088%2018.4454C18.4021%2018.1645%2018.4932%2017.618%2018.2123%2017.2248Z'%20fill='%23848388'/%3e%3c/svg%3e";
const trashBin = "data:image/svg+xml,%3csvg%20width='28'%20height='28'%20viewBox='0%200%2028%2028'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M17.214%202.98004C16.7085%202.61088%2016.1199%202.42373%2015.4936%202.36888C15.1093%202.33522%2014.6485%202.33473%2014.137%202.33418C14.0918%202.33413%2014.0463%202.33408%2014.0003%202.33401C13.9542%202.33393%2013.9081%202.33381%2013.862%202.33369C13.4239%202.33256%2012.9845%202.33142%2012.5483%202.37031C11.908%202.42739%2011.3074%202.62227%2010.7957%203.00668C10.4173%203.29092%2010.1587%203.63788%209.94024%204.01281C9.73771%204.3604%209.53609%204.79357%209.30715%205.28542L8.91314%206.13182L4.02533%206.13252C3.41321%206.13252%202.91699%206.61841%202.91699%207.21779C2.91699%207.81717%203.41321%208.30306%204.02533%208.30306H4.98922L5.57846%2017.9562C5.66159%2019.3182%205.72756%2020.399%205.8648%2021.2623C6.00554%2022.1477%206.23183%2022.885%206.68575%2023.5301C7.101%2024.1203%207.63598%2024.6184%208.25662%2024.9927C8.93504%2025.402%209.6929%2025.5809%2010.595%2025.6665L17.3843%2025.6667C18.2853%2025.5812%2019.0424%2025.4026%2019.7203%2024.9942C20.3405%2024.6205%2020.8754%2024.1232%2021.2908%2023.534C21.7448%2022.89%2021.9718%2022.1538%2022.1136%2021.2696C22.2519%2020.4075%2022.3193%2019.3282%2022.4043%2017.9682L23.0085%208.30306H23.9753C24.5874%208.30306%2025.0837%207.81717%2025.0837%207.21779C25.0837%206.61841%2024.5874%206.13252%2023.9753%206.13252L19.1895%206.13182L18.7169%205.17716C18.4821%204.70278%2018.2751%204.2846%2018.0695%203.9492C17.8476%203.58726%2017.5879%203.25305%2017.214%202.98004ZM16.7261%206.13182C16.4751%205.62497%2016.3144%205.30366%2016.1689%205.06624C15.9558%204.7186%2015.7004%204.5662%2015.2961%204.53079C15.0087%204.50562%2014.6342%204.50462%2014.0386%204.50462C13.4281%204.50462%2013.0438%204.50565%2012.7493%204.53191C12.3347%204.56887%2012.0761%204.72708%2011.8656%205.08845C11.7277%205.32515%2011.5775%205.64196%2011.3493%206.13182H16.7261ZM10.6761%2013.5295C10.217%2013.5295%209.84487%2013.9213%209.84487%2014.4045C9.84487%2014.8878%2010.217%2015.2795%2010.6761%2015.2795H17.3261C17.7852%2015.2795%2018.1574%2014.8878%2018.1574%2014.4045C18.1574%2013.9213%2017.7852%2013.5295%2017.3261%2013.5295H10.6761ZM11.5059%2018.6565C11.5059%2018.1732%2011.8781%2017.7815%2012.3372%2017.7815H15.6622C16.1213%2017.7815%2016.4934%2018.1732%2016.4934%2018.6565C16.4934%2019.1397%2016.1213%2019.5315%2015.6622%2019.5315H12.3372C11.8781%2019.5315%2011.5059%2019.1397%2011.5059%2018.6565Z'%20fill='%23848388'/%3e%3c/svg%3e";
const wc = "data:image/svg+xml,%3csvg%20width='32'%20height='27'%20viewBox='0%200%2032%2027'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20clip-path='url(%23clip0_15025_43671)'%3e%3cpath%20d='M6.59387%207.40974C8.61917%207.40974%2010.261%205.75102%2010.261%203.70487C10.261%201.65873%208.61917%200%206.59387%200C4.56858%200%202.92676%201.65873%202.92676%203.70487C2.92676%205.75102%204.56858%207.40974%206.59387%207.40974Z'%20fill='%23848388'/%3e%3cpath%20d='M10.7203%208.97266H2.46527C0.634976%208.97266%20-0.555584%2011.4822%200.263252%2013.6184L4.92047%2025.7637C5.03352%2026.1223%205.25654%2026.4353%205.55729%2026.6574C5.85803%2026.8795%206.22091%2026.9992%206.59344%2026.9992C6.96597%2026.9992%207.32885%2026.8795%207.62959%2026.6574C7.93034%2026.4353%208.15336%2026.1223%208.26641%2025.7637L12.9236%2013.6184C13.742%2011.484%2012.5506%208.97266%2010.7203%208.97266Z'%20fill='%23848388'/%3e%3cpath%20d='M24.6114%207.4002C26.6316%207.25515%2028.1529%205.48301%2028.0093%203.44202C27.8658%201.40102%2026.1117%20-0.13595%2024.0915%200.00909701C22.0713%200.154144%2020.55%201.92628%2020.6935%203.96728C20.8371%206.00828%2022.5912%207.54525%2024.6114%207.4002Z'%20fill='%23848388'/%3e%3cpath%20d='M19.1686%2027H29.535C31.3653%2027%2032.5554%2024.704%2031.737%2022.7527L26.2679%209.9206C26.1479%209.56549%2025.9213%209.25699%2025.6197%209.03802C25.3181%208.81905%2024.9564%208.7005%2024.5849%208.69885H24.2015C23.8318%208.70041%2023.4717%208.81778%2023.1708%209.03478C22.8699%209.25179%2022.6431%209.55775%2022.5215%209.91048L16.9661%2022.7527C16.1477%2024.704%2017.3383%2027%2019.1686%2027Z'%20fill='%23848388'/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_15025_43671'%3e%3crect%20width='32'%20height='27'%20fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e";
const wheelchair = "data:image/svg+xml,%3csvg%20width='32'%20height='32'%20viewBox='0%200%2032%2032'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M12.667%2029.3333C17.0853%2029.3333%2020.667%2025.7516%2020.667%2021.3333C20.667%2016.9151%2017.0853%2013.3333%2012.667%2013.3333C8.24871%2013.3333%204.66699%2016.9151%204.66699%2021.3333C4.66699%2025.7516%208.24871%2029.3333%2012.667%2029.3333ZM12.667%2026.6667C15.6125%2026.6667%2018.0003%2024.2789%2018.0003%2021.3333C18.0003%2018.3878%2015.6125%2016%2012.667%2016C9.72147%2016%207.33366%2018.3878%207.33366%2021.3333C7.33366%2024.2789%209.72147%2026.6667%2012.667%2026.6667Z'%20fill='%23848388'/%3e%3cpath%20d='M22.0003%2022.6667H24.0003V28H22.0003V22.6667Z'%20fill='%23848388'/%3e%3cpath%20d='M24.667%2028C24.667%2028.7364%2024.07%2029.3333%2023.3337%2029.3333C22.5973%2029.3333%2022.0003%2028.7364%2022.0003%2028C22.0003%2027.2636%2022.5973%2026.6667%2023.3337%2026.6667C24.07%2026.6667%2024.667%2027.2636%2024.667%2028Z'%20fill='%23848388'/%3e%3cpath%20d='M23.3337%2026.6667H28.667V28.6667H23.3337V26.6667Z'%20fill='%23848388'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M21.9057%2022.6667C21.968%2022.2312%2022.0002%2021.786%2022.0002%2021.3333C22.0002%2018.7217%2020.9276%2016.3607%2019.1989%2014.6667H22.0002C24.2094%2014.6667%2026.0002%2016.4575%2026.0002%2018.6667V22.6667H21.9057Z'%20fill='%23848388'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M8.66699%2010.3333C8.66699%209.78105%208.96547%209.33333%209.33366%209.33333H16.0003C16.3685%209.33333%2016.667%209.78105%2016.667%2010.3333C16.667%2010.8856%2016.3685%2011.3333%2016.0003%2011.3333H9.33366C8.96547%2011.3333%208.66699%2010.8856%208.66699%2010.3333Z'%20fill='%23848388'/%3e%3cpath%20d='M16.667%2021.3333C16.667%2023.5425%2014.8761%2025.3333%2012.667%2025.3333C10.4579%2025.3333%208.66699%2023.5425%208.66699%2021.3333C8.66699%2019.1242%2010.4579%2017.3333%2012.667%2017.3333C14.8761%2017.3333%2016.667%2019.1242%2016.667%2021.3333Z'%20fill='%23848388'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M1.66699%204C1.66699%203.44772%202.11471%203%202.66699%203H6.37265C7.37698%203%208.26864%203.64267%208.58624%204.59547L9.66699%207.83772V16C9.66699%2016.5523%209.21928%2017%208.66699%2017C8.11471%2017%207.66699%2016.5523%207.66699%2016V8.16228L6.68887%205.22792C6.6435%205.09181%206.51612%205%206.37265%205H2.66699C2.11471%205%201.66699%204.55228%201.66699%204Z'%20fill='%23848388'/%3e%3cpath%20d='M8.66699%206.66667H11.3337V14.6667H8.66699V6.66667Z'%20fill='%23848388'/%3e%3c/svg%3e";
const serviceLabels = {
  WC: wc,
  wc_sign: wc,
  STROLLER: stroller,
  WHEELCHAIR: wheelchair,
  RESTAURANT: restaurant,
  LUGGAGE: luggage,
  "2nd_class_sign": secondClass,
  no_phone_area_sign: noPhone,
  "1st_class_sign": firstClass,
  quiet_sign: quiet,
  trash_bin_sign: trashBin,
  luggage_sign: luggage,
  bike_sign: bike,
  phone_area_sign: phone,
  family_area_sign: family,
  prm_sign: wheelchair,
  stroller_sign: stroller,
  bar_area_sign: bar,
  restaurant_car_sign: restaurant,
  power_outlet_sign: powerOutlet,
  conference_compartment_sign: conferenceRoom,
  luggage_locker_sign: luggageLocker,
  children_play_area_sign: childrenPlayArea,
  coat_rack_sign: hanger,
  infant_area_sign: infantCompartment,
  priority_seats_sign: prioritySeat
};
const accessibilityMap = {
  WC: "accessibility.images.serviceLabels.WC",
  wc_sign: "accessibility.images.serviceLabels.wc_sign",
  STROLLER: "accessibility.images.serviceLabels.STROLLER",
  WHEELCHAIR: "accessibility.images.serviceLabels.WHEELCHAIR",
  RESTAURANT: "accessibility.images.serviceLabels.RESTAURANT",
  LUGGAGE: "accessibility.images.serviceLabels.LUGGAGE",
  "2nd_class_sign": "accessibility.images.serviceLabels.2nd_class_sign",
  no_phone_area_sign: "accessibility.images.serviceLabels.no_phone_area_sign",
  "1st_class_sign": "accessibility.images.serviceLabels.1st_class_sign",
  quiet_sign: "accessibility.images.serviceLabels.quiet_sign",
  trash_bin_sign: "accessibility.images.serviceLabels.trash_bin_sign",
  luggage_sign: "accessibility.images.serviceLabels.luggage_sign",
  bike_sign: "accessibility.images.serviceLabels.bike_sign",
  phone_area_sign: "accessibility.images.serviceLabels.phone_area_sign",
  family_area_sign: "accessibility.images.serviceLabels.family_area_sign",
  prm_sign: "accessibility.images.serviceLabels.prm_sign",
  stroller_sign: "accessibility.images.serviceLabels.stroller_sign",
  bar_area_sign: "accessibility.images.serviceLabels.bar_area_sign",
  restaurant_car_sign: "accessibility.images.serviceLabels.restaurant_car_sign",
  power_outlet_sign: "accessibility.images.serviceLabels.power_outlet_sign",
  conference_compartment_sign: "accessibility.images.serviceLabels.conference_compartment_sign",
  luggage_locker_sign: "accessibility.images.serviceLabels.luggage_locker_sign",
  children_play_area_sign: "accessibility.images.serviceLabels.children_play_area_sign",
  coat_rack_sign: "accessibility.images.serviceLabels.coat_rack_sign",
  infant_area_sign: "accessibility.images.serviceLabels.infant_area_sign",
  priority_seats_sign: "accessibility.images.serviceLabels.priority_seats_sign"
};
const darkBackgroundIcons = ["1st_class_sign", "2nd_class_sign"];
const ServiceSeat = ({ position, code, size }) => {
  const seatSelection = useSeatSelectionUtils();
  const { t } = useTranslation();
  const gridPlacement = seatSelection.getGridPlacement(position, size);
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: bem("seat-selection-service-seat", { dark: darkBackgroundIcons.includes(code) }),
      style: { ...gridPlacement },
      children: /* @__PURE__ */ jsx(
        "img",
        {
          src: serviceLabels[code],
          alt: t(accessibilityMap[code]),
          className: bem("seat-selection", "labeled-seat", { code })
        }
      )
    }
  );
};
const TableSeat = ({ neighbors, position, size }) => {
  const seatSelection = useSeatSelectionUtils();
  return /* @__PURE__ */ jsx(
    "div",
    {
      "data-tag": `table-row-${position.x + 1}-column-${position.y + 1}`,
      className: bem("seat-selection-table"),
      style: seatSelection.getGridPlacement(position, size),
      children: /* @__PURE__ */ jsx("div", { className: bem("seat-selection-table", "deck"), children: neighbors?.map((neighbour) => /* @__PURE__ */ jsx("div", { className: bem("seat-selection-table", "link", { [neighbour]: true }) }, neighbour)) })
    }
  );
};
const isServiceSeat = (props) => !!serviceLabels[props.code];
const isIconSeat = (props) => !!iconsMap[props.code];
const isTableSeat = (props) => ["TABLE"].includes(props.code);
const SeatComponent = (props) => {
  if (isTableSeat(props)) {
    return /* @__PURE__ */ jsx(TableSeat, { ...props });
  }
  if (isServiceSeat(props)) {
    return /* @__PURE__ */ jsx(ServiceSeat, { ...props });
  }
  if (isIconSeat(props)) {
    return /* @__PURE__ */ jsx(IconSeat, { ...props });
  }
  return /* @__PURE__ */ jsx(PassengerSeat, { ...props });
};
const DISCOUNT_SIGN = "%";
const Content = ({
  amenities,
  hasPaidSeats,
  priceCategories,
  hasDiscountedSeats,
  showFemaleOnly
}) => {
  const { currency: currency2 } = useSettings();
  const seat = useSeatSelectionUtils();
  const { t } = useTranslation();
  return /* @__PURE__ */ jsxs("div", { className: "seat-selection__legend column row-lg mb-4", children: [
    amenities && /* @__PURE__ */ jsx("div", { className: "seat-selection__legend-amenities cell basis-auto", children: /* @__PURE__ */ jsx("div", { className: "row row gap-2", children: amenities }) }),
    /* @__PURE__ */ jsxs("div", { className: "seat-selection__legend-info gap-3 wrap column row-lg", children: [
      hasDiscountedSeats && /* @__PURE__ */ jsxs("div", { className: "row items-center", children: [
        /* @__PURE__ */ jsx("div", { className: bem("seat-selection", "legend-seat", { discounted: true }), children: DISCOUNT_SIGN }),
        /* @__PURE__ */ jsx("span", { children: t("seats.discounted") })
      ] }),
      hasPaidSeats && Object.entries(priceCategories).map(([price, count]) => /* @__PURE__ */ jsxs("div", { className: "row items-center", children: [
        /* @__PURE__ */ jsx("div", { className: bem("seat-selection", "legend-seat", { paid: true }), children: /* @__PURE__ */ jsx("span", { className: "row items-center mb-1 mb-lg-2", children: new Array(count).fill(seat.getCurrencyIcon(currency2)).map((icon, index) => /* @__PURE__ */ jsx(Icon, { className: bem("seat-selection", "legend-seat-sign"), name: icon, size: "small" }, index)) }) }),
        /* @__PURE__ */ jsxs("span", { children: [
          "+",
          /* @__PURE__ */ jsx(Money, { fractional: Number(price), currency: currency2 })
        ] })
      ] }, price)),
      /* @__PURE__ */ jsxs("div", { className: "row items-center", children: [
        /* @__PURE__ */ jsx("div", { className: bem("seat-selection", "legend-seat") }),
        /* @__PURE__ */ jsx("span", { children: t(hasPaidSeats ? "seats.free" : "seats.available") })
      ] }),
      showFemaleOnly && /* @__PURE__ */ jsxs("div", { className: "row items-center", children: [
        /* @__PURE__ */ jsx("div", { className: bem("seat-selection", "legend-seat", { "female-only": true }), children: /* @__PURE__ */ jsx("img", { src: femaleSymbol, alt: "female" }) }),
        /* @__PURE__ */ jsx("span", { children: t("seats.female_only_legend") })
      ] }),
      /* @__PURE__ */ jsxs("div", { className: "row items-center", children: [
        /* @__PURE__ */ jsx("div", { className: bem("seat-selection", "legend-seat", { disabled: true }), children: /* @__PURE__ */ jsx(Icon, { name: "cross", size: "medium" }) }),
        /* @__PURE__ */ jsx("span", { children: t("seats.not_available") })
      ] }),
      /* @__PURE__ */ jsxs("div", { className: "row items-center", children: [
        /* @__PURE__ */ jsx("div", { className: bem("seat-selection", "legend-seat", { selected: true }), children: /* @__PURE__ */ jsx(Icon, { name: "checkout", size: "medium" }) }),
        /* @__PURE__ */ jsx("span", { children: t("seats.your_seat") })
      ] })
    ] })
  ] });
};
const Mobile$1 = ({ opened, onClose, ...rest }) => {
  const { t } = useTranslation();
  return /* @__PURE__ */ jsx(Modal, { className: "seat-selection__legend-modal", title: t("seats.key"), opened: !!opened, onClose, children: /* @__PURE__ */ jsx(Content, { ...rest }) });
};
const Legend = ({ modal, ...rest }) => {
  const isMobile = useIsMobile();
  return modal && isMobile ? /* @__PURE__ */ jsx(Mobile$1, { ...rest }) : /* @__PURE__ */ jsx(Content, { ...rest });
};
function lastUniqueBy(items, iteratee) {
  return items && reverse(uniqBy(reverse(items), iteratee));
}
const Deck = (props) => {
  const {
    seats,
    priceCategories,
    passengerCard,
    legendOpened,
    onLegendClose,
    onClick,
    selectedSeats,
    amenities,
    discountCategories,
    deckSize,
    startX
  } = props;
  const { checkIsFemaleOnly } = useSettings();
  const isMobile = useIsMobile();
  const hasPaidSeats = seats.some((seat) => !!seat.price);
  const hasExclusiveSeat = useCallback(
    (discount) => !!discount.meta?.exclusive && discount.name === passengerCard,
    [passengerCard]
  );
  const isExclusiveSeats = useMemo(
    () => seats.some((car) => car.limitations?.some(hasExclusiveSeat)),
    [hasExclusiveSeat, seats]
  );
  const isDiscountAvailable = useMemo(
    () => discountCategories.some(
      ({ name, meta }) => name === passengerCard && (meta?.amount_left ?? 0) > selectedSeats.length
    ),
    [discountCategories, passengerCard, selectedSeats]
  );
  const getVacancy = useCallback(
    (seat) => {
      if (!discountCategories.length) return seat.vacant;
      if (isExclusiveSeats) return !!seat.limitations?.some(hasExclusiveSeat);
      if (isDiscountAvailable || !passengerCard) return !!seat.limitations?.every((item) => !item.meta?.exclusive);
      return selectedSeats.some((item) => item.code === seat.code);
    },
    [discountCategories, isExclusiveSeats, hasExclusiveSeat, isDiscountAvailable, passengerCard, selectedSeats]
  );
  const getDiscountCategory = useCallback(
    (seat) => {
      if (seat.limitations?.length || isExclusiveSeats) return seat.limitations;
      return discountCategories.filter(({ name }) => passengerCard === name);
    },
    [discountCategories, isExclusiveSeats, passengerCard]
  );
  const normalizedSeats = useMemo(() => {
    return lastUniqueBy(
      seats.map((seat) => {
        const x = seat.coordinates.x - startX;
        let coordinates = isMobile ? { ...seat.coordinates, x: x + 2 } : { ...seat.coordinates, x: deckSize.length - x - 2 };
        if (seat.code === "ES") coordinates = { ...seat.coordinates, x: coordinates.x, y: coordinates.y - 1 };
        return { ...seat, coordinates, orientation: isMobile ? "facingBackward" : "facingForward" };
      }),
      "id"
    );
  }, [deckSize.length, isMobile, startX, seats]);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      Legend,
      {
        modal: true,
        opened: legendOpened,
        onClose: onLegendClose,
        amenities,
        hasPaidSeats,
        priceCategories,
        hasDiscountedSeats: discountCategories.length > 0,
        showFemaleOnly: !!checkIsFemaleOnly
      }
    ),
    /* @__PURE__ */ jsx("div", { className: "column items-center pb-3 px-2 overflow-auto", children: /* @__PURE__ */ jsx("div", { className: "cell", children: /* @__PURE__ */ jsxs(DeckFrame, { lights: true, bus: true, orientation: isMobile ? "up" : "right", size: deckSize, children: [
      /* @__PURE__ */ jsx(
        SeatComponent,
        {
          code: "steeringWheel",
          position: isMobile ? { x: 0, y: 0 } : { x: deckSize.length, y: 0 },
          orientation: isMobile ? "facingBackward" : "facingForward"
        }
      ),
      normalizedSeats.map((seat, index) => /* @__PURE__ */ jsx(
        SeatComponent,
        {
          code: seat.code,
          price: seat.price,
          priceCategory: priceCategories[seat.price ?? 0],
          discountCategory: getDiscountCategory(seat),
          orientation: seat.orientation,
          position: seat.coordinates,
          disabled: !seat.vacant || !getVacancy(seat),
          label: seat.label,
          onSelect: () => {
            onClick(seat);
          },
          selected: selectedSeats.some((item) => item.code === seat.code),
          isFirstSeat: index === 0,
          size: seat.size,
          femaleOnly: checkIsFemaleOnly?.(seat) ?? false
        },
        seat.id
      ))
    ] }) }) })
  ] });
};
const DiscountsDropdown = (props) => {
  const { discountCategories, passengerCard, setPassengerCard, hasSelectedSeats, discounts } = props;
  const { t } = useTranslation();
  const availableCards = useMemo(
    () => discounts.filter((c) => c.context === "pax" && c.cardType === "discount_card") ?? /* istanbul ignore next: handle array.find */
    [],
    [discounts]
  );
  const getAmountLeft = useCallback(
    (card) => discountCategories.find((item) => item.name === card)?.meta?.amount_left,
    [discountCategories]
  );
  const cardOptions = useMemo(() => {
    return availableCards.map((card) => ({
      value: card.name,
      label: /* @__PURE__ */ jsxs("div", { className: "row space-between", children: [
        /* @__PURE__ */ jsx("span", { className: "mr-1", children: card.marketingName }),
        /* @__PURE__ */ jsx("span", { className: "seat-selection__legend-discounts", children: t("seats.ticketsLeft", { count: getAmountLeft(card.name) }) })
      ] }),
      selectedLabel: card.marketingName
    }));
  }, [availableCards, getAmountLeft, t]);
  return /* @__PURE__ */ jsx("div", { "data-tag": "seat-selection-card-dropdown", className: "seat-selection__card-dropdown", children: /* @__PURE__ */ jsx(
    Dropdown,
    {
      items: cardOptions,
      label: t("checkout.passengerDetails.discount"),
      value: passengerCard,
      onChange: setPassengerCard,
      onReset: () => setPassengerCard(null),
      disabled: hasSelectedSeats,
      resettable: true
    }
  ) });
};
const hasFeature = (feature, code) => feature.code === code;
const isFullyRefundable = (feature) => hasFeature(feature, "REFU");
const isPartiallyRefundable = (feature) => hasFeature(feature, "PREF");
const isNotRefundable = (feature) => hasFeature(feature, "NREF");
const isVoucherRefund = (feature) => hasFeature(feature, "VREF");
const isAmendable = (feature) => hasFeature(feature, "AMEN");
const isNonAmendable = (feature) => hasFeature(feature, "NAME");
const hasRefundFeatures = (feature) => {
  return [
    isFullyRefundable(feature),
    isPartiallyRefundable(feature),
    isNotRefundable(feature),
    isVoucherRefund(feature),
    isAmendable(feature),
    isNonAmendable(feature)
  ].some((item) => item);
};
const SEPARATOR = " - ";
const FareClassDropdown = ({ value, onChange, fares, showSegmentPrice }) => {
  const { t } = useTranslation();
  const items = fares.map((fare) => ({
    label: /* @__PURE__ */ jsxs("div", { className: "row space-between", children: [
      /* @__PURE__ */ jsx("span", { children: fare.fareClass.name }),
      showSegmentPrice && /* @__PURE__ */ jsx("span", { children: /* @__PURE__ */ jsx(Money, { ...fare.price }) })
    ] }),
    value: fare.fareClass.code,
    selectedLabel: /* @__PURE__ */ jsxs("div", { className: "row mr-1", children: [
      /* @__PURE__ */ jsx("span", { className: "fare-dropdown__name body-16 bold", children: fare.fareClass.name }),
      showSegmentPrice && /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx("span", { className: "mx-1", children: SEPARATOR }),
        /* @__PURE__ */ jsx("span", { className: "body-16 bold", children: /* @__PURE__ */ jsx(Money, { ...fare.price }) })
      ] })
    ] })
  }));
  return /* @__PURE__ */ jsx(
    Dropdown,
    {
      className: "fare-dropdown",
      label: t("card.fareClass"),
      items,
      value,
      onChange,
      popperProps: { className: "fare-dropdown__popper" }
    }
  );
};
const FareFeatures = ({ fareFeatures, media }) => {
  const isMobile = useIsMobile();
  const [hide, setHide] = useState(false);
  const handleScroll = (e) => {
    const scrollLeft = e.currentTarget.scrollLeft;
    const scrollWidth = e.currentTarget.scrollWidth;
    const clientWidth = e.currentTarget.clientWidth;
    const gap = 100;
    setHide(scrollLeft + clientWidth - (hide ? gap / 2 : 0) > scrollWidth - gap);
  };
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: bem("carriers", "fares-feature-wrapper", { media }),
      onScroll: fareFeatures.length > 4 ? handleScroll : void 0,
      "data-tag": "fare-features-list",
      children: [
        fareFeatures.map((item) => /* @__PURE__ */ jsxs("div", { className: "carriers__fares-feature", "data-tag": "fare-feature", children: [
          /* @__PURE__ */ jsx(Icon, { name: getFareFeatureIcon(item.code), size: "large" }),
          /* @__PURE__ */ jsx("span", { className: bem("carriers", "fares-description"), children: item.name })
        ] }, item.id)),
        fareFeatures.length > 4 && isMobile && /* @__PURE__ */ jsx("div", { className: bem("carriers", "fares-blur", { hide }) })
      ]
    }
  );
};
const Item = ({ icon, title }) => {
  return /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsxs("span", { className: bem("trip-conditions", "wrapper"), children: [
    /* @__PURE__ */ jsx("span", { className: bem("trip-conditions", "icon"), children: /* @__PURE__ */ jsx(Icon, { name: icon, size: "medium" }) }),
    /* @__PURE__ */ jsx("span", { className: bem("trip-conditions", "title"), children: title })
  ] }) });
};
const RefundableMessage = ({ fareFeatures }) => {
  const { t } = useTranslation();
  switch (true) {
    case isFullyRefundable(fareFeatures):
      return t("checkout.tripDetails.refundable.full");
    case isPartiallyRefundable(fareFeatures):
      return t("checkout.tripDetails.refundable.partial");
    case isNotRefundable(fareFeatures):
      return t("checkout.tripDetails.refundable.not");
    case isVoucherRefund(fareFeatures):
      return t("checkout.tripDetails.refundable.voucher");
    case isAmendable(fareFeatures):
      return t("checkout.tripDetails.amendable.full");
    case isNonAmendable(fareFeatures):
      return t("checkout.tripDetails.amendable.not");
  }
  return null;
};
const TripConditions = ({
  fareFeatures = [],
  validityMessage,
  showDescription = false
}) => {
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs("div", { className: "row gap-2 wrap trip-conditions", "data-tag": "trip-conditions", children: [
      uniqBy(fareFeatures, "code").map((item) => /* @__PURE__ */ jsx(
        Item,
        {
          icon: getFareFeatureIcon(item.code),
          title: /* @__PURE__ */ jsx(RefundableMessage, { fareFeatures: item })
        },
        item.code
      )),
      validityMessage && /* @__PURE__ */ jsx(Item, { icon: "clock", title: validityMessage })
    ] }),
    showDescription && fareFeatures.map(({ description, code }) => /* @__PURE__ */ jsx("p", { className: "trip-conditions__description cell-lg-6", children: description }, code))
  ] });
};
const Desktop = ({ fares, value, onChange, showSegmentPrice }) => {
  const faresTabs = useMemo(
    () => fares.map((item) => ({
      value: item.fareClass.code,
      label: /* @__PURE__ */ jsxs("div", { className: "column", children: [
        /* @__PURE__ */ jsx("span", { children: item.fareClass.name }),
        showSegmentPrice && /* @__PURE__ */ jsx("span", { className: "normal", children: /* @__PURE__ */ jsx(Money, { ...item.price }) })
      ] })
    })).filter((item) => item.label),
    [fares, showSegmentPrice]
  );
  if (faresTabs.length <= 1) return null;
  return /* @__PURE__ */ jsx(Tabs, { options: faresTabs, value, onClick: onChange });
};
const Mobile = ({ fares, value, onChange, showSegmentPrice }) => {
  const [opened, setOpened] = useState(false);
  const selectedFare = fares?.find((item) => item.fareClass.code === value);
  const segmentFareFeatures = selectedFare?.fareClass.fareFeatures ?? [];
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs("div", { className: "row space-between items-center", children: [
      /* @__PURE__ */ jsx(FareClassDropdown, { value, onChange, fares, showSegmentPrice }),
      /* @__PURE__ */ jsx(Icon, { name: "info", size: "medium", className: "ml-2 mr-1", onClick: () => setOpened(true) })
    ] }),
    /* @__PURE__ */ jsxs(
      Modal,
      {
        title: selectedFare?.fareClass.name,
        className: bem("seat-selection", "tabs-fares-modal"),
        opened,
        onClose: () => setOpened(false),
        children: [
          /* @__PURE__ */ jsx(FareFeatures, { fareFeatures: segmentFareFeatures.filter((item) => !hasRefundFeatures(item)) }),
          /* @__PURE__ */ jsx(
            TripConditions,
            {
              fareFeatures: segmentFareFeatures.filter(hasRefundFeatures),
              showDescription: true
            }
          )
        ]
      }
    )
  ] });
};
const SeatsFareClasses = (props) => {
  const seatSelectionUtils = useSeatSelectionUtils();
  const isMobile = useIsMobile();
  const { connection, segmentLayout, value, ...rest } = props;
  const segmentFares = connection?.segments[segmentLayout.segment.index]?.fares;
  const connectionFares = connection?.fares;
  const fares = segmentFares?.length ? segmentFares : connectionFares;
  const seatsFareClasses = seatSelectionUtils.getUniqueFares(props.segmentLayout);
  const filteredFares = fares?.filter((item) => seatsFareClasses.includes(item.fareClass.code)) ?? [];
  const supportedValue = filteredFares.find((fare) => fare.fareClass.code === value)?.fareClass.code ?? filteredFares[0]?.fareClass.code;
  return /* @__PURE__ */ jsx("div", { className: bem("seat-selection", "tabs-fares"), children: isMobile ? /* @__PURE__ */ jsx(Mobile, { value: supportedValue, fares: filteredFares, ...rest }) : /* @__PURE__ */ jsx(Desktop, { value: supportedValue, fares: filteredFares, ...rest }) });
};
const Footer = (props) => {
  const { passengerCount, onClick, reservedSeatsCount, requiredSeats, price, outboundSeatsCount, warnMaxSeats } = props;
  const { t } = useTranslation();
  const { maxPassengers } = useSettings();
  const isMobile = useIsMobile();
  const [isAnimationInProgress, setIsAnimationInProgress] = useState(false);
  const limitSeatCountToReserved = reservedSeatsCount != void 0;
  const seatCountLimit = outboundSeatsCount === 0 ? maxPassengers : outboundSeatsCount;
  const enableWarning = warnMaxSeats && passengerCount > seatCountLimit;
  const limitByMaxSeats = warnMaxSeats && !outboundSeatsCount && !requiredSeats;
  const limitByReservedSeats = limitSeatCountToReserved || !!outboundSeatsCount || requiredSeats;
  const disableButton = useMemo(() => {
    if (limitSeatCountToReserved) return passengerCount > 0 && passengerCount !== reservedSeatsCount;
    if (outboundSeatsCount) return passengerCount !== outboundSeatsCount;
    if (requiredSeats) return passengerCount !== requiredSeats;
    return passengerCount === 0 || passengerCount > seatCountLimit;
  }, [limitSeatCountToReserved, seatCountLimit, outboundSeatsCount, passengerCount, requiredSeats, reservedSeatsCount]);
  const disabledTooltip = limitSeatCountToReserved && outboundSeatsCount === 0 || !disableButton || isAnimationInProgress;
  const handleClick = () => {
    setIsAnimationInProgress(true);
    onClick();
  };
  const maxReservedSeats = requiredSeats ? requiredSeats : outboundSeatsCount || reservedSeatsCount;
  return /* @__PURE__ */ jsxs("div", { className: "column seat-selection__footer", children: [
    /* @__PURE__ */ jsxs("div", { className: "row end gap-7", children: [
      /* @__PURE__ */ jsxs("span", { className: "mb-1", children: [
        /* @__PURE__ */ jsx("span", { className: bem("seat-selection", "footer-title"), children: `${t("seats.selected_seats")}: ` }),
        limitByReservedSeats && /* @__PURE__ */ jsxs("span", { children: [
          passengerCount,
          "/",
          maxReservedSeats
        ] }),
        limitByMaxSeats && /* @__PURE__ */ jsx("span", { className: bem("seat-selection", "footer-limit", { warning: passengerCount > seatCountLimit }), children: passengerCount })
      ] }),
      price && /* @__PURE__ */ jsx("span", { className: "seat-selection__footer-price mb-1", "data-tag": "seat-selection-footer-price", children: /* @__PURE__ */ jsx(Money, { ...price }) })
    ] }),
    enableWarning && /* @__PURE__ */ jsxs("div", { className: "seat-selection__footer-alert row items-center mb-1", children: [
      /* @__PURE__ */ jsx("span", { className: "pr-1", children: /* @__PURE__ */ jsx(Icon, { name: "alert", size: "small" }) }),
      /* @__PURE__ */ jsx("span", { children: t("seats.warning.max_seats", { count: seatCountLimit }) })
    ] }),
    /* @__PURE__ */ jsx(Button, { color: "secondary", disabled: disableButton, onClick: handleClick, children: /* @__PURE__ */ jsx(
      Tooltip,
      {
        action: isMobile ? "click" : "hover",
        content: t("seats.warning.selected_pax", { count: outboundSeatsCount || reservedSeatsCount }),
        position: isMobile ? "top" : "left",
        disabled: disabledTooltip,
        children: t("seats.continue")
      }
    ) })
  ] });
};
const SegmentLabel = (props) => {
  const { segment, segmentsCount, onNavigateBack, connection, currentIndex } = props;
  const { departureStation, arrivalStation } = segment;
  const getName2 = (stationCode) => {
    const stations = connection?.segments.flatMap(({ departureStation: departureStation2, arrivalStation: arrivalStation2 }) => [
      departureStation2,
      arrivalStation2
    ]);
    return stations?.find(({ code }) => stationCode === code)?.name;
  };
  const departureStationName = getName2(departureStation.code);
  const arrivalStationName = getName2(arrivalStation.code);
  return /* @__PURE__ */ jsxs("div", { className: "seat-selection__header-stations", children: [
    currentIndex >= 1 && onNavigateBack && /* @__PURE__ */ jsx(Icon, { onClick: onNavigateBack, name: "back-arrow", size: "medium" }),
    segmentsCount > 1 && /* @__PURE__ */ jsxs("span", { className: "cell-1-sm", children: [
      /* @__PURE__ */ jsx("b", { children: currentIndex + 1 }),
      /* @__PURE__ */ jsx("span", { children: "/" }),
      /* @__PURE__ */ jsx("span", { className: bem("seat-selection", "header-stations-leg"), children: segmentsCount })
    ] }),
    departureStationName && arrivalStationName && /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx("span", { className: "seat-selection__header-stations-name cell-4-sm", children: departureStationName }),
      /* @__PURE__ */ jsx(Icon, { name: "arrow-right", size: "medium" }),
      /* @__PURE__ */ jsx("span", { className: "seat-selection__header-stations-name cell-4-sm", children: arrivalStationName })
    ] })
  ] });
};
const getInitialLevel = (layout, fareClassCode) => {
  return layout?.cars[0].seats.find((item) => item.fareClass === fareClassCode)?.coordinates.z ?? 0;
};
const isSeat = (seat) => seat.code !== "WC" && seat.code !== "ES";
const getSegmentIndex$1 = (data) => data.segment.index;
const SeatSelectionBus = withUISettingsProvider(
  ({
    opened,
    layout,
    connections,
    reservedSeatsCount,
    onSubmit,
    onClose,
    fareFilter,
    initialFare,
    outboundSeatsCount: _outboundSeatsCount,
    warnMaxSeats,
    isFullPrice,
    requiredSeats,
    discountDropdown,
    initialSelection,
    showSegmentPrice,
    currentSegment,
    onSegmentChange,
    showDistribusionBranding,
    passengers
  }) => {
    const [fareClassCode, setFareClassCode] = useState("");
    const [deckLevel, setDeckLevel] = useState(0);
    const { currency: currency2, carrierLogo, showFareFeatures, showPrice } = useSettings();
    const {
      filterLayoutByFareClass: filterLayoutByFareClass2,
      getDiscountCategories: getDiscountCategories2,
      getPriceCategories: getPriceCategories2,
      getUniqueFares: getUniqueFares2,
      getUniqueLevel: getUniqueLevel2,
      isLimitedSeatsTaken: isLimitedSeatsTaken2
    } = useSeatSelectionUtils();
    const [legendOpened, setLegendOpened] = useState(false);
    const selection = useItemsSelection(initialSelection);
    const [direction, setDirection] = useReactiveState(() => {
      if (currentSegment?.direction) return currentSegment.direction;
      if (connections.outbound) return "outbound";
      return "inbound";
    }, [currentSegment?.direction, connections]);
    const connection = connections[direction];
    const indexedLayout = useMemo(() => {
      const filteredByFare = fareFilter ? filterLayoutByFareClass2(layout[direction], fareFilter) : layout[direction];
      return filteredByFare.map((data) => ({
        ...data,
        segment: { ...data.segment, index: data.segment.index }
      }));
    }, [fareFilter, filterLayoutByFareClass2, layout, direction]);
    const segmentList = useLinkedListWithIndex(
      indexedLayout,
      getSegmentIndex$1,
      currentSegment && indexedLayout.find((layout2) => layout2.segment.id === currentSegment.segment.id)
    );
    const schemeSegment = segmentList.current.item;
    const selectedSegmentSeats = useMemo(
      () => selection.items[direction][schemeSegment.segment.index] ?? [],
      [direction, schemeSegment.segment.index, selection.items]
    );
    const isFirstPart = direction === "outbound" && segmentList.current.position === 0;
    const outboundSeatsCount = (isFirstPart ? null : Object.values(selection.items.outbound)[0]?.length) ?? _outboundSeatsCount ?? 0;
    const isMobile = useIsMobile();
    const { t } = useTranslation();
    const { cars, segment } = schemeSegment;
    const seats = useMemo(() => cars?.flatMap((car) => car.seats) ?? [], [cars]);
    useEffect(() => {
      const index = schemeSegment.segment.index;
      const existed = !!connection?.segments[index]?.fares.find(({ fareClass }) => fareClass.code === initialFare);
      const fareClassCode2 = existed ? initialFare : getUniqueFares2(schemeSegment)[0];
      const deckLevel2 = getInitialLevel(schemeSegment, fareClassCode2);
      setFareClassCode(fareClassCode2);
      setDeckLevel(deckLevel2);
    }, [initialFare, opened, schemeSegment, connection, getUniqueFares2]);
    useEffect(() => {
      if (fareClassCode) {
        setDeckLevel(getInitialLevel(schemeSegment, fareClassCode));
      }
    }, [fareClassCode, opened, schemeSegment]);
    const deckLevels = useMemo(() => getUniqueLevel2(schemeSegment), [getUniqueLevel2, schemeSegment]);
    const filteredSeats = useMemo(() => {
      const levels = cars?.flatMap((item) => item.seats.filter((el) => el.coordinates.z === deckLevel));
      return fareClassCode ? levels?.filter((item) => item.fareClass === fareClassCode || !item.fareClass || !isSeat(item)) : levels;
    }, [cars, deckLevel, fareClassCode]);
    const handleSwitchDeck = useCallback(
      (level) => {
        const seats2 = cars?.flatMap(({ seats: seats3 }) => seats3.filter((el) => el.coordinates.z === level));
        const fareClass = seats2?.find(({ fareClass: fareClass2 }) => fareClass2)?.fareClass;
        setDeckLevel(level);
        if (fareClass) setFareClassCode(fareClass);
      },
      [cars]
    );
    const amenities = useMemo(() => {
      if (isMobile) return null;
      if (!showFareFeatures) return null;
      const fareFeature = getFareByCode(fareClassCode, connection);
      return fareFeature?.fareClass.fareFeatures.map((item) => /* @__PURE__ */ jsx(Amenity, { fareFeature: item, tooltipPosition: "bottom" }, item.id));
    }, [connection, fareClassCode, isMobile, showFareFeatures]);
    const key = camelCase(carrierLogo.source);
    const carrierCode = useMemo(
      () => connection.segments.find((item) => item[key])?.[key]?.code,
      [connection.segments, key]
    );
    const carrierLogoUrl = useMarketingCarrierLogo(carrierCode);
    const changeFareClass = (fareClassCode2) => {
      setFareClassCode(fareClassCode2);
      selection.clear();
      if (!connection?.offerBundle) {
        segmentList.reset();
        const firstDirection = connections.outbound ? "outbound" : "inbound";
        setDirection(firstDirection);
        if (onSegmentChange) {
          const firstSegment = layout[firstDirection].sort((a, b) => a.segment.index - b.segment.index)[0].segment;
          const connection2 = connections[firstDirection];
          assertNotNull(connection2, "Connection for direction is not set");
          onSegmentChange(
            firstDirection,
            connection2.segments.find((segment2) => segment2.id === firstSegment.id),
            selection.items
          );
        }
      }
    };
    const header = /* @__PURE__ */ jsxs(Fragment, { children: [
      carrierLogoUrl && /* @__PURE__ */ jsx("div", { className: "mt-2", children: /* @__PURE__ */ jsx(Logo, { showDistribusionBranding, url: carrierLogoUrl, clickable: false }) }),
      /* @__PURE__ */ jsx(
        SegmentLabel,
        {
          segment,
          connection,
          onNavigateBack: () => {
            const prev = segmentList.current?.prev;
            if (prev) {
              const connection2 = connections[direction];
              assertNotNull(connection2, "Connection for direction is not set");
              onSegmentChange?.(
                direction,
                connection2.segments.find((segment2) => segment2.id === prev.item.segment.id),
                selection.items
              );
              segmentList.move(-1);
            }
          },
          segmentsCount: connection?.segments.length,
          currentIndex: schemeSegment.segment.index
        }
      )
    ] });
    const discounts = useDiscounts({ enabled: !!discountDropdown });
    const priceCategories = getPriceCategories2(seats);
    const discountCategories = useMemo(() => {
      if (!discountDropdown) return [];
      return getDiscountCategories2(cars);
    }, [cars, discountDropdown, getDiscountCategories2]);
    const title = /* @__PURE__ */ jsxs("div", { className: "row items-center", children: [
      /* @__PURE__ */ jsx("span", { children: t("seats.title") }),
      isMobile && /* @__PURE__ */ jsx(Icon, { name: "info", size: "medium", className: "ml-2 mr-1", onClick: () => setLegendOpened(true) })
    ] });
    const firstPassengerCard = passengers?.[0]?.cards?.[0]?.name ?? null;
    const passengerDiscountEnabled = discountCategories.length > 0 && !!discountDropdown;
    const [passengerCard, setPassengerCard] = useState(firstPassengerCard);
    const isFinalStep = !segmentList.current.next?.item && (!connections.inbound || !layout.inbound.length || direction === "inbound");
    const nextStep = () => {
      const next = segmentList.current.next?.item;
      if (next) {
        segmentList.move(1);
        const connection2 = connections[direction];
        assertNotNull(connection2, "Connection for direction is not set");
        onSegmentChange?.(
          direction,
          connection2.segments.find((segment2) => segment2.id === next.segment.id),
          selection.items
        );
      } else {
        setDirection("inbound");
        if (onSegmentChange) {
          const firstSegment = layout.inbound.sort((a, b) => a.segment.index - b.segment.index)[0].segment;
          assertNotNull(connections.inbound, "inbound connection is not set");
          onSegmentChange(
            "inbound",
            connections.inbound.segments.find((segment2) => segment2.id === firstSegment.id),
            selection.items
          );
        }
      }
    };
    const submit = () => {
      if (!isFinalStep) return nextStep();
      const getPassengerDiscount = () => {
        if (!passengerDiscountEnabled) return void 0;
        if (!passengerCard) return null;
        return find(discounts.data ?? [], { name: passengerCard });
      };
      onSubmit({ seats: selection.items, passengerCard: getPassengerDiscount() });
    };
    const [altDiscountOpened, setAltDiscountOpened] = useState(false);
    useEffect(() => {
      if (opened) {
        const isOpened = firstPassengerCard != null && isLimitedSeatsTaken2(seats, firstPassengerCard);
        setAltDiscountOpened(isOpened);
      }
    }, [firstPassengerCard, opened, isLimitedSeatsTaken2, seats]);
    const startX = useMemo(() => Math.min(...seats.map(({ coordinates }) => coordinates.x)), [seats]);
    const deckSize = useMemo(
      () => ({
        length: Math.max(Math.max(...seats.map(({ coordinates }) => coordinates.x)) + (isMobile ? 3 : 2) - startX, 12),
        width: 5,
        height: 1
      }),
      [isMobile, seats, startX]
    );
    const showDiscountDropdown = discounts.data && discountDropdown;
    const sumPrice2 = useMemo(() => {
      if (selectedSegmentSeats.some((seat) => !!seat.limitations?.length)) return null;
      const fractional = sumBy(selectedSegmentSeats, ({ price, fareClass }) => {
        const segmentFares = connection?.segments[schemeSegment.segment.index]?.fares;
        const fare = isFullPrice ? segmentFares?.find((el) => el.fareClass.code === fareClass) : null;
        const farePrice = fare?.price?.fractional ?? 0;
        if (requiredSeats != null) return Number(price) + farePrice / requiredSeats;
        return Number(price) + farePrice;
      });
      return showPrice ? { fractional, currency: currency2 } : null;
    }, [connection, currency2, isFullPrice, requiredSeats, schemeSegment.segment.index, selectedSegmentSeats, showPrice]);
    return /* @__PURE__ */ jsxs(
      Modal,
      {
        opened,
        onClose,
        closeAfterTransition: true,
        title,
        header,
        fullScreen: isMobile,
        className: bem("seat-selection", "modal"),
        footer: /* @__PURE__ */ jsx(
          Footer,
          {
            requiredSeats,
            reservedSeatsCount,
            passengerCount: selectedSegmentSeats.length,
            outboundSeatsCount,
            warnMaxSeats,
            onClick: submit,
            price: sumPrice2
          }
        ),
        children: [
          /* @__PURE__ */ jsxs(Fragment, { children: [
            /* @__PURE__ */ jsxs("div", { className: "seat-selection__tabs column", children: [
              showDiscountDropdown && /* @__PURE__ */ jsx(
                DiscountsDropdown,
                {
                  discountCategories,
                  passengerCard,
                  setPassengerCard,
                  hasSelectedSeats: selectedSegmentSeats.length > 0,
                  discounts: discounts.data
                }
              ),
              /* @__PURE__ */ jsxs("div", { className: "row-lg space-between", children: [
                /* @__PURE__ */ jsx(
                  SeatsFareClasses,
                  {
                    connection,
                    value: fareClassCode,
                    onChange: changeFareClass,
                    segmentLayout: schemeSegment,
                    showSegmentPrice
                  }
                ),
                deckLevels.length > 1 && /* @__PURE__ */ jsx(DeckLevelSelector, { level: deckLevel, levels: deckLevels, onChange: handleSwitchDeck })
              ] })
            ] }),
            /* @__PURE__ */ jsx(
              Deck,
              {
                startX,
                deckSize,
                seats: filteredSeats,
                priceCategories,
                discountCategories,
                onClick: (seat) => selection.toggle(seat, direction, schemeSegment.segment.index),
                selectedSeats: selectedSegmentSeats,
                amenities,
                passengerCard,
                legendOpened,
                onLegendClose: () => setLegendOpened(false)
              }
            )
          ] }),
          /* @__PURE__ */ jsx(
            AlternativeDiscountModal,
            {
              opened: altDiscountOpened,
              selectedDiscount: passengerCard,
              setSelectedDiscount: setPassengerCard,
              onClose: () => setAltDiscountOpened(false),
              onCloseTrip: onClose,
              discounts: discounts.data
            }
          )
        ]
      }
    );
  }
);
const TrainCarInfo = ({ connection, fareClass, label, seats }) => {
  const { t } = useTranslation();
  const { showFareFeatures } = useSettings();
  const freeSeats = useMemo(() => seats.filter((item) => item.vacant).length ?? 0, [seats]);
  const fareFeatures = useMemo(
    () => getUniqueFareFeatures([connection], { fareClassCode: fareClass }),
    [fareClass, connection]
  );
  return /* @__PURE__ */ jsx("div", { className: bem("train-seats-car"), children: /* @__PURE__ */ jsxs("div", { className: "column gap-2", children: [
    /* @__PURE__ */ jsx("div", { className: "cell", children: /* @__PURE__ */ jsxs("div", { className: "column items-center row-lg space-between-lg", children: [
      /* @__PURE__ */ jsx("h4", { className: "bold m-0 bolder", children: t("seats.train.carNumber", { index: label }) }),
      /* @__PURE__ */ jsx("div", { className: bem("train-seats-car", "seats-left"), children: t("seats.seatsLeft", { count: freeSeats }) })
    ] }) }),
    showFareFeatures && /* @__PURE__ */ jsx("div", { className: "cell", children: /* @__PURE__ */ jsx("div", { className: "row wrap gap-2 center start-lg", children: fareFeatures.map((feature) => /* @__PURE__ */ jsx(Amenity, { fareFeature: feature }, feature.id)) }) })
  ] }) });
};
const scrollThreshold = 7;
const CarSelection = (props) => {
  const { cars, value, onChange } = props;
  const isMobile = useIsMobile();
  const sorted = useMemo(() => cars.sort((a, b) => a.index - b.index), [cars]);
  const [cursor, setCursor] = useState(0);
  const cursorMax = cars.length - scrollThreshold;
  const showScroll = cars.length > scrollThreshold && !isMobile;
  const visibleCars = showScroll ? sorted.slice(cursor, cursor + scrollThreshold) : cars;
  useEffect(() => {
    const carOrder = sorted.findIndex((car) => car.index === value);
    if (showScroll && (carOrder < cursor || carOrder >= cursor + scrollThreshold)) {
      setCursor(clamp(carOrder - 4, 0, cursorMax));
    }
  }, [value]);
  const selectCar = (index) => {
    onChange(index);
    if (showScroll) {
      if (index >= cursor + scrollThreshold - 1) {
        setCursor((cursor2) => clamp(cursor2 + 1, 0, cursorMax));
      }
      if (index < cursor + 1) {
        setCursor((cursor2) => clamp(cursor2 - 1, 0, cursorMax));
      }
    }
  };
  return /* @__PURE__ */ jsxs("div", { className: "car-selector", children: [
    /* @__PURE__ */ jsx(ButtonGroup, { flat: isMobile, children: visibleCars.map(({ index, label }) => /* @__PURE__ */ jsx(
      Button,
      {
        onClick: () => selectCar(index),
        variant: value === index ? "filled" : "outline",
        color: value === index ? "secondary" : "grey",
        className: bem("car-selector", "car-button"),
        children: label
      },
      label
    )) }),
    showScroll && /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(
        Button,
        {
          variant: "outline",
          color: "grey",
          round: true,
          disabled: cursor === 0,
          onClick: () => setCursor((cursor2) => cursor2 - 1),
          className: bem("car-selector", "scroll-button", { left: true }),
          children: /* @__PURE__ */ jsx(Icon, { name: "chevron-left", size: "medium" })
        }
      ),
      /* @__PURE__ */ jsx(
        Button,
        {
          variant: "outline",
          round: true,
          disabled: cursor === cursorMax,
          onClick: () => setCursor((cursor2) => cursor2 + 1),
          color: "grey",
          className: bem("car-selector", "scroll-button", { right: true }),
          children: /* @__PURE__ */ jsx(Icon, { name: "chevron-right", size: "medium" })
        }
      )
    ] })
  ] });
};
const TrainSeatSelectionContext = createContext(null);
const useTrainSeatSelection = () => {
  const context = useContext(TrainSeatSelectionContext);
  if (!context) throw new Error("No provider for TrainSeatSelectionContext has been found");
  return context;
};
const vector = {
  toKey: (vector2) => `${vector2.x},${vector2.y}`,
  step: {
    up: (vector2) => ({ x: vector2.x, y: vector2.y - 1 }),
    right: (vector2) => ({ x: vector2.x + 1, y: vector2.y }),
    down: (vector2) => ({ x: vector2.x, y: vector2.y + 1 }),
    left: (vector2) => ({ x: vector2.x - 1, y: vector2.y })
  }
};
const sides = ["up", "right", "down", "left"];
const tableKey = (table) => vector.toKey(table.coordinates);
const getNeighbors = (table, cells) => sides.map((side) => {
  const key = vector.toKey(vector.step[side](table.coordinates));
  return cells.has(key) ? side : null;
}).filter(Boolean);
const buildTablesSet = (seats) => {
  const tables = /* @__PURE__ */ new Set();
  seats.forEach((seat) => {
    if (seat.code === "TABLE") tables.add(tableKey(seat));
  });
  return tables;
};
const TrainDeck = (props) => {
  const { seats, onClick, selectedSeats, deckSize, carIndex } = props;
  const seatSelectionUtils = useSeatSelectionUtils();
  const tables = useMemo(() => buildTablesSet(seats), [seats]);
  const tableProps = (table) => ({ neighbors: getNeighbors(table, tables) });
  const priceCategories = seatSelectionUtils.getPriceCategories(seats);
  return /* @__PURE__ */ jsx(DeckFrame, { orientation: "up", isTrainHead: carIndex === 0, size: deckSize, dense: true, children: seats.map((seat) => /* @__PURE__ */ jsx(
    SeatComponent,
    {
      position: seat.coordinates,
      code: seat.code,
      label: seat.label,
      disabled: !seat.vacant,
      price: seat.price,
      orientation: seat.orientation,
      priceCategory: priceCategories[seat.price ?? 0],
      onSelect: () => onClick({ ...seat, carIndex }),
      selected: selectedSeats.some((item) => item.code === seat.code),
      size: seat.size,
      ...{ flipped: seat.flipped },
      ...seat.code === "TABLE" ? tableProps(seat) : void 0
    },
    seat.id
  )) });
};
const SelectedSeat = (props) => {
  const { t } = useTranslation();
  const { seat, paxIndex, fareClass, schemeSegment } = props;
  const { seatAncillaryAsSelection: isAncillary, currency: currency2 } = useSettings();
  const carLabel = schemeSegment.cars.find((car) => car.index === seat.carIndex)?.label;
  return /* @__PURE__ */ jsxs("div", { className: "train__selected-seat row cell mb-1 gap-1 wrap", children: [
    /* @__PURE__ */ jsx("span", { className: "cell-12 mb-1 mb-lg-0 cell-lg-4 bolder bold-lg", children: t("seats.train.passengerLabel", { index: paxIndex + 1 }) }),
    /* @__PURE__ */ jsx("span", { className: "cell-5 grow cell-lg-3", children: fareClass }),
    /* @__PURE__ */ jsxs("span", { className: "row cell", children: [
      /* @__PURE__ */ jsx(Icon, { className: "mr-1", name: "carriage", size: "large" }),
      /* @__PURE__ */ jsx("span", { children: carLabel ?? 1 })
    ] }),
    /* @__PURE__ */ jsxs("span", { className: "row cell", children: [
      /* @__PURE__ */ jsx(Icon, { className: "mr-1", name: "place", size: "large" }),
      /* @__PURE__ */ jsx("span", { children: seat.label })
    ] }),
    !isAncillary && /* @__PURE__ */ jsx("span", { className: "row bold cell no-grow", children: /* @__PURE__ */ jsx(Money, { fractional: seat.price ?? 0, currency: currency2 }) })
  ] });
};
const SelectedSeatsBreakdown$1 = (props) => {
  const { max, seats, fareClass, schemeSegment } = props;
  const [listOpened, setListOpened] = useState(false);
  const { t } = useTranslation();
  const isMobile = useIsMobile();
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs("div", { className: "row items-center gap-1", onClick: () => setListOpened(true), children: [
      /* @__PURE__ */ jsx("div", { className: "cell basis-auto", children: /* @__PURE__ */ jsx(
        Trans,
        {
          components: [/* @__PURE__ */ jsx("span", { className: "bolder" }, "1")],
          i18nKey: "seats.selected_short",
          values: { count: seats.length, max }
        }
      ) }),
      /* @__PURE__ */ jsx(Icon, { "aria-hidden": "true", name: "chevron-down", size: "medium" })
    ] }),
    /* @__PURE__ */ jsx(Modal, { onClose: () => setListOpened(false), title: t("seats.selectedTitle"), opened: listOpened, children: /* @__PURE__ */ jsx("div", { className: "px-4 pt-3 pb-5", children: seats.length > 0 && /* @__PURE__ */ jsx("div", { className: "column", children: seats.map((seat, index) => /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(
        SelectedSeat,
        {
          schemeSegment,
          fareClass,
          paxIndex: index,
          seat
        },
        seat.label
      ),
      isMobile && index !== seats.length - 1 && /* @__PURE__ */ jsx(Divider, { className: "my-1" })
    ] })) }) }) })
  ] });
};
const TrainSubmitSection = (props) => {
  const {
    continueDisabled,
    requiredSeatsCount,
    selectedSeats,
    fareClassName,
    onSubmit,
    farePrice,
    seatsPrice,
    allowSkip,
    onClear,
    schemeSegment
  } = props;
  const { t } = useTranslation();
  const isMobile = useIsMobile();
  const { seatAncillaryAsSelection: isAncillary, currency: currency2 } = useSettings();
  const { createCurrency } = useCurrencyUtils();
  const totalPrice = (farePrice2) => ({
    fractional: farePrice2.fractional + seatsPrice,
    currency: farePrice2.currency
  });
  const formatedSeatsPrice = !!seatsPrice && /* @__PURE__ */ jsx("div", { className: "body-12 mt-1 color-grey-70", children: t("seats.price", { price: createCurrency(seatsPrice, currency2).format() }) });
  return /* @__PURE__ */ jsxs("div", { className: "column gap-3 px-sm-4 py-3", children: [
    !isAncillary && /* @__PURE__ */ jsxs("div", { className: "cell", children: [
      /* @__PURE__ */ jsxs("div", { className: "row gap-3 space-between-sm", children: [
        /* @__PURE__ */ jsx("div", { className: "cell no-grow basis-auto-sm cell-lg-6", children: isMobile && /* @__PURE__ */ jsx(
          SelectedSeatsBreakdown$1,
          {
            schemeSegment,
            fareClass: fareClassName,
            seats: selectedSeats,
            max: requiredSeatsCount
          }
        ) }),
        /* @__PURE__ */ jsxs("div", { className: "cell no-grow cell-lg-6", children: [
          /* @__PURE__ */ jsxs("div", { className: "row space-between body-20", children: [
            !isMobile && /* @__PURE__ */ jsx("div", { children: t("seats.total") }),
            farePrice && /* @__PURE__ */ jsx("div", { className: "bolder", children: /* @__PURE__ */ jsx(Money, { ...totalPrice(farePrice) }) })
          ] }),
          !isMobile && formatedSeatsPrice
        ] })
      ] }),
      isMobile && formatedSeatsPrice
    ] }),
    /* @__PURE__ */ jsx("div", { className: "cell", children: /* @__PURE__ */ jsxs("div", { className: "row end gap-3", children: [
      allowSkip && selectedSeats.length === 0 && /* @__PURE__ */ jsx("div", { className: "cell-5 no-shrink cell-lg-6", children: /* @__PURE__ */ jsx(Button, { variant: "outline", color: "secondary", onClick: () => onSubmit(), children: t("seats.skip") }) }),
      !!onClear && selectedSeats.length > 0 && /* @__PURE__ */ jsx("div", { className: "cell-5 no-shrink cell-lg-6", children: /* @__PURE__ */ jsx(Button, { variant: "outline", color: "secondary", onClick: onClear, children: t("seats.clear") }) }),
      /* @__PURE__ */ jsx("div", { className: "cell cell-lg-6", children: /* @__PURE__ */ jsx(Button, { disabled: continueDisabled, variant: "filled", color: "secondary", onClick: () => onSubmit(), children: t("seats.continue") }) })
    ] }) })
  ] });
};
const SelectedSeatsBreakdown = (props) => {
  const { max, seats, fareClass, schemeSegment } = props;
  return /* @__PURE__ */ jsxs("div", { className: bem("train-seats-selected"), children: [
    /* @__PURE__ */ jsx("h4", { className: "m-0 mb-3", children: /* @__PURE__ */ jsx(
      Trans,
      {
        components: [
          /* @__PURE__ */ jsx("span", { className: "bolder" }, "1"),
          /* @__PURE__ */ jsx("span", { className: "bolder ml-3" }, "2"),
          /* @__PURE__ */ jsx("span", { className: "color-grey-70" }, "3")
        ],
        i18nKey: "seats.selected",
        values: { count: seats.length, max }
      }
    ) }),
    seats.length > 0 && /* @__PURE__ */ jsx("div", { className: "column gap-1", children: seats.map((seat, index) => /* @__PURE__ */ jsx("div", { className: "cell", children: /* @__PURE__ */ jsx(SelectedSeat, { schemeSegment, fareClass, paxIndex: index, seat }) }, seat.code)) })
  ] });
};
const EMPTY_SEATS = [];
const TrainSeatsDesktop = () => {
  const {
    connection,
    fareClass,
    segmentsCount,
    currentSegment,
    fareOptions,
    setFareClass,
    carIndex,
    setCarIndex,
    disableFare,
    reservedSeatsCount,
    onSelect,
    selectedSeats,
    onSubmit,
    onNavigateBack,
    continueDisabled,
    layout,
    schemeSegment,
    connectionSegment,
    allowSkip,
    onClear,
    vacancyPrice,
    deckLevel,
    deckLevels,
    onDeckLevelChange
  } = useTrainSeatSelection();
  const { t } = useTranslation();
  const seatSelectionUtils = useSeatSelectionUtils();
  const fare = connection.fares.find((fare2) => fare2.fareClass.code === fareClass);
  const farePrice = vacancyPrice ?? fare?.price;
  const seatsPrice = seatSelectionUtils.sumPrice(selectedSeats);
  const seats = layout?.seats || EMPTY_SEATS;
  const deckSeats = useMemo(() => seats.filter((seat) => seat.coordinates.z === deckLevel) ?? [], [deckLevel, seats]);
  const handleChange = useCallback(
    (fareClass2) => {
      setFareClass?.(fareClass2);
      setCarIndex(0);
    },
    [setCarIndex, setFareClass]
  );
  return /* @__PURE__ */ jsx("div", { className: "train-seats", children: /* @__PURE__ */ jsxs("div", { className: "row gap-10", children: [
    /* @__PURE__ */ jsx("div", { className: "cell basis-auto no-grow", children: /* @__PURE__ */ jsxs("div", { className: cn("py-4 pr-4", bem("train-seats", "deck-section")), children: [
      /* @__PURE__ */ jsx(
        TrainCarInfo,
        {
          seats,
          connection,
          label: schemeSegment.cars.find((car) => car.index === carIndex).label,
          fareClass
        }
      ),
      /* @__PURE__ */ jsx(
        TrainDeck,
        {
          deckSize: layout?.size,
          seats: deckSeats,
          carIndex,
          onClick: onSelect,
          selectedSeats
        }
      )
    ] }) }),
    /* @__PURE__ */ jsx("div", { className: "cell pb-sm-5", children: /* @__PURE__ */ jsxs("div", { className: "column pt-4 h-100", children: [
      segmentsCount > 1 && /* @__PURE__ */ jsx("div", { className: "cell no-grow pb-3", children: /* @__PURE__ */ jsx(
        SegmentLabel,
        {
          segment: connectionSegment,
          segmentsCount,
          connection,
          currentIndex: currentSegment,
          onNavigateBack
        }
      ) }),
      /* @__PURE__ */ jsx("div", { className: "cell no-grow pb-3", children: /* @__PURE__ */ jsx(
        Dropdown,
        {
          label: t("seats.fareClass"),
          disabled: disableFare || !setFareClass,
          items: fareOptions,
          value: fareClass,
          onChange: handleChange
        }
      ) }),
      /* @__PURE__ */ jsx("div", { className: "cell no-grow pb-4", children: /* @__PURE__ */ jsx(CarSelection, { cars: schemeSegment.cars, onChange: setCarIndex, value: carIndex }) }),
      deckLevels.length > 1 && /* @__PURE__ */ jsx("div", { className: "cell no-grow pb-4", children: /* @__PURE__ */ jsx(DeckLevelSelector, { level: deckLevel, levels: deckLevels, onChange: onDeckLevelChange }) }),
      /* @__PURE__ */ jsx("div", { className: "cell", children: /* @__PURE__ */ jsx(
        SelectedSeatsBreakdown,
        {
          schemeSegment,
          fareClass: fare?.fareClass.name,
          seats: selectedSeats,
          max: reservedSeatsCount
        }
      ) }),
      /* @__PURE__ */ jsx("div", { className: "cell no-grow", children: /* @__PURE__ */ jsx(
        TrainSubmitSection,
        {
          schemeSegment,
          allowSkip,
          onClear,
          selectedSeats,
          continueDisabled,
          requiredSeatsCount: reservedSeatsCount,
          fareClassName: fare?.fareClass.name,
          farePrice,
          seatsPrice,
          onSubmit
        }
      ) })
    ] }) })
  ] }) });
};
const Header = ({ seats }) => {
  const { t } = useTranslation();
  const isMobile = useIsMobile();
  const seatSelectionUtils = useSeatSelectionUtils();
  const [opened, setOpened] = useState(false);
  const hasPaidSeats = seats.some((seat) => !!seat.price);
  const priceCategories = seatSelectionUtils.getPriceCategories(seats);
  const legend = /* @__PURE__ */ jsx(Legend, { hasPaidSeats, priceCategories });
  return /* @__PURE__ */ jsxs("div", { className: "row items-center", children: [
    /* @__PURE__ */ jsx("h3", { className: "mb-0 mr-2", children: t("seats.title") }),
    /* @__PURE__ */ jsx(Tooltip, { content: isMobile ? null : legend, action: "click", children: /* @__PURE__ */ jsx(Icon, { name: "info", size: "medium", onClick: () => isMobile && setOpened(true) }) }),
    /* @__PURE__ */ jsx(
      Modal,
      {
        title: /* @__PURE__ */ jsx("h3", { className: "mb-0", children: t("seats.seatMap") }),
        className: "train-seats-modal__legend",
        opened,
        onClose: () => setOpened(false),
        children: legend
      }
    )
  ] });
};
const TrainSeatsMobile = () => {
  const {
    connection,
    fareClass,
    segmentsCount,
    currentSegment,
    fareOptions,
    setFareClass,
    carIndex,
    setCarIndex,
    disableFare,
    onSelect,
    selectedSeats,
    onNavigateBack,
    layout,
    schemeSegment,
    connectionSegment,
    deckLevel,
    deckLevels,
    onDeckLevelChange
  } = useTrainSeatSelection();
  const { t } = useTranslation();
  const seats = useMemo(() => layout?.seats || [], [layout?.seats]);
  const deckSeats = useMemo(() => seats.filter((seat) => seat.coordinates.z === deckLevel) ?? [], [deckLevel, seats]);
  const handleChange = useCallback(
    (fareClass2) => {
      setFareClass?.(fareClass2);
      setCarIndex(0);
    },
    [setCarIndex, setFareClass]
  );
  return /* @__PURE__ */ jsxs("div", { className: "column train-seats", children: [
    /* @__PURE__ */ jsx("div", { className: "cell no-grow", children: /* @__PURE__ */ jsxs("div", { className: "column", children: [
      segmentsCount > 1 && /* @__PURE__ */ jsx("div", { className: "cell no-grow px-4 pb-3", children: /* @__PURE__ */ jsx(
        SegmentLabel,
        {
          segment: connectionSegment,
          segmentsCount,
          connection,
          currentIndex: currentSegment,
          onNavigateBack
        }
      ) }),
      /* @__PURE__ */ jsx("div", { className: "cell no-grow px-4 pb-4", children: /* @__PURE__ */ jsx(
        Dropdown,
        {
          label: t("seats.fareClass"),
          disabled: disableFare || !setFareClass,
          items: fareOptions,
          value: fareClass,
          onChange: handleChange
        }
      ) }),
      /* @__PURE__ */ jsx("div", { className: "cell no-grow", children: /* @__PURE__ */ jsx(CarSelection, { cars: schemeSegment.cars, onChange: setCarIndex, value: carIndex }) }),
      deckLevels.length > 1 && /* @__PURE__ */ jsx("div", { className: "cell no-grow pb-4", children: /* @__PURE__ */ jsx(DeckLevelSelector, { level: deckLevel, levels: deckLevels, onChange: onDeckLevelChange }) })
    ] }) }),
    /* @__PURE__ */ jsx("div", { className: cn("cell", bem("train-seats", "deck-section")), children: /* @__PURE__ */ jsx("div", { className: bem("train-seats", "deck-section-scrollable"), children: /* @__PURE__ */ jsxs("div", { className: "px-3 py-4 column items-center", children: [
      /* @__PURE__ */ jsx(
        TrainCarInfo,
        {
          seats,
          connection,
          label: schemeSegment.cars.find((car) => car.index === carIndex).label,
          fareClass
        }
      ),
      /* @__PURE__ */ jsx(
        TrainDeck,
        {
          deckSize: layout?.size,
          seats: deckSeats,
          carIndex,
          onClick: onSelect,
          selectedSeats
        }
      )
    ] }) }) })
  ] });
};
const getInitialCarIndex = (segment, seats) => {
  if (seats?.[0]?.carIndex) return seats[0].carIndex;
  return segment ? Math.min(...segment.cars.map(({ index }) => index)) : 0;
};
const getSegmentIndex = (segment) => segment.index;
const SeatSelectionTrain = withUISettingsProvider((props) => {
  const {
    opened,
    connection,
    selectedFares,
    onClose,
    scheme,
    layoutQuery,
    reservedSeatsCount,
    onSubmit,
    onClear,
    onFareClassChange,
    currentSegment,
    onSegmentChange,
    disableFare,
    allowSkip,
    initialSelection,
    vacancyPrice
  } = props;
  const seatSelectionUtils = useSeatSelectionUtils();
  const isMobile = useIsMobile();
  const selection = useItemsSelection(initialSelection);
  const [tripDirection, setTripDirection] = useReactiveState(
    () => currentSegment?.direction || "outbound",
    [currentSegment]
  );
  const selectedTripSeats = selection.items[tripDirection];
  const selectedSchemeList = scheme[tripDirection];
  const segmentList = useLinkedListWithIndex(
    selectedSchemeList,
    getSegmentIndex,
    currentSegment?.segment
  );
  const schemeSegment = segmentList.current.item;
  const currentSegmentIndex = schemeSegment?.index;
  const selectedSegmentSeats = useMemo(
    () => selectedTripSeats[currentSegmentIndex] ?? [],
    [currentSegmentIndex, selectedTripSeats]
  );
  const tripDirectionSelectedFare = selectedFares[tripDirection];
  const fareOptions = useMemo(
    () => getUniqueFareClasses([connection], {}).map(({ code, name }) => ({ value: code, label: name })).sort((a, b) => a.value.localeCompare(b.value, void 0, { numeric: true })),
    [connection]
  );
  const connectionSegment = useMemo(() => {
    return connection.segments.find(({ index }) => index === currentSegmentIndex);
  }, [currentSegmentIndex, connection]);
  const [selectedCar, setSelectedCar] = useReactiveState(
    () => getInitialCarIndex(schemeSegment, initialSelection?.[tripDirection]?.[schemeSegment.index]),
    [initialSelection, schemeSegment, tripDirection]
  );
  const segmentsCount = connection.segments.length;
  const fareClassName = fareOptions.find(({ value }) => value === tripDirectionSelectedFare)?.label;
  const farePrice = vacancyPrice ?? connection.fares.find((fare2) => fare2.fareClass.code === tripDirectionSelectedFare)?.price;
  const seatsPrice = seatSelectionUtils.sumPrice(selectedSegmentSeats);
  const handleSubmit = () => {
    const nextSegment = segmentList.current.next?.item;
    if (nextSegment) {
      segmentList.move(1);
      onSegmentChange?.(tripDirection, nextSegment);
    } else if (tripDirection === "outbound" && scheme["inbound"].length) {
      onSegmentChange?.("inbound", sortBy(scheme["inbound"], getSegmentIndex)[0]);
      setTripDirection("inbound");
    } else {
      onSubmit({ seats: selection.items });
    }
  };
  const layoutQueryResult = useQuery$1(
    layoutQuery(schemeSegment?.cars[selectedCar].layout, tripDirection, currentSegmentIndex, selectedCar)
  );
  const deckLevels = useMemo(
    () => uniq(layoutQueryResult.data?.seats.map((seat) => seat.coordinates.z).sort((a, b) => a - b)),
    [layoutQueryResult.data?.seats]
  );
  const [deckLevel, setDeckLevel] = useReactiveState(() => deckLevels[0], [deckLevels]);
  const labeledSegmentedSeats = useMemo(() => {
    const hasUnlabeledSeats = selectedSegmentSeats.some((seat) => !seat.label);
    if (hasUnlabeledSeats) {
      return selectedSegmentSeats.map(
        (seat) => seat.label ? seat : { ...seat, label: layoutQueryResult.data?.seats.find(({ code }) => code === seat.code)?.label }
      );
    }
    return selectedSegmentSeats;
  }, [layoutQueryResult.data?.seats, selectedSegmentSeats]);
  const continueDisabled = reservedSeatsCount != null && labeledSegmentedSeats.length !== reservedSeatsCount;
  return /* @__PURE__ */ jsx(
    Modal,
    {
      title: /* @__PURE__ */ jsx(Header, { seats: layoutQueryResult.data?.seats ?? [] }),
      opened,
      onClose,
      closeAfterTransition: true,
      footer: isMobile && /* @__PURE__ */ jsx(
        TrainSubmitSection,
        {
          selectedSeats: labeledSegmentedSeats,
          continueDisabled,
          requiredSeatsCount: reservedSeatsCount,
          fareClassName,
          farePrice,
          seatsPrice,
          onSubmit: handleSubmit,
          onClear,
          allowSkip,
          schemeSegment
        }
      ),
      fullScreen: true,
      fullWidth: true,
      fullHeight: true,
      maxWidth: "lg",
      className: "train-seats-modal",
      children: scheme && /* @__PURE__ */ jsx(
        TrainSeatSelectionContext.Provider,
        {
          value: {
            fareClass: tripDirectionSelectedFare,
            segmentsCount,
            fareOptions,
            setFareClass: onFareClassChange && ((fareClass) => onFareClassChange(tripDirection, fareClass)),
            carIndex: selectedCar,
            setCarIndex: setSelectedCar,
            onSubmit: handleSubmit,
            onSelect: (seat) => selection.toggle(seat, tripDirection, currentSegmentIndex),
            selectedSeats: labeledSegmentedSeats,
            opened,
            connection,
            deckLevel,
            deckLevels,
            onDeckLevelChange: setDeckLevel,
            scheme,
            currentSegment: segmentList.current.item?.index ?? segmentList.current.position,
            continueDisabled,
            disableFare,
            reservedSeatsCount,
            onNavigateBack: () => {
              segmentList.move(-1);
              if (schemeSegment !== segmentList.current.item) {
                onSegmentChange?.(tripDirection, segmentList.current.item);
              }
            },
            schemeSegment,
            connectionSegment,
            layout: layoutQueryResult.data,
            allowSkip,
            onClear,
            vacancyPrice
          },
          children: isMobile ? /* @__PURE__ */ jsx(TrainSeatsMobile, {}) : /* @__PURE__ */ jsx(TrainSeatsDesktop, {})
        }
      )
    }
  );
});
export {
  SeatSelectionBus as SeatSelectionBusModal,
  SeatSelectionTrain as SeatSelectionTrainModal,
  SettingsContext
};
//# sourceMappingURL=owl-seats.js.map
